import { ContainerStatusEnum, DateFilter, ErrorResponse, HarvestTypes, InvoiceStatusEnum, OperationTypeEnum, ProductCategoryEnum, SupplierTypeEnum, TransactionType, UnitRequest, UomEnum } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Repository,getConnection,QueryRunner, In } from 'typeorm';
import { appSettings} from '../../../../config';
import { StockInEntity } from './stock-in.entity';
import { ReportTypeENum, StockInResDto, StockInResponseData, StockInData,ProductReq, MontlyMisModel, ColumnsInfoModel, MontlyMisInfoReq } from '@gtpl/shared-models/analytics-data';
import { StockInRequestDto } from './dto/stock-in.request.dto';
import { StockInObj } from './dto/stock-obj';
import { AbstractInfo, CommonResponse, ContainerWiseAbstract, ContainerWiseAbstractModel, ContainerWiseAbstractReq, ContainerWiseAbstractResponseModel, CountryWiseAbstract, DayWiseProducitonAnalysisModel, DayWiseProductionReq, DaywiseAnalysisResponseModel, DaywiseProductionModel, DaywiseProductionResponseModel, ExpectedStockInOutResponse, ExportsProductsInfo, ForkJobPurpose, G2ProductsInfo, JobIdRequest, JumbleProductsInfo, LotWiseInfoModel, LotWiseInfoResponseModel, MISProductDetailedReportModel, MISProductInfo, MISProductsInfo, MonthWiseShrimpReq, ProductAnalysisModel, ProductAnalysisReq, ProductAnalysisResponseModel, ProductAnalysisTotals, ProductSummaryReportReq, ProductionQuantity, StockSTatementReq, StockStatementGradesInfo, StockStatementModel, StockStatementProductInfo, StockStatementResponseModel, StockValuationModel, StockValuationProductInfo, StockValuationReportModel, StockValuationResponseModel, lotWisePoInfoModel, lotWiseQtyInfoModel, SPSAStockValuationReq } from '@gtpl/shared-models/warehouse-management'
import { PlantIdRequest } from '@gtpl/shared-models/warehouse-management';
import { AnalyticsUnitRequest } from './dto/analytics-unit.request';
import { BaleReq, CompanyCategoryEnum } from '@gtpl/shared-models/raw-material-procurement';
import {FgPriceListCategoryEnum} from '@gtpl/shared-models/masters'
import { ProductionCostAnalysisEntity } from './production-cost-analysis.entity';
import { UnitsOfWeightInput } from '@gtpl/shared-models/sale-management';
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { EmpLeavesResponse } from '@gtpl/shared-models/hrms';
import { CronInfo } from './cron-info.entity';
import { RMPurchaseAnalysisEntity } from './rm_purchase_analysis.entity';
import { Cron } from '@nestjs/schedule';
import { DaywiseOpeningStockEntity } from './daywise-opening-stock.entity';
import { DaywiseShrimpAnalysisEntity } from './daywise-shrimp-analysis.entity';
import { MontlyMisEntity } from './montly-mis.entity';
import { MontlyMisColumnsJson } from './montly-mis-columns';
import { ForkLiftJobService } from '@gtpl/shared-services/warehouse-management';
import { IdRequest } from '@gtpl/shared-models/gtpl';
import { LotCodeDropDown } from '@gtpl/shared-models/production-management';
import { FgStockStatus } from './dto/fg-stock-status.enum';
import { BaleAmtInfo } from './bale-amt-info.entity';

const dashboardStockInTable = appSettings.analytics_db + '.stock_in';
const dashboardStockOutTable = appSettings.analytics_db + '.stock_out';
let moment = require('moment');
moment().format();
@Injectable()
export class WarehouseService {
    constructor(
        @InjectRepository(StockInEntity) private stockInRepository: Repository<StockInEntity>,
        private forkLiftJobService : ForkLiftJobService,
        @InjectRepository(CronInfo)
        private cronInfoRepo : Repository<CronInfo>,
        @InjectRepository(BaleAmtInfo)
        private baleAmtInfoRepo : Repository<BaleAmtInfo>
    ){}

    async getStockInfo(dtoObj: StockInRequestDto): Promise <StockInResponseData>{
        try {  
            const manager = getManager();  
            let queryIn='';  
            let queryOut='';  
            let monthNo=0;           
            // const quarterInfo=3;
            if(!dtoObj.month){
                const dateData = new Date();
                monthNo = dateData.getMonth();
            }else{
                monthNo=dtoObj.month;
            }
           
            let yearNo=0;
            if(!dtoObj.year){
                const dateData = new Date();
                yearNo = dateData.getFullYear();
            }else{
                yearNo=dtoObj.year;
            }
            const names = []; 
            const namesData = [];

            let quarterName;
            const qunarterCount = {1 : 'quarter1',  2 : 'quarter1', 3 : 'quarter1', 4 : 'quarter2', 5 : 'quarter2', 6 : 'quarter2', 7 : 'quarter3', 8 : 'quarter3', 9 : 'quarter3', 10 : 'quarter4', 11 : 'quarter4', 12 : 'quarter4'};
            const monthData ={1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec'};
            let mapKey;
            let querySelect;
            let queryWhere;
            let queryGroup;
            let queryOutSelect;
            let queryOutWhere;
            let queryOutGroup;
            const monthInfo=monthNo-1;
            let allNames;
            // const kg=2.20462;
            // const gm=0.00220462;
            // const oz=0.0625;
           
            /** For Storing Names of the Series Data*/
            if(dtoObj.reportType == ReportTypeENum.DAYWISE){
                /** Assigning all dateData */               
                const date = new Date(yearNo, monthInfo, 1);   
                while (date.getMonth() === monthInfo) {
                    names.push(moment(new Date(date)).format('YYYY-MM-DD'));                    
                    date.setDate(date.getDate() + 1);
                }

                /**Day QueryFilter */
                querySelect = 'DATE(reporting_date) AS reportedDate';
                queryGroup = 'DATE(reporting_date)';
                queryWhere = 'MONTH(reporting_date)='+monthNo+'';

                queryOutSelect = 'DATE(created_at) AS reportedDate';
                queryOutGroup = 'DATE(created_at)';
                queryOutWhere = 'MONTH(created_at)='+monthNo+'';

                allNames = names;
            }else if(dtoObj.reportType == ReportTypeENum.WEEKWISE){
                let month;      
                if (monthNo < 10)
                month = "0" + monthNo;            
                const date = "01." + month + "." + yearNo;
                const first = moment(date, 'dd.MM.yyyy').startOf('month').week();
                const last = moment(date, 'dd.MM.yyyy').endOf('month').week();
                for (let i = first; i < last; i++) {
                    namesData.push(i);
                    names.push(i + " " + monthData[monthNo]);
                } 
                /** Month QueryFilter */
                querySelect = 'WEEK(reporting_date) AS reportedDate';
                queryGroup = 'WEEK(reporting_date)';
                queryWhere = 'MONTH(reporting_date)='+monthNo+'';

                queryOutSelect = 'WEEK(created_at) AS reportedDate';
                queryOutGroup = 'WEEK(created_at)';
                queryOutWhere = 'MONTH(created_at)='+monthNo+'';

                allNames = namesData;
            }else{
                const quarterNames = ['Jan - Mar', 'Apr - Jun', 'Jul - Sep', 'Oct - Dec'];
                const quarterData = ['quarter1', 'quarter2', 'quarter3', 'quarter4'];
                for (const quanrter of quarterNames) {
                    names.push(quanrter + " " + yearNo);                
                }
                /** Year QueryFilter */
                querySelect = 'MONTH(reporting_date) AS reportedDate';
                queryGroup = 'MONTH(reporting_date)';
                queryWhere = 'YEAR(reporting_date)='+yearNo+'';

                queryOutSelect = 'MONTH(created_at) AS reportedDate';
                queryOutGroup = 'MONTH(created_at)';
                queryOutWhere = 'YEAR(created_at)='+yearNo+'';


                allNames = quarterData;
            }           
           
            queryIn = `SELECT `+querySelect+`,ROUND(SUM(IF(stock_type='dummy',
            (IF(uom = 'OZ' , (reported_cases * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(reported_cases * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(reported_cases * no_of_pouches * pouches_per_row * 0.0022),(reported_cases * no_of_pouches * pouches_per_row))))),0)),2) AS dummy,      
            ROUND(SUM(IF(stock_type='SaleOrder',
            (IF(uom = 'OZ' , (reported_cases * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(reported_cases * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(reported_cases * no_of_pouches * pouches_per_row * 0.0022),(reported_cases * no_of_pouches * pouches_per_row))))),0)),2) AS saleorder,  
            ROUND(SUM(IF(stock_type='anticipated',
            (IF(uom = 'OZ' , (reported_cases * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(reported_cases * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(reported_cases * no_of_pouches * pouches_per_row * 0.0022),(reported_cases * no_of_pouches * pouches_per_row))))),0)),2) AS anticipated,
            ROUND(SUM(IF(stock_type='superDummy',
            (IF(uom = 'OZ' , (reported_cases * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(reported_cases * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(reported_cases * no_of_pouches * pouches_per_row * 0.0022),(reported_cases * no_of_pouches * pouches_per_row))))),0)),2) AS superDummy  FROM `+dashboardStockInTable+` Where `+queryWhere;
            if(dtoObj.unitId != "5"){
                queryIn = queryIn + ` AND unit_id= '`+dtoObj.unitId;
            }
            queryIn = queryIn + ` GROUP BY `+queryGroup+``; 
            const reportDataIn = await manager.query(queryIn);
            // console.log(reportDataIn);
            queryOut = `SELECT `+queryOutSelect+`,ROUND(SUM(IF(stock_type='dummy',
            (IF(uom = 'OZ' , (job_cartons * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(job_cartons * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(job_cartons * no_of_pouches * pouches_per_row * 0.0022),(job_cartons * no_of_pouches * pouches_per_row))))),0)),2) AS dummy,      
            ROUND(SUM(IF(stock_type='SaleOrder',
            (IF(uom = 'OZ' , (job_cartons * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(job_cartons * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(job_cartons * no_of_pouches * pouches_per_row * 0.0022),(job_cartons * no_of_pouches * pouches_per_row))))),0)),2) AS saleorder,  
            ROUND(SUM(IF(stock_type='anticipated',
            (IF(uom = 'OZ' , (job_cartons * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(job_cartons * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(job_cartons * no_of_pouches * pouches_per_row * 0.0022),(job_cartons * no_of_pouches * pouches_per_row))))),0)),2) AS anticipated,
            ROUND(SUM(IF(stock_type='superDummy',
            (IF(uom = 'OZ' , (job_cartons * no_of_pouches * pouches_per_row * 0.0625),
            IF(uom = 'KG' ,(job_cartons * no_of_pouches * pouches_per_row * 2.20462),
            IF(uom = 'GM' ,(job_cartons * no_of_pouches * pouches_per_row * 0.0022),(job_cartons * no_of_pouches * pouches_per_row))))),0)),2) AS superDummy FROM `+dashboardStockOutTable+` WHERE `+queryOutWhere;
            if(dtoObj.unitId != "5"){
                queryOut = queryOut + ` AND unit_id= '`+dtoObj.unitId;
            }
            queryOut = queryOut + ` GROUP BY `+queryOutGroup+``; 
            const reportDataOut = await manager.query(queryOut);
            // console.log(reportDataOut);
            if(reportDataIn.length<1 && reportDataOut.length<1){
                throw new ErrorResponse(99998, 'No Records Found');
            }   
              
             /** Fetching  Stock In Informaiton */
            const stockInDataMap = new Map<string, StockInObj>();
            for(const stockInData of reportDataIn){
                if(dtoObj.reportType == ReportTypeENum.DAYWISE){
                    const mapKey = moment(stockInData.reportedDate).format('YYYY-MM-DD');
                    if(!stockInDataMap.has(mapKey)){
                        const stockInDataObj = new StockInObj();
                
                        stockInDataObj.anticipated = stockInData.anticipated;                
                        stockInDataObj.saleorder = stockInData.saleorder;                
                        stockInDataObj.dummy = stockInData.dummy;                
                        stockInDataObj.superDummy = stockInData.superDummy; 
                        stockInDataMap.set(mapKey, stockInDataObj);   
                    }else{
                        stockInDataMap.get(mapKey).dummy += stockInData.dummy;     
                        stockInDataMap.get(mapKey).saleorder += stockInData.saleorder;     
                        stockInDataMap.get(mapKey).anticipated += stockInData.anticipated;     
                        stockInDataMap.get(mapKey).superDummy += stockInData.superDummy;     
                    }
                }else if(dtoObj.reportType == ReportTypeENum.WEEKWISE){ 
                    const mapKey = stockInData.reportedDate;
                    if(!stockInDataMap.has(mapKey)){
                        const stockInDataObj = new StockInObj();
                
                        stockInDataObj.anticipated = stockInData.anticipated;                
                        stockInDataObj.saleorder = stockInData.saleorder;                
                        stockInDataObj.dummy = stockInData.dummy;                
                        stockInDataObj.superDummy = stockInData.superDummy; 
                        stockInDataMap.set(mapKey, stockInDataObj);   
                    }else{
                        stockInDataMap.get(mapKey).dummy += stockInData.dummy;     
                        stockInDataMap.get(mapKey).saleorder += stockInData.saleorder;     
                        stockInDataMap.get(mapKey).anticipated += stockInData.anticipated;     
                        stockInDataMap.get(mapKey).superDummy += stockInData.superDummy;     
                    }
                }else{                     
                    quarterName=qunarterCount[stockInData.reportedDate];
                    if(!stockInDataMap.has(quarterName)){
                        const stockInDataObj = new StockInObj();                        
                        stockInDataObj.anticipated = stockInData.anticipated;                
                        stockInDataObj.saleorder = stockInData.saleorder;                
                        stockInDataObj.dummy = stockInData.dummy;                
                        stockInDataObj.superDummy = stockInData.superDummy; 
                        stockInDataMap.set(quarterName, stockInDataObj);
                    }else{
                        stockInDataMap.get(quarterName).dummy += stockInData.dummy;     
                        stockInDataMap.get(quarterName).saleorder += stockInData.saleorder;     
                        stockInDataMap.get(quarterName).anticipated += stockInData.anticipated;     
                        stockInDataMap.get(quarterName).superDummy += stockInData.superDummy; 
                    }
                }
            }
            // console.log(stockInDataMap);
            // console.log(names);
            const dashboardStockInData = new StockInData();
            dashboardStockInData.anticipated = [];
            dashboardStockInData.saleorder = [];
            dashboardStockInData.dummy = [];
            dashboardStockInData.superDummy = [];            
            allNames.forEach(eachName => {
                const stockInObj = stockInDataMap.get(eachName); 
                dashboardStockInData.anticipated.push(stockInObj? stockInObj.anticipated : 0); 
                dashboardStockInData.saleorder.push(stockInObj? stockInObj.saleorder : 0);
                dashboardStockInData.dummy.push(stockInObj? stockInObj.dummy : 0);  
                dashboardStockInData.superDummy.push(stockInObj? stockInObj.superDummy : 0);  
            })

           /** Fetching  Stock Out Informaiton */
            const stockOutDataMap = new Map<string, StockInObj>();
            for(const stockOutData of reportDataOut){
                if(dtoObj.reportType == ReportTypeENum.DAYWISE){
                    const mapKey = moment(stockOutData.reportedDate).format('YYYY-MM-DD');
                    if(!stockOutDataMap.has(mapKey)){
                        const stockOutDataObj = new StockInObj();
                
                        stockOutDataObj.anticipated = stockOutData.anticipated;                
                        stockOutDataObj.saleorder = stockOutData.saleorder;                
                        stockOutDataObj.dummy = stockOutData.dummy;                
                        stockOutDataObj.superDummy = stockOutData.superDummy; 
                        stockOutDataMap.set(mapKey, stockOutDataObj);   
                    }else{
                        stockOutDataMap.get(mapKey).dummy += stockOutData.dummy;     
                        stockOutDataMap.get(mapKey).saleorder += stockOutData.saleorder;     
                        stockOutDataMap.get(mapKey).anticipated += stockOutData.anticipated;     
                        stockOutDataMap.get(mapKey).superDummy += stockOutData.superDummy;     
                    }
                }else if(dtoObj.reportType == ReportTypeENum.WEEKWISE){ 
                    const mapKey = stockOutData.reportedDate;
                    if(!stockOutDataMap.has(mapKey)){
                        const stockOutDataObj = new StockInObj();                
                        stockOutDataObj.anticipated = stockOutData.anticipated;                
                        stockOutDataObj.saleorder = stockOutData.saleorder;                
                        stockOutDataObj.dummy = stockOutData.dummy;                
                        stockOutDataObj.superDummy = stockOutData.superDummy; 
                        stockOutDataMap.set(mapKey, stockOutDataObj);   
                    }else{
                        stockOutDataMap.get(mapKey).dummy += stockOutData.dummy;     
                        stockOutDataMap.get(mapKey).saleorder += stockOutData.saleorder;     
                        stockOutDataMap.get(mapKey).anticipated += stockOutData.anticipated;     
                        stockOutDataMap.get(mapKey).superDummy += stockOutData.superDummy;     
                    }
                }else{                     
                    quarterName=qunarterCount[stockOutData.reportedDate];   
                    if(!stockOutDataMap.has(quarterName)){
                        const stockOutDataObj = new StockInObj();                        
                        stockOutDataObj.anticipated = stockOutData.anticipated;                
                        stockOutDataObj.saleorder = stockOutData.saleorder;                
                        stockOutDataObj.dummy = stockOutData.dummy;                
                        stockOutDataObj.superDummy = stockOutData.superDummy; 
                        stockOutDataMap.set(quarterName, stockOutDataObj);   
                    }else{
                        stockOutDataMap.get(quarterName).dummy += stockOutData.dummy;     
                        stockOutDataMap.get(quarterName).saleorder += stockOutData.saleorder;     
                        stockOutDataMap.get(quarterName).anticipated += stockOutData.anticipated;     
                        stockOutDataMap.get(quarterName).superDummy += stockOutData.superDummy;     
                    }
                }
            }

            const dashboardStockOutData = new StockInData();
            dashboardStockOutData.anticipated = [];
            dashboardStockOutData.saleorder = [];
            dashboardStockOutData.dummy = [];
            dashboardStockOutData.superDummy = [];
            allNames.forEach(eachName => {
                const stockOutObj = stockOutDataMap.get(eachName); 
                dashboardStockOutData.anticipated.push(stockOutObj? stockOutObj.anticipated : 0); 
                dashboardStockOutData.saleorder.push(stockOutObj? stockOutObj.saleorder : 0);
                dashboardStockOutData.dummy.push(stockOutObj? stockOutObj.dummy : 0);  
                dashboardStockOutData.superDummy.push(stockOutObj? stockOutObj.superDummy : 0);  
            })

            const dashboardStockData = new StockInResDto(names, dashboardStockInData, dashboardStockOutData);
            return new StockInResponseData(true, 10000, 'Data Retrieved Successfully.', dashboardStockData);
                       
        } catch (error) {
            // console.log(error);
            return error
        }
    }
    async getTodaysStockOutSOs(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select SUM(so.job_cartons) AS jobCartonsCnt from "+appSettings.analytics_db+".stock_out so where date(so.created_at) = Date(Now())";
            if(req.unitId && req.unitId !=5){
                query = query + ' and so.unit_id = ' + req.unitId
            }
            const queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Stock Out transcations retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }catch (error) {
            // console.log(error);
            return error
        }
    }
    async getrecentFiveStockIns(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select si.created_at AS date, si.reporting_log_id AS reportingLogId,si.po_number AS poNumber,si.variant_code AS variantCode, si.reported_cases AS reportedCases,si.rack_position_code AS rackPositionCode,si.unit_code AS unitCode,si.unit_id from "+appSettings.analytics_db+".stock_in si  WHERE si.reporting_log_id > 0 ";
            if(req.unitId && req.unitId !=5){
                query = query + ' and si.unit_id = ' + req.unitId
            }
            query = query + ' order by si.reporting_log_id desc limit 5'
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Stock In transactions retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getrecentFiveStockOuts(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select so.job_purpose AS jobPurpose,so.fork_lift_job_id as forkLiftJobId,so.fork_lift_item_id AS forkLiftItem_id,so.po_number AS poNumber, SUM(so.job_cartons) AS jobCartons, so.current_position_code AS currentPositionCode,so.unit_code AS unitCode,so.created_at AS createdAt,si.variant_code as variantCode from "+appSettings.analytics_db+".stock_out so LEFT JOIN " + appSettings.analytics_db + ".stock_in si ON si.sale_order_item_id = so.sale_order_item_id WHERE fork_lift_item_id > 0 ";
            if(req.unitId && req.unitId !=5){
                query = query + ' and so.unit_id = ' + req.unitId
            }
            query = query + ' group by so.fork_lift_job_id order by so.fork_lift_job_id desc limit 5 '
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Stock Out transcations retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getTodayStockTransfers(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select SUM(so.job_cartons) AS jobCartonsCnt from "+appSettings.analytics_db+".stock_out so where date(so.created_at) = Date(Now()) and so.job_purpose = 'stockTransfer'";
            if(req.unitId && req.unitId !=5){
                query = query + ' and so.unit_id = ' + req.unitId
            }
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Stock transactions retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getCartonsInWayRacks(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "Select SUM(total_cartons) AS totalCartons from "+appSettings.analytics_db+".stock s where status = 'StockIn' and rack_type = true";
            if(req.unitId && req.unitId !=5){
                query = query + ' and s.unit_id = ' + req.unitId;
            }
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Way Racks Info retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }

    async getLongRunningDummyStock(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = `SELECT si.po_number AS poNumber, si.reported_cases AS cases, si.variant_code AS variantCode, si.rack_position_code AS rackPositionCode, si.unit_code AS unitCode,si.reporting_date as reportingDate FROM `+appSettings.analytics_db+`.stock_in si LEFT JOIN `+appSettings.analytics_db+`.stock s ON s.stock_id = si.stock_id WHERE si.stock_type = "dummy" AND DATE(reporting_date) < DATE( DATE_SUB( NOW() , INTERVAL 180 DAY ) ) AND s.status = "StockIn"`;
            if(req.unitId && req.unitId !=5){
                query = query + ' and s.unit_id = ' + req.unitId;
            }
            let queryResult = await manager.query(query)
            if(queryResult.length > 0){
                return new CommonResponse(true,1001,"Dead Stock retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }

    async getWarehouseCapacity(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "SELECT u.unit_name AS unitName,SUM(IF(rp.occupancy='Assigned',1,0)) AS assignedCount, SUM(IF(rp.occupancy='Not Occupied',1,0)) AS notOccupiedCount,SUM(IF(rp.occupancy='Occupied',1,0)) AS OccupiedCount,(SUM(IF(rp.occupancy='Assigned',1,0)) + SUM(IF(rp.occupancy='Not Occupied',1,0)) + SUM(IF(rp.occupancy='Occupied',1,0)) ) as total FROM "+appSettings.masters_db+".rack_position rp  LEFT JOIN "+appSettings.masters_db+".unitcodes u ON u.unit_code_id = rp.plant_id LEFT JOIN "+appSettings.masters_db+".rack r ON r.rack_id = rp.rack_id WHERE r.rack_status = FALSE AND rp.is_active = TRUE ";
            if(req.unitId && req.unitId !=5){
                query = query + ' and rp.plant_id = ' + req.unitId;
            }
            query = query + ` GROUP BY rp.plant_id ORDER BY u.unit_name , rp.occupancy `
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Warehouse Capacity retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getPOsProductionAbove70Perc(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "select count(*) AS count from "+appSettings.analytics_db+".sale_order so LEFT JOIN  " + appSettings.analytics_db + ".stock s ON s.sale_order_id = so.sale_order_id where so.production_percentage > 70 and so.status Not In ('CLOSED','CANCELLED')";
            if(req.unitId && req.unitId !=5){
                query = query + ' and s.unit_id = ' + req.unitId;
            }
            let queryResult = await manager.query(query)
            if(queryResult){
                return new CommonResponse(true,1001,"Production above 70% retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }
    async getTransferdSOsStock(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let query = "select sale_order_id AS saleOrder_id from "+appSettings.sales_db+".so_transfer_log stl where date(created_at) = date(now())";
            let queryResult = await manager.query(query)
            let response = [];
            if(queryResult.length > 0){
                for(const res of queryResult){
                    let stockIds = `Select CONCAT("'",sl.stockId,"',") as stockIds from `+appSettings.warehouse_db+`.stock_log sl where stock_id =" + res.saleOrderId+" and date(created_at) = date(now())`;
                    let stockIdsResult = await manager.query(stockIds);
                    let transferedStock = "select SUM(total_cartons) AS totalCartons from "+appSettings.analytics_db+".stock s where s.stock_id IN ("+stockIdsResult[0].stockIds+")"; 
                    let transferedStockResult = await manager.query(transferedStock);
                    response.push(transferedStockResult);
                }
            }
            if(response.length > 0) {
                return new CommonResponse(true,1001,"Transfered SO's stock retrived successfully",response);
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }

    async getRepackingEfficiency(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        try{
            const manager = getManager();  
            let getRepackingStock = "Select po_number AS poNumber,job_cartons AS jobCartons,issued_quantity AS issuedQuantity,received_quantity AS receivedQuantity,(issued_quantity - received_quantity) as efficiency  from "+appSettings.analytics_db+".stock_out where job_purpose = 'repacking' and status = 'completed'";
            // console.log('##############',getRepackingStock)
            if(req.unitId && req.unitId !=5){
                getRepackingStock = getRepackingStock + ' and stock_out.unit_id = ' + req.unitId;
            }
            let getRepackingStockResult = await manager.query(getRepackingStock);
            if(getRepackingStockResult.length > 0) {
                return new CommonResponse(true,1001,"Repacking efficiency retrived successfully",getRepackingStockResult);
                
            }
            else{
                return new CommonResponse(false,1010,"no data found");
            }
        }catch (error) {
            return error
        }
    }
    async getExpectedStockInsAndStockOuts(req:AnalyticsUnitRequest): Promise <ExpectedStockInOutResponse>{
        try{
            let res:any = []
            const manager = getManager();  
            let expectedStockIns = "SELECT SUM(si.job_cases - si.reported_cases) AS inCartons FROM "+appSettings.analytics_db+".`sale_order_items` si LEFT JOIN "+appSettings.analytics_db+".`sale_order` s ON s.sale_order_id = si.sale_order_id LEFT JOIN "+appSettings.analytics_db+".stock st ON st.sale_order_id = si.sale_order_id WHERE DATE(s.act_edl_date) <= DATE(NOW()) + INTERVAL 30 DAY AND s.status IN ('OPEN','INPROGRESS') AND si.reported_cases < si.job_cases  limit 1";
            if(req.unitId && req.unitId !=5){
                expectedStockIns = expectedStockIns + ' and st.unit_id = ' + req.unitId;
            }
            let expectedStockInCnt = await manager.query(expectedStockIns);
            // console.log("expectedStockInCnt" + expectedStockInCnt[0].inCartons);
            let expectedLocationsQuery = "SELECT SUM((si.job_cases - si.reported_cases)/si.pallet_capacity) AS inLocationsCnt FROM "+appSettings.analytics_db+".`sale_order_items` si LEFT JOIN "+appSettings.analytics_db+".`sale_order` s ON s.sale_order_id = si.sale_order_id WHERE DATE(s.act_edl_date) <= DATE(NOW()) + INTERVAL 30 DAY AND s.status IN ('OPEN','INPROGRESS') AND si.reported_cases < si.job_cases  limit 1";
            let expectedLocations = await manager.query(expectedLocationsQuery);
            // console.log("expectedLocations" + expectedLocations[0]);

            let expectedStockOuts = "SELECT SUM(st.total_cartons) AS outCartons FROM "+appSettings.analytics_db+".stock st LEFT JOIN "+appSettings.analytics_db+".`sale_order` s ON s.sale_order_id = st.sale_order_id WHERE st.status = 'StockIn' AND DATE(s.act_edl_date) <= DATE(NOW()) + INTERVAL 30 DAY AND s.status IN ('OPEN','INPROGRESS') limit 1";
            let expectedStockOutCnt = await manager.query(expectedStockOuts);
            // console.log("expectedStockOutCnt" + expectedStockOutCnt[0]);

            let expectedavailLocations = "SELECT COUNT(*) AS outLocationscnt FROM "+appSettings.analytics_db+".stock st LEFT JOIN "+appSettings.analytics_db+".`sale_order` s ON s.sale_order_id = st.sale_order_id WHERE st.status = 'StockIn' AND DATE(s.act_edl_date) <= DATE(NOW()) + INTERVAL 30 DAY AND s.status IN ('OPEN','INPROGRESS') limit 1";
            let expectedavailableLocations = await manager.query(expectedavailLocations);
            // console.log("expectedavailableLocations" + expectedavailableLocations[0]);

            if(expectedStockInCnt[0].inCartons > 0){
                return new ExpectedStockInOutResponse(true,1001,"Expected Stock In's & Out Locations retrived Successfully ",expectedStockInCnt[0].inCartons,expectedLocations[0].inLocationsCnt,expectedStockOutCnt[0].outCartons,expectedavailableLocations[0].outLocationscnt);
            }
            else{
                return new ExpectedStockInOutResponse(false,1010,"no data found");
            }
        }
        catch (error) {
            return error
        }
    }

    async getWarehouseLifeCycle(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        const manager = getManager();  
        try{
            let stockInQuery = "SELECT 'SO Stock IN' AS lifeCycleStatus, COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1 AS kkd,COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1 AS `unitOne`,COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1 AS `unitTwo`, ((COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1)) as total FROM "+appSettings.analytics_db+".stock WHERE `status` = 'StockIn'";
            if(req.unitId && req.unitId !=5){
                stockInQuery = stockInQuery + ' and stock.unit_id = ' + req.unitId;
            }
            let stockInSOs = await manager.query(stockInQuery);
            let stockOutquery = "SELECT 'SO Stock Out' AS lifeCycleStatus,COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1 AS kkd,COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1 AS `unitOne`,COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1 AS `unitTwo`,((COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1)) as total FROM "+appSettings.analytics_db+".stock WHERE STATUS = 'StockOut'";
            if(req.unitId && req.unitId !=5){
                stockOutquery = stockOutquery + ' and stock.unit_id = ' + req.unitId;
            }
            let stockOutSOs = await manager.query(stockOutquery);
            // let stockBeyondETDQuery = "Select count(sale_order_id) as stockBeyondETD from "+appSettings.analytics_db+".stock s left join "+appSettings.analytics_db+".sale_order so so.sale_order_id = s.sale_order_id where date(";

            let stockMovedBeyondEtdQuery = "SELECT 'Stock Not Moved Beyond ETD' AS lifeCycleStatus,SUM(IF(so.factoryId = 1, 1, 0)) AS kkd,SUM(IF(so.factoryId = 2, 1, 0)) AS unitOne,SUM(IF(so.factoryId = 3, 1, 0)) AS unitTwo,((SUM(IF(so.factoryId = 1, 1, 0))) + (SUM(IF(so.factoryId = 2, 1, 0))) + (SUM(IF(so.factoryId = 3, 1, 0)))) as total FROM "+appSettings.sales_db+".`sale_order_track` s LEFT JOIN "+appSettings.sales_db+".`so_invoice_details` so ON so.sale_order_id = s.sale_order_id WHERE DATE(s.dispatched_date) > DATE(so.act_edl_date)";
            if(req.unitId && req.unitId !=5){
                stockMovedBeyondEtdQuery = stockMovedBeyondEtdQuery + ' and so.factoryId = ' + req.unitId;
            }
            let stockMovedBeyondEtd = await manager.query(stockMovedBeyondEtdQuery);

            let stockMovedBeforeEtdQuery = "SELECT 'Stock Moved Before ETD' AS lifeCycleStatus,SUM(IF(so.factoryId = 1, 1, 0)) AS kkd,SUM(IF(so.factoryId = 2, 1, 0)) AS unitOne,SUM(IF(so.factoryId = 3, 1, 0)) AS unitTwo,((SUM(IF(so.factoryId = 1, 1, 0))) + (SUM(IF(so.factoryId = 2, 1, 0))) + (SUM(IF(so.factoryId = 3, 1, 0)))) as total FROM "+appSettings.sales_db+".`sale_order_track` s LEFT JOIN "+appSettings.sales_db+".`so_invoice_details` so ON so.sale_order_id = s.sale_order_id WHERE DATE(s.dispatched_date) < DATE(so.act_edl_date)";
            if(req.unitId && req.unitId !=5){
                stockMovedBeforeEtdQuery = stockMovedBeforeEtdQuery + ' and so.factoryId = ' + req.unitId;
            }
            let stockMovedBeforeEtd = await manager.query(stockMovedBeforeEtdQuery);

            let stockMovedOnTimeQuery = "SELECT 'Stock Moved OnTime' AS lifeCycleStatus,SUM(IF(so.factoryId = 1, 1, 0)) AS kkd,SUM(IF(so.factoryId = 2, 1, 0)) AS unitOne,SUM(IF(so.factoryId = 3, 1, 0)) AS unitTwo,((SUM(IF(so.factoryId = 1, 1, 0))) + (SUM(IF(so.factoryId = 2, 1, 0))) + (SUM(IF(so.factoryId = 3, 1, 0)))) as total FROM "+appSettings.sales_db+".`sale_order_track` s LEFT JOIN "+appSettings.sales_db+".`so_invoice_details` so ON so.sale_order_id = s.sale_order_id WHERE DATE(s.dispatched_date) = DATE(so.act_edl_date)";
            if(req.unitId && req.unitId !=5){
                stockMovedOnTimeQuery = stockMovedOnTimeQuery + ' and so.factoryId = ' + req.unitId;
            }
            let stockMovedOnTime = await manager.query(stockMovedOnTimeQuery);

            let dummyStockInQuery = "select 'Without SO Stock IN' AS lifeCycleStatus, COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1 AS kkd,COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1 AS `unitOne`,COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1 AS `unitTwo`,((COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1)) as total from "+appSettings.warehouse_db+".stock where `status` = 'StockIn' and stock_type = 'dummy'";
            if(req.unitId && req.unitId !=5){
                dummyStockInQuery = dummyStockInQuery + ' and stock.unit_id = ' + req.unitId;
            }
            let dummyStockInSOs = await manager.query(dummyStockInQuery);

            let dummyStockOutquery = "select 'Without SO Stock Out' AS lifeCycleStatus, COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1 AS kkd,COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1 AS `unitOne`,COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1 AS `unitTwo`,((COUNT(DISTINCT(IF(unit_id =1 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =2 ,sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(unit_id =3 ,sale_order_id,0))) - 1)) as total from "+appSettings.warehouse_db+".stock where `status` = 'StockOut' and stock_type = 'dummy'";
            if(req.unitId && req.unitId !=5){
                dummyStockOutquery = dummyStockOutquery + ' and stock.unit_id = ' + req.unitId;
            }
            let dummyStockOutSOs = await manager.query(dummyStockOutquery);

            let deadStockBeyond30daysQuery = `SELECT 'Dummy Stock Not Moved Beyond 30days' AS lifeCycleStatus,IF(s.unit_id = 1, COUNT(DISTINCT s.sale_order_id), 0) AS kkd,IF(s.unit_id = 2, COUNT(DISTINCT s.sale_order_id), 0) AS unitOne,IF(s.unit_id = 3, COUNT(DISTINCT s.sale_order_id), 0) AS unitTwo,((COUNT(DISTINCT(IF(s.unit_id =1 ,s.sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(s.unit_id =2 ,s.sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(s.unit_id =3 ,s.sale_order_id,0))) - 1)) as total FROM `+appSettings.analytics_db+`.stock_in si LEFT JOIN `+appSettings.analytics_db+`.stock s ON s.stock_id = si.stock_id WHERE si.stock_type = "dummy" AND DATE(reporting_date) < DATE(NOW()) - INTERVAL 30 DAY AND s.status = "StockIn"`;
            if(req.unitId && req.unitId !=5){
                deadStockBeyond30daysQuery = deadStockBeyond30daysQuery + ' and si.unit_id = ' + req.unitId;
            }
            let deadStockBeyond30days = await manager.query(deadStockBeyond30daysQuery)

            let deadStockBeyond60daysQuery = `SELECT 'Dummy Stock Not Moved Beyond 60days' AS lifeCycleStatus,IF(si.unit_id = 1, COUNT(DISTINCT s.sale_order_id), 0) AS kkd,IF(si.unit_id = 2, COUNT(DISTINCT s.sale_order_id), 0) AS unitOne,IF(si.unit_id = 3, COUNT(DISTINCT s.sale_order_id), 0) AS unitTwo,((COUNT(DISTINCT(IF(si.unit_id =1 ,s.sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(si.unit_id =2 ,s.sale_order_id,0))) - 1) + (COUNT(DISTINCT(IF(si.unit_id =3 ,s.sale_order_id,0))) - 1)) as total FROM `+appSettings.analytics_db+`.stock_in si LEFT JOIN `+appSettings.analytics_db+`.stock s ON s.stock_id = si.stock_id WHERE si.stock_type = "dummy" AND DATE(reporting_date) < DATE(NOW()) - INTERVAL 60 DAY AND s.status = "StockIn"`;
            if(req.unitId && req.unitId !=5){
                deadStockBeyond60daysQuery = deadStockBeyond60daysQuery + ' and si.unit_id = ' + req.unitId;
            }
            let deadStockBeyond60days = await manager.query(deadStockBeyond60daysQuery)

            let response = [...stockInSOs,...stockOutSOs,...stockMovedBeyondEtd,...stockMovedBeforeEtd,...stockMovedOnTime,...dummyStockInSOs,...dummyStockOutSOs,...deadStockBeyond30days,...deadStockBeyond60days];
            
            return new CommonResponse(true,1001,"Life Cycle status retrived successfully",response)

        }catch (error) {



            return error
        }
    }
    async getTop10DummyProducts(req:AnalyticsUnitRequest): Promise <CommonResponse>{
        const manager = getManager();  
        try{
            let query = "SELECT variant_code AS product,varient_id, SUM(stockin_qunatity) as qty,ROUND(SUM(IF(uom_code = 'KG' ,(stockin_qunatity*pouches*pouch_weight* 2.20462),IF(uom_code = 'OZ', (stockin_qunatity*pouches*pouch_weight* 0.0625),IF(uom_code = 'GM' ,(stockin_qunatity*pouches*pouch_weight* 0.0022),IF(uom_code = 'LB',(stockin_qunatity*pouches*pouch_weight),(stockin_qunatity*pouches*pouch_weight))))))) AS cnt FROM "+appSettings.analytics_db+".stock WHERE stock_type = 'dummy' AND STATUS = 'StockIn' ";
            if(req.unitId && req.unitId !=5){
                query = query + ' and unit_id = '+ req.unitId;
            }
            query = query + ` GROUP BY varient_id ORDER BY cnt DESC LIMIT 10 `
            let queryResult = await manager.query(query);
            if(queryResult.length > 0){
                return new CommonResponse(true,1001,"Data retrived successfully",queryResult);
            }
            else{
                return new CommonResponse(false,1001,"No data found",queryResult);
            }
        }catch (error) {
            return error
        }
    }

    
    async getVarientCodeDropdown():Promise<CommonResponse>{
        try{
            const manager = getManager()
            const dataQuery = `SELECT sku.variant_code as varientCode
            FROM ${appSettings.warehouse_db} .stock s
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id
            WHERE (s.total_pouches > 0 OR s.loose_pouches > 0 ) AND s.status != 'Cancelled'
            GROUP BY varient_id`
            const data = await manager.query(dataQuery)
            if(data.length > 0){
                return new CommonResponse(true,1,'Data retrievd', data)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getStockValuationReport1(req:ProductReq):Promise<StockValuationResponseModel>{
        try{
            const manager = getManager()

            const dateString = req.fromDate;
            const parts = dateString.split("-");
            const month = parseInt(parts[1], 10);
            let toDate = new Date(req.toDate);
            toDate.setDate(toDate.getDate() + 1);
            req.toDate = moment(toDate).format('YYYY-MM-DD')
            const mfgCost = `SELECT SUM(amount) AS price FROM ${appSettings.finance_db} .expenses WHERE category IN('Procurement Freight','LABOUR CHARGES','PROCESSING CHARGES','Electrical cost',
            'SOLAR UNITS INCOME','PACKING MAT','SALT & CHEM','QC COST','CONSUMABLES','OTHER DIR EXP','SALARIES','Finance cost','Depreciation','INSURANCE','ADMIN','Forwarding Expenses') AND month = ${month}`;
            const mfgCostData = await manager.query(mfgCost)
            // console.log(mfgCostData,'---mfgCostData----')

            const forwExpQuery = `SELECT amount FROM ${appSettings.finance_db} .expenses WHERE category = 'Forwarding Expenses' AND month = ${month}`
            const forwExpData = await manager.query(forwExpQuery)
            // console.log(forwExpData,'---forwExpData----')


            const rmQtyQuery = `select sum(quantity) as rmQty from ${appSettings.rm_procure_db} .grn_items where created_at between '${req.fromDate}' and '${req.toDate}'`
            const rmQtyData = await manager.query(rmQtyQuery)
            // console.log(rmQtyData,'---rmQtyData----')


            const prevailingMarketRateQuery = `select min_price,product_id from ${appSettings.masters_db} .product_price_list where category = '${FgPriceListCategoryEnum.EXPORT}'`
            const prevailingMarketRateData = await manager.query(prevailingMarketRateQuery)
            const prevailingMarketRateMap = new Map<number,any>()
            for(const rec of prevailingMarketRateData){
                prevailingMarketRateMap.set(rec.product_id,rec.min_price)
            }
            // console.log(prevailingMarketRateMap,'---prevailingMarketRateMap----')


            const prevOrderQuery = `SELECT soi.varient_id,(soi.cases * soi.pouches * soi.pouch_weight) AS qty,soi.unitPrice,(soi.cases * soi.pouches * soi.pouch_weight * soi.unitPrice) as amount  FROM ${appSettings.sales_db} .sale_order_items  soi
            LEFT JOIN ${appSettings.sales_db} .sale_order so ON so.sale_order_id = soi.sale_order_id
            WHERE so.status != 'CLOSED' AND soi.unitPrice > 0`
            const prevOrderData = await manager.query(prevOrderQuery)
            const prevOrderMap = new Map<number,any>()
            for(const rec of prevOrderData){
                if(!prevOrderMap.has(rec.varient_id)){
                    prevOrderMap.set(rec.varient_id,{'quantity':Number(rec.qty),'amount':Number(rec.amount)})
                }else{
                    const prevQty = prevOrderMap.get(rec.varient_id).quantity
                    const prevAmt = prevOrderMap.get(rec.varient_id).amount
                    prevOrderMap.get(rec.varient_id).quantity = Number(prevQty) + Number(rec.qty)
                    prevOrderMap.get(rec.varient_id).amount = Number(prevAmt) + Number(rec.amount)
                }
            }
            // console.log(prevOrderMap,'---prevOrderMap----')


            const prevShippedQuery = `SELECT soi.varient_id,(soi.cases * soi.pouches * soi.pouch_weight) AS qty,soi.unitPrice,(soi.cases * soi.pouches * soi.pouch_weight * soi.unitPrice) as amount  FROM ${appSettings.sales_db} .sale_order_items  soi
            LEFT JOIN ${appSettings.sales_db} .sale_order so ON so.sale_order_id = soi.sale_order_id
            WHERE so.status = 'CLOSED' AND soi.unitPrice > 0`
            const prevShippedData = await manager.query(prevShippedQuery)
            const prevShippedMap = new Map<number,any>()
            for(const rec of prevShippedData){
                if(!prevShippedMap.has(rec.varient_id)){
                    prevShippedMap.set(rec.varient_id,{'quantity':Number(rec.qty),'amount':Number(rec.amount)})
                }else{
                    const prevQty = prevShippedMap.get(rec.varient_id).quantity
                    const prevAmt = prevShippedMap.get(rec.varient_id).amount
                    prevShippedMap.get(rec.varient_id).quantity = Number(prevQty) + Number(rec.qty)
                    prevShippedMap.get(rec.varient_id).amount = Number(prevAmt) + Number(rec.amount)
                }
            }
            // console.log(prevShippedMap,'---prevShippedMap----')

            // const productPriceListQuery = `SELECT mid_price as price,product_id as varientId from ${appSettings.masters_db} .product_price_list where category = '${FgPriceListCategoryEnum.EXPORT}'`
            const priceAgainstCountQuery = `SELECT count,price FROM ${appSettings.rm_procure_db } .rm_rates WHERE category = '${CompanyCategoryEnum.OWN}' AND TYPE=  '${HarvestTypes.Live_Harvest}'`
            const countPriceListInfo = await manager.query(priceAgainstCountQuery)
            const countPriceListInfoMap = new Map<number,any>()
            for(const rec of countPriceListInfo){
                countPriceListInfoMap.set(rec.count,{'price':Number(rec.price)})
                
            }

            const reportingPricesQry = `SELECT r.lot_code,gi.count,gi.price,r.stock_id FROM ${appSettings.warehouse_db} .reporting r LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.plant_lot_number = r.lot_code `
            const reportingPrices = await manager.query(reportingPricesQry)
            const reportingPricesMap = new Map<number,any>()
            for(const rec of reportingPrices){
                if(!reportingPricesMap.has(rec.stock_id)){
                    reportingPricesMap.set(rec.stock_id,{price:rec.price,total:1})
                }else{
                    let price = reportingPricesMap.get(rec.stock_id).price
                    let total = reportingPricesMap.get(rec.stock_id).total
                    reportingPricesMap.get(rec.stock_id).price = price
                    reportingPricesMap.get(rec.stock_id).total = Number(total) + 1
                }
            }


            let infoQuery = `SELECT SUM(s.total_cartons) AS totalCartons,SUM(s.total_pouches) AS totalPouches,SUM(s.loose_pouches) AS loosePouches,s.varient_id,s.uom_id,s.pouches,s.product_id,uom.uom_name,s.status,s.pack_style_id,s.pouch_weight,pm.packing_method_name,sku.hon_to_fg_yield as yield,g.grade_name as grade, g.pack_count as packCount,s.product_category,vf.code as valueAdditionFive,s.stock_type,ex.exchange_rate,CONCAT(SUBSTRING(sku.short_code, 1, LENGTH(sku.short_code) - LOCATE('/', REVERSE(sku.short_code))), ' ', pm.packing_method_name) AS variant_code,GROUP_CONCAT(DISTINCT(s.stock_id)) AS stockIds
            FROM ${appSettings.warehouse_db} .stock s 
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id
            LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = s.uom_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = s.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .grades g on g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_five_types vf ON vf.value_addition_five_id = sku.value_addition_five_id
            LEFT JOIN ${appSettings.sales_db} .so_invoice_details so on so.sale_order_id = s.sale_order_id
            LEFT JOIN ${appSettings.masters_db} .exchange_rates ex on ex.currency_id = so.currency_id 
            WHERE (s.total_pouches > 0 OR s.loose_pouches > 0 ) AND s.status != 'Cancelled' `
            // if(req.varientCode){
            //     infoQuery += ` AND sku.variant_code = '${req.varientCode}'`
            // }
            if(req.fromDate){
                infoQuery += ` AND s.date between '${req.fromDate}' and '${req.toDate}'`
            }
            // infoQuery += ` GROUP BY varient_id,pouch_weight`
            infoQuery += ` GROUP BY pm.packing_method_name,sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,
            sku.value_addition_four_id,sku.value_addition_five_id,sku.product_id,sku.grade_id`
            const data = await manager.query(infoQuery)

            const exchangeRateQry = `SELECT exchange_rate from ${appSettings.masters_db} .exchange_rates er LEFT JOIN ${appSettings.masters_db} .currencies c ON c.currency_id = er.currency_id WHERE c.currency_name = 'USD'`
            const exchangeRate = await manager.query(exchangeRateQry)

            const mfgCostPerKg = Number(mfgCostData[0].price) / Number(rmQtyData[0].rmQty)
            const forwardExpAmount = forwExpData.length > 0 ? Number(forwExpData[0].amount) : 0
            const mfgCostPerKgForJumble = (Number(mfgCostData[0].price) - forwardExpAmount) / Number(rmQtyData[0].rmQty)
            const dataMap = new Map<number,StockValuationProductInfo>()
            const abstractMap = new Map<string,AbstractInfo>()
            if(data.length > 0){
                for(const rec of data){
                    // console.log(rec,'------------rec')
                    if(!dataMap.has(rec.varient_id)){
                        let qtyInKgs = 0
                        let qtyInLbs = 0
                        let totalPouches = (Number(rec.totalPouches) * Number(rec.totalCartons)) + Number(rec.loosePouches)
                        if(rec.uom_name == 'KGS'){
                            qtyInKgs = totalPouches * Number(rec.pouch_weight)
                            qtyInLbs = Number(qtyInKgs) / 0.454
                        }else if(rec.uom_name == 'LBS'){
                            qtyInLbs = totalPouches * Number(rec.pouch_weight)
                            qtyInKgs = Number(qtyInLbs) * 0.454
                        } else if(rec.uom_name == 'GMS'){
                            const gmtokg = Number(rec.pouch_weight) / 1000
                            qtyInKgs = totalPouches * Number(gmtokg)
                            qtyInLbs =  Number(qtyInKgs) / 0.454
                        } else if(rec.uom_name == 'OZ'){
                            const oztolb = Number(rec.pouch_weight) / 16
                            qtyInLbs = totalPouches * Number(oztolb)
                            qtyInKgs = Number(qtyInLbs) * 0.454
                        }
                        const productYield = rec.yield ? rec.yield : 0
                        const rmCount = Math.round(1000/((454/Number(productYield)/Number(rec.packCount))*100))
                        // const rmPrice = countPriceListInfoMap.get(rmCount)?.price ? countPriceListInfoMap.get(rmCount).price : 0
                     
                        let price = 0 
                        let totalCount = 0
                        for(const stockId of rec.stockIds){
                            price += reportingPricesMap.get(stockId) ? Number(reportingPricesMap.get(stockId).price) : 0
                            totalCount += reportingPricesMap.get(stockId) ?  Number(reportingPricesMap.get(stockId).total) : 0
                        }
                        const rmPrice = Number(price) / Number(totalCount)
                        
                        const calRmQty = Number(((Number(qtyInKgs))/Number(productYield)*100).toFixed(2))
                        const rmValue = Math.round(Number(rmPrice)*Number(calRmQty))
                        const mfgCost = Math.round(Number(calRmQty) * Number(mfgCostData[0].price))
                        const netCOP = Number(rmValue) + Number(mfgCost)
                        let basis
                        let realisationRate = 0
                        if(prevOrderMap.has(rec.varient_id)){
                            realisationRate = prevOrderMap.get(rec.varient_id).amount / prevOrderMap.get(rec.varient_id).quantity
                            basis = 'ORDER'
                        } else if(prevailingMarketRateMap.has(rec.variant_id)){
                            realisationRate = prevailingMarketRateMap.get(rec.variant_id)
                            basis = 'MARKET'
                        } else if(prevShippedMap.has(rec.variant_id)){
                            realisationRate = prevShippedMap.get(rec.variant_id).amount / prevShippedMap.get(rec.variant_id).quantity
                            basis = 'PREVIOUS ORDER'
                        }
                        const realisationValue = (Number(qtyInKgs)* rmPrice * Number(realisationRate))
                        // dataMap.set(rec.varient_id,new StockValuationModel(rec.variant_code,rec.totalCartons,rec.packing_method_name,Number(qtyInKgs),Number(qtyInLbs),rmPrice,(Number(qtyInKgs)* rmPrice)))
                        dataMap.set(rec.varient_id,new StockValuationProductInfo(rec.grade,rec.variant_code,rec.totalCartons,rec.loosePouches,Number(qtyInKgs),productYield,rec.packCount,rmCount,rmPrice,calRmQty,rmValue,mfgCost,netCOP,realisationRate,realisationValue,basis))                      

                    }else{
                        let qtyInKgs
                        let qtyInLbs
                        let totalPouches = (Number(rec.totalPouches) * Number(rec.totalCartons)) + Number(rec.loosePouches)
                        if(rec.uom_name == 'KGS'){
                            qtyInKgs = totalPouches * Number(rec.pouch_weight)
                            qtyInLbs =  Number(qtyInKgs) / 0.454
                        }else if(rec.uom_name == 'LBS'){
                            qtyInLbs = totalPouches * Number(rec.pouch_weight)
                            qtyInKgs = Number(qtyInLbs) * 0.454
                        } else if(rec.uom_name == 'GMS'){
                            const gmtokg = Number(rec.pouch_weight) / 1000
                            qtyInKgs = totalPouches * Number(gmtokg)
                            qtyInLbs =  Number(qtyInKgs) / 0.454
                        } else if(rec.uom_name == 'OZ'){
                            const oztolb = Number(rec.pouch_weight) / 16
                            qtyInLbs = totalPouches * Number(oztolb)
                            qtyInKgs = Number(qtyInLbs) * 0.454
                        }
                        const productYield = rec.yield ? rec.yield : 0
                        const totalQty = Number(dataMap.get(rec.varient_id).fgQtyInKgs) + Number(qtyInKgs)
                        const calRmQty = Number((Number(totalQty)/Number(productYield)*100).toFixed(2))
                        const rmValue = Math.round(Number(dataMap.get(rec.varient_id).rmRate)*Number(calRmQty))
                        const mfgCost = Math.round(Number(calRmQty) * Number(mfgCostData[0].price))
                        const netCOP = Number(rmValue) + Number(mfgCost)
                        dataMap.get(rec.varient_id).masterCartons = Number(dataMap.get(rec.varient_id).masterCartons) + Number(rec.totalCartons)
                        // dataMap.get(rec.varient_id).qtyInKgs = dataMap.sget(rec.varient_id).qtyInKgs + Number(qtyInKgs)
                        // dataMap.get(rec.varient_id).qtyInLbs = dataMap.get(rec.varient_id).qtyInLbs + Number(qtyInLbs)
                        dataMap.get(rec.varient_id).fgQtyInKgs = totalQty
                        dataMap.get(rec.varient_id).calRmQty = calRmQty
                        dataMap.get(rec.varient_id).rmValue = rmValue
                        dataMap.get(rec.varient_id).mfgCost = mfgCost
                        dataMap.get(rec.varient_id).netCop = netCOP

                    }
                    let particular
                        if(rec.product_category == ProductCategoryEnum.GI){
                            particular = 'FG'
                        }else if(rec.product_category == ProductCategoryEnum.jumble){
                            particular = 'JUMBLE'
                        }else{
                            particular = 'GII/BRK/DC'
                        }
                        // else if(rec.valueAdditionFive == 'GII' || rec.valueAdditionFive == 'BKN' || rec.valueAdditionFive == 'DC'){
                        //     particular = 'GII/BRK/DC'
                        // }
                        const abfgQty = dataMap.get(rec.varient_id).fgQtyInKgs ? dataMap.get(rec.varient_id).fgQtyInKgs : 0
                        // console.log(abfgQty,'99')
                        const abnetCop  = dataMap.get(rec.varient_id).netCop ? dataMap.get(rec.varient_id).netCop : 0
                        const abReal = dataMap.get(rec.varient_id).realisationValue ? dataMap.get(rec.varient_id).realisationValue : 0

                        if(!abstractMap.has(particular)){
                            abstractMap.set(particular,new AbstractInfo(particular,abfgQty,abnetCop,(Number(abnetCop)/abfgQty),abReal,(Number(abReal)/abfgQty)))
                        }else{
                            const quantity = Number(abstractMap.get(particular).qty) + abfgQty
                            const cop = Number(abstractMap.get(particular).cop) + abnetCop
                            const copPerKg = Number(cop) / Number(quantity)
                            const realValue = Number(abstractMap.get(particular).realisation) + abReal
                            const realPerKg = Number(realValue) / Number(quantity)
                            abstractMap.get(particular).qty = quantity
                            abstractMap.get(particular).cop = cop
                            abstractMap.get(particular).copPerKg = copPerKg
                            abstractMap.get(particular).realisation = realValue
                            abstractMap.get(particular).realisationPerKg = realPerKg
                        }

                }
                const abstractModel : AbstractInfo[] = []
                abstractMap.forEach(e => abstractModel.push(e))
                const dataModel : StockValuationProductInfo[] = []
                dataMap.forEach((e => dataModel.push(e)))
                // await this.getAbstractForStockValuation(dataMap)
                const info = new StockValuationReportModel(mfgCostPerKgForJumble,mfgCostPerKg,exchangeRate[0].exchange_rate,dataModel,abstractModel)
                return new StockValuationResponseModel(true,1,'Data retrieved',info)
            }else{
                return new StockValuationResponseModel(false,0,'No data found')
            }

        }catch(err){
            throw err
        }
    }


    // async getAbstractForStockValuation(data):Promise<any>{
    //     try{
    //         const manager = getManager()
    //         const fgQuery = `SELECT 
    //         CASE 
    //             WHEN uom.uom_name = 'KG' THEN (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* s.pouch_weight)))
    //             WHEN uom.uom_name = 'Gms' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* (s.pouch_weight/1000))) * 2.20462 )
    //             WHEN uom.uom_name = 'LB' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* s.pouch_weight)) / 2.20462 )
    //             WHEN uom.uom_name = 'Gms' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* (s.pouch_weight / 16))) / 2.20462 )
    //         END AS qty
    //         FROM ${appSettings.warehouse_db} .stock s
    //         LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = s.uom_id
    //         WHERE s.product_category = 'g1' AND (s.total_pouches > 0 OR s.loose_pouches > 0 ) AND s.status != 'Cancelled'`
    //         const fgInfo = await manager.query(fgQuery)

    //         const infoQuery = `SELECT sku.value_addition_five_id,vf.code,
    //         CASE 
    //             WHEN uom.uom_name = 'KG' THEN (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* s.pouch_weight)))
    //             WHEN uom.uom_name = 'Gms' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* (s.pouch_weight/1000))) * 2.20462 )
    //             WHEN uom.uom_name = 'LB' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* s.pouch_weight)) / 2.20462 )
    //             WHEN uom.uom_name = 'Gms' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* (s.pouch_weight / 16))) / 2.20462 )
    //         END AS qty
    //         FROM ${appSettings.warehouse_db} .stock s
    //         LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = s.uom_id
    //         LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id
    //         LEFT JOIN ${appSettings.masters_db} .value_addition_five_types vf ON vf.value_addition_five_id = sku.value_addition_five_id
    //         WHERE (s.total_pouches > 0 OR s.loose_pouches > 0 ) AND s.status != 'Cancelled' AND vf.code ='GII' OR vf.code = 'BKN' OR vf.code = 'DC'`
    //         const infoData = await manager.query(infoQuery)

    //         const jumbleQuery = `SELECT 
    //         CASE 
    //             WHEN uom.uom_name = 'KG' THEN (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* s.pouch_weight)))
    //             WHEN uom.uom_name = 'Gms' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* (s.pouch_weight/1000))) * 2.20462 )
    //             WHEN uom.uom_name = 'LB' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* s.pouch_weight)) / 2.20462 )
    //             WHEN uom.uom_name = 'Gms' THEN  (SUM((((s.total_cartons*s.total_pouches)+s.loose_pouches)* (s.pouch_weight / 16))) / 2.20462 )
    //         END AS qty
    //         FROM ${appSettings.warehouse_db} .stock s
    //         LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = s.uom_id
    //         WHERE s.stock_type = 'dummy' AND (s.total_pouches > 0 OR s.loose_pouches > 0 ) AND s.status != 'Cancelled'`
    //         const jumbleData = await manager.query(jumbleQuery)

    //         return

    //     }catch(err){
    //         throw err
    //     }
    // }


    //  old services used 

    async getStockStatementInfo1(req:StockSTatementReq):Promise<StockStatementResponseModel>{
        try{
            const manager = getManager()
            const otherProducts = ['VPDTOFFBLKBKN/NS/BKN','VPUDTOFFBLKDC/NS/DC','VCPDTOFFIQFBKN/S2S2/12-15/120Min/BKN','VCPDTOFFIQFGII/S2S2/12-15/120MIN/61-70','VPDTONIQFBRD/NS/BRD','VHLSOIQFBRD/NS/BRD','VHLSOBLKDC/NS/DC']
            const updated = otherProducts.map(str => `"${str}"`)
            const jumbleinfoQuery = `SELECT SUM(total_cartons) AS totalCartons,SUM(total_pouches) AS totalPouches,SUM(loose_pouches) AS loosePouches,varient_id,sku.variant_code,g.grade_name,CONCAT(SUBSTRING(sku.short_code, 1, LENGTH(sku.short_code) - LOCATE('/', REVERSE(sku.short_code))), ' ', pm.packing_method_name) AS skuCode,s.pouch_weight as pouchWeight,uom.uom_name
            FROM ${appSettings.warehouse_db} .stock s
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = varient_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm on pm.packing_method_id = s.pack_style_id 
            LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = s.uom_id
            WHERE (total_pouches > 0 OR loose_pouches > 0 ) AND STATUS != 'Cancelled' AND s.product_category = '${ProductCategoryEnum.jumble}' AND CAST(s.date AS DATE) = '${req.date}'
            GROUP BY pm.packing_method_name,sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,
            sku.value_addition_four_id,sku.value_addition_five_id,sku.product_id,g.grade_id`
            const jumbleinfo = await manager.query(jumbleinfoQuery)

            const fginfoQuery = `SELECT SUM(total_cartons) AS totalCartons,SUM(total_pouches) AS totalPouches,SUM(loose_pouches) AS loosePouches,varient_id,sku.variant_code,g.grade_name,CONCAT(SUBSTRING(sku.short_code, 1, LENGTH(sku.short_code) - LOCATE('/', REVERSE(sku.short_code))), ' ', pm.packing_method_name) AS skuCode,s.pouch_weight as pouchWeight,uom.uom_name
            FROM ${appSettings.warehouse_db} .stock s
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = varient_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm on pm.packing_method_id = s.pack_style_id 
            LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = s.uom_id
            WHERE (total_pouches > 0 OR loose_pouches > 0 ) AND STATUS != 'Cancelled' AND s.product_category = '${ProductCategoryEnum.GI}' AND CAST(s.date AS DATE) = '${req.date}'
            GROUP BY pm.packing_method_name,sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,
            sku.value_addition_four_id,sku.value_addition_five_id,sku.product_id,g.grade_id`
            const fginfo = await manager.query(fginfoQuery)

            const g2infoQuery = `SELECT SUM(total_cartons) AS totalCartons,SUM(total_pouches) AS totalPouches,SUM(loose_pouches) AS loosePouches,varient_id,sku.variant_code,g.grade_name,CONCAT(SUBSTRING(sku.short_code, 1, LENGTH(sku.short_code) - LOCATE('/', REVERSE(sku.short_code))), ' ', pm.packing_method_name) AS skuCode,s.pouch_weight as pouchWeight,uom.uom_name
            FROM ${appSettings.warehouse_db} .stock s
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = varient_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_five_types vf ON vf.value_addition_five_id = sku.value_addition_five_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm on pm.packing_method_id = s.pack_style_id 
            LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = s.uom_id
            WHERE (total_pouches > 0 OR loose_pouches > 0 ) AND STATUS != 'Cancelled' AND (vf.code ='GII' OR vf.code = 'BKN' OR vf.code = 'DC') AND CAST(s.date AS DATE) = '${req.date}'
            GROUP BY pm.packing_method_name,sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,
            sku.value_addition_four_id,sku.value_addition_five_id,sku.product_id,g.grade_id`
            const g2info = await manager.query(g2infoQuery)

            const otherProductsQuery = `SELECT SUM(total_cartons) AS totalCartons,SUM(total_pouches) AS totalPouches,SUM(loose_pouches) AS loosePouches,varient_id,sku.variant_code,g.grade_name,CONCAT(SUBSTRING(sku.short_code, 1, LENGTH(sku.short_code) - LOCATE('/', REVERSE(sku.short_code))), ' ', pm.packing_method_name) AS skuCode,s.pouch_weight as pouchWeight,uom.uom_name
            FROM ${appSettings.warehouse_db} .stock s
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = varient_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_five_types vf ON vf.value_addition_five_id = sku.value_addition_five_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm on pm.packing_method_id = s.pack_style_id 
            LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = s.uom_id
            WHERE (total_pouches > 0 OR loose_pouches > 0 ) AND STATUS != 'Cancelled' AND sku.variant_code IN (${updated}) AND CAST(s.date AS DATE) = '${req.date}'
            GROUP BY pm.packing_method_name,sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,
            sku.value_addition_four_id,sku.value_addition_five_id,sku.product_id,g.grade_id`
            const otherProductsInfo = await manager.query(otherProductsQuery)

            const inputDate = new Date(req.date)
            const year = inputDate.getFullYear();
            const month = String(inputDate.getMonth() + 1).padStart(2, '0');
            const day = String(inputDate.getDate()).padStart(2, '0');
            const fromDate = `${year}-${month}-1`
            const toDate = `${year}-${month}-${Number(day)+1}`

            const gettotalProductionQuery = `SELECT SUM(gi.quantity) as prodQty FROM ${appSettings.rm_procure_db} .grn_items gi LEFT JOIN ${appSettings.rm_procure_db} .grn g ON g.grn_id = gi.grn_id where g.grn_date between '${fromDate}' AND '${toDate}'` 
            const totalProductionQty = await manager.query(gettotalProductionQuery)
            
            let qtyInKgs = 0
            let qtyInLbs = 0

            if(jumbleinfo.length > 0 || fginfo.length > 0 || g2info.length > 0 || otherProductsInfo.length > 0){
                const jumbledataMap = new Map<string,StockStatementProductInfo>()
                // console.log(jumbleinfo,'jumbleInfo')
                // console.log(fginfo,'fginfo')
                // console.log(g2info,'g2info')
                for(const rec of jumbleinfo){
                    if(!jumbledataMap.has(rec.skuCode)){

                        let totalPouches = (Number(rec.totalPouches) * Number(rec.totalCartons)) + Number(rec.loosePouches)
                        if(rec.uom_name == 'KGS'){
                            qtyInKgs = totalPouches * Number(rec.pouchWeight)
                            qtyInLbs = 2.20462 * Number(qtyInKgs)
                        }else if(rec.uom_name == 'LBS'){
                            qtyInLbs = totalPouches * Number(rec.pouchWeight)
                            qtyInKgs = Number(qtyInLbs) / 2.20462
                        } else if(rec.uom_name == 'GMS'){
                            const gmtokg = Number(rec.pouchWeight) / 1000
                            qtyInKgs = totalPouches * Number(gmtokg)
                            qtyInLbs = 2.20462 * Number(qtyInKgs)
                        } else if(rec.uom_name == 'OZ'){
                            const oztolb = Number(rec.pouchWeight) / 16
                            qtyInLbs = totalPouches * Number(oztolb)
                            qtyInKgs = Number(qtyInLbs) / 2.20462
                        }

                        jumbledataMap.set(rec.skuCode,new StockStatementProductInfo(rec.skuCode,[]))
                    }
                    jumbledataMap.get(rec.skuCode).gradesInfo.push(new StockStatementGradesInfo(rec.grade_name,rec.totalCartons,rec.loosePouches))
                }
                const jumbledataModel: StockStatementProductInfo[] = []
                jumbledataMap.forEach(e => jumbledataModel.push(e))

                const fgdataMap = new Map<string,StockStatementProductInfo>()
                for(const rec of fginfo){
                    if(!fgdataMap.has(rec.skuCode)){

                        let totalPouches = (Number(rec.totalPouches) * Number(rec.totalCartons)) + Number(rec.loosePouches)
                        if(rec.uom_name == 'KGS'){
                            qtyInKgs = totalPouches * Number(rec.pouchWeight)
                            qtyInLbs = 2.20462 * Number(qtyInKgs)
                        }else if(rec.uom_name == 'LBS'){
                            qtyInLbs = totalPouches * Number(rec.pouchWeight)
                            qtyInKgs = Number(qtyInLbs) / 2.20462
                        } else if(rec.uom_name == 'GMS'){
                            const gmtokg = Number(rec.pouchWeight) / 1000
                            qtyInKgs = totalPouches * Number(gmtokg)
                            qtyInLbs = 2.20462 * Number(qtyInKgs)
                        } else if(rec.uom_name == 'OZ'){
                            const oztolb = Number(rec.pouchWeight) / 16
                            qtyInLbs = totalPouches * Number(oztolb)
                            qtyInKgs = Number(qtyInLbs) / 2.20462
                        }

                        fgdataMap.set(rec.skuCode,new StockStatementProductInfo(rec.skuCode,[]))
                    }
                    fgdataMap.get(rec.skuCode).gradesInfo.push(new StockStatementGradesInfo(rec.grade_name,rec.totalCartons,rec.loosePouches))
                }
                const fgdataModel: StockStatementProductInfo[] = []
                fgdataMap.forEach(e => fgdataModel.push(e))

                const g2dataMap = new Map<string,StockStatementProductInfo>()
                for(const rec of g2info){
                    if(!g2dataMap.has(rec.skuCode)){

                        let totalPouches = (Number(rec.totalPouches) * Number(rec.totalCartons)) + Number(rec.loosePouches)
                        if(rec.uom_name == 'KGS'){
                            qtyInKgs = totalPouches * Number(rec.pouchWeight)
                            qtyInLbs = 2.20462 * Number(qtyInKgs)
                        }else if(rec.uom_name == 'LBS'){
                            qtyInLbs = totalPouches * Number(rec.pouchWeight)
                            qtyInKgs = Number(qtyInLbs) / 2.20462
                        } else if(rec.uom_name == 'GMS'){
                            const gmtokg = Number(rec.pouchWeight) / 1000
                            qtyInKgs = totalPouches * Number(gmtokg)
                            qtyInLbs = 2.20462 * Number(qtyInKgs)
                        } else if(rec.uom_name == 'OZ'){
                            const oztolb = Number(rec.pouchWeight) / 16
                            qtyInLbs = totalPouches * Number(oztolb)
                            qtyInKgs = Number(qtyInLbs) / 2.20462
                        }

                        g2dataMap.set(rec.skuCode,new StockStatementProductInfo(rec.skuCode,[]))
                    }
                    g2dataMap.get(rec.skuCode).gradesInfo.push(new StockStatementGradesInfo(rec.grade_name,rec.totalCartons,rec.loosePouches))
                }
                const g2dataModel: StockStatementProductInfo[] = []
                g2dataMap.forEach(e => g2dataModel.push(e))

                const otherProductsDataMap = new Map<string,StockStatementProductInfo>()
                for(const rec of otherProductsInfo){
                    if(!otherProductsDataMap.has(rec.skuCode)){

                        let totalPouches = (Number(rec.totalPouches) * Number(rec.totalCartons)) + Number(rec.loosePouches)
                        if(rec.uom_name == 'KGS'){
                            qtyInKgs = totalPouches * Number(rec.pouchWeight)
                            qtyInLbs = 2.20462 * Number(qtyInKgs)
                        }else if(rec.uom_name == 'LBS'){
                            qtyInLbs = totalPouches * Number(rec.pouchWeight)
                            qtyInKgs = Number(qtyInLbs) / 2.20462
                        } else if(rec.uom_name == 'GMS'){
                            const gmtokg = Number(rec.pouchWeight) / 1000
                            qtyInKgs = totalPouches * Number(gmtokg)
                            qtyInLbs = 2.20462 * Number(qtyInKgs)
                        } else if(rec.uom_name == 'OZ'){
                            const oztolb = Number(rec.pouchWeight) / 16
                            qtyInLbs = totalPouches * Number(oztolb)
                            qtyInKgs = Number(qtyInLbs) / 2.20462
                        }

                        otherProductsDataMap.set(rec.skuCode,new StockStatementProductInfo(rec.skuCode,[]))
                    }
                    otherProductsDataMap.get(rec.skuCode).gradesInfo.push(new StockStatementGradesInfo(rec.grade_name,rec.totalCartons,rec.loosePouches))
                }
                const otherProductsdataModel: StockStatementProductInfo[] = []
                otherProductsDataMap.forEach(e => otherProductsdataModel.push(e))

                const finalData = new StockStatementModel(fgdataModel,jumbledataModel,g2dataModel,otherProductsdataModel,totalProductionQty[0].prodQty,qtyInKgs)
                return  new StockStatementResponseModel(true,1,'Data retrieved',finalData)
            }else{
                return new StockStatementResponseModel(false,0,'No data found')
            }


        }catch(err){
            throw err
        }
    }

    async getProductionAnalysisInfo(req:ProductAnalysisReq):Promise<ProductAnalysisResponseModel>{
        try{
            const manager = getManager()
            
            let toDate = new Date(req.toDate);
            toDate.setDate(toDate.getDate() + 1);
            req.toDate = moment(toDate).format('YYYY-MM-DD')

            const iqfProductInfoQuery = `SELECT SUM(total_pouches) as pouches,SUM(loose_pouches) as loosePouches,s.varient_id,variant_code,short_code,hon_to_fg_yield,packing_method_name,no_of_pouches,pouches_per_row,uom.uom_name,
            CONCAT(SUBSTRING(sku.short_code, 1, LENGTH(sku.short_code) - LOCATE('/', REVERSE(sku.short_code))), ' ', pm.packing_method_name) AS skuCode,g.grade_name,val.name,vone.code as voneCode,soi.gross_weight_per_kg AS grossWeightPerKg
            FROM ${appSettings.warehouse_db} .stock s
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = s.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = pm.uom_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_four_types val ON val.value_addition_four_id = sku.value_addition_four_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_one_types vone ON vone.value_addition_one_id = sku.value_addition_one_id
            LEFT JOIN ${appSettings.sales_db} .sale_order_items soi ON soi.sale_order_item_id = s.sale_order_item_id
            WHERE val.code IN ('IQF','IQF/JB') AND s.date BETWEEN '${req.fromDate}' AND '${req.toDate}'
            GROUP BY pm.packing_method_name,sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,
            sku.value_addition_four_id,sku.value_addition_five_id,sku.product_id,g.grade_id`
            const iqfProductInfo = await manager.query(iqfProductInfoQuery)

            const blockProductInfoQuery = `SELECT SUM(total_pouches) as pouches,SUM(loose_pouches) as loosePouches,s.varient_id,variant_code,short_code,hon_to_fg_yield,packing_method_name,no_of_pouches,pouches_per_row,uom.uom_name,
            CONCAT(SUBSTRING(sku.short_code, 1, LENGTH(sku.short_code) - LOCATE('/', REVERSE(sku.short_code))), ' ', pm.packing_method_name) AS skuCode,g.grade_name,val.name,vone.code as voneCode,soi.gross_weight_per_kg AS grossWeightPerKg
            FROM ${appSettings.warehouse_db} .stock s
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = s.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = pm.uom_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_four_types val ON val.value_addition_four_id = sku.value_addition_four_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_one_types vone ON vone.value_addition_one_id = sku.value_addition_one_id
            LEFT JOIN ${appSettings.sales_db} .sale_order_items soi ON soi.sale_order_item_id = s.sale_order_item_id
            WHERE val.code IN ('BLK','BLK/JB') AND s.date BETWEEN '${req.fromDate}' AND '${req.toDate}'
            GROUP BY pm.packing_method_name,sku.food_type_id,sku.value_addition_one_id,sku.value_addition_two_id,sku.value_addition_three_id,
            sku.value_addition_four_id,sku.value_addition_five_id,sku.product_id,g.grade_id`
            const blockProductInfo = await manager.query(blockProductInfoQuery)

            const totalsQuery = `SELECT SUM(total_pouches + loose_pouches) AS slabs, SUM(pouches_per_row * (total_pouches+loose_pouches)) AS netWeight,
            SUM((total_pouches+loose_pouches)*(no_of_pouches)) AS grossWeight,SUM(((total_pouches+loose_pouches)*pouches_per_row)/(hon_to_fg_yield)) AS hoWeight,
            (SUM((total_pouches+loose_pouches)*(no_of_pouches)) / (SUM(((total_pouches+loose_pouches)*pouches_per_row)/(hon_to_fg_yield)))) AS productionPer
            FROM ${appSettings.warehouse_db} .stock s
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = s.pack_style_id
            WHERE s.date BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            const totalsInfo = await manager.query(totalsQuery) 

            const productionQtyQuery = `SELECT SUM(gi.quantity) AS qty,SUM(gi.reweighment_quantity) AS reweighmentQty FROM ${appSettings.rm_procure_db} .grn_items gi
            LEFT JOIN ${appSettings.rm_procure_db} .grn g on g.grn_id = gi.grn_id
            WHERE g.grn_date BETWEEN '${req.fromDate}' AND '${req.toDate}'`
            const productionQtyInfo = await manager.query(productionQtyQuery)

            let honProdcution = 0

            const iqfProductMap = new Map<string,MISProductsInfo>()
            // console.log(iqfProductInfo,'iqfProductInfo')
            for(const rec of iqfProductInfo){
                // console.log(rec,'rec')
                const slabs = Number(rec.pouches) + Number(rec.loosePouches)
                // console.log(slabs,'===')
                let pouchWeight
                if(rec.uom_name == 'GMS'){
                    pouchWeight = Number(rec.pouches_per_row) / 1000
                }else if(rec.uom_name == 'LBS'){
                    pouchWeight = Number(rec.pouches_per_row) * 0.454
                } else if(rec.uom_name == 'OZ'){
                    pouchWeight = (Number(rec.pouches_per_row) / 16) * 0.454
                } else{
                    pouchWeight = Number(rec.pouches_per_row)
                }
                const grossWeightPerKg = rec.grossWeightPerKg ? rec.grossWeightPerKg : 0
                const grossWeight = Number(slabs) * Number(grossWeightPerKg)
                const netWeight = Number(slabs) * Number(pouchWeight)
                const hoWeight = Number(grossWeight) / (Number(rec.hon_to_fg_yield) * 100)
                const yieldPer = (Number(grossWeight) / Number(hoWeight)) * 100
                const productionPer = Number(grossWeight) / ((totalsInfo[0].grossWeight) * 100)
                if(rec.voneCode == 'HOSO'){
                    honProdcution += rec.hoWeight
                }
                if(!iqfProductMap.has(rec.skuCode)){
                    iqfProductMap.set(rec.skuCode,new MISProductsInfo(rec.skuCode,slabs,pouchWeight,Number(netWeight),Number(grossWeight),Number(yieldPer),Number(hoWeight),Number(productionPer)))
                    // console.log(iqfProductMap,'iqfProductMap')
                }else{
                    const headOnWeight = Number(iqfProductMap.get(rec.skuCode).totalEquivalentHeadOnWeight) + hoWeight
                    const totGrossWeight = Number(iqfProductMap.get(rec.skuCode).grossTotalWeight) + grossWeight
                    iqfProductMap.get(rec.skuCode).noOfSlabs = Number(iqfProductMap.get(rec.skuCode).noOfSlabs) + slabs
                    iqfProductMap.get(rec.skuCode).weightPerSlab = Number(iqfProductMap.get(rec.skuCode).weightPerSlab) + Number(pouchWeight)
                    iqfProductMap.get(rec.skuCode).netTotalWeight = Number(iqfProductMap.get(rec.skuCode).netTotalWeight) + netWeight
                    iqfProductMap.get(rec.skuCode).grossTotalWeight = Number(iqfProductMap.get(rec.skuCode).grossTotalWeight) + grossWeight
                    iqfProductMap.get(rec.skuCode).totalEquivalentHeadOnWeight = Number(iqfProductMap.get(rec.skuCode).totalEquivalentHeadOnWeight) + hoWeight
                    iqfProductMap.get(rec.skuCode).yieldPer =  (Number(totGrossWeight) / Number(headOnWeight))* 100
                    iqfProductMap.get(rec.skuCode).produciton = Number(totGrossWeight) / ((totalsInfo[0].grossWeight) * 100)

                }

            }
            const iqfModel: MISProductsInfo[] = []
            iqfProductMap.forEach(e=> {
                iqfModel.push(e)
            })

            const blockProductMap = new Map<string,MISProductsInfo>()
            for(const rec of blockProductInfo){
                // console.log(rec,'recblock')
                const slabs = Number(rec.pouches) + Number(rec.loosePouches)
                let pouchWeight
                if(rec.uom_name == 'GMS'){
                    pouchWeight = Number(rec.pouches_per_row) / 1000
                }else if(rec.uom_name == 'LBS'){
                    pouchWeight = Number(rec.pouches_per_row) / 2.20462
                } else if(rec.uom_name == 'OZ'){
                    pouchWeight = (Number(rec.pouches_per_row) / 16) / 2.20462
                } else{
                    pouchWeight = Number(rec.pouches_per_row)
                }
                const grossWeightPerKg = rec.grossWeightPerKg ? rec.grossWeightPerKg : 0
                const grossWeight = Number(slabs) * Number(grossWeightPerKg)
                const netWeight = Number(slabs) * Number(pouchWeight)
                const hoWeight = Number(grossWeight) / (Number(rec.hon_to_fg_yield) * 100)
                const yieldPer = (Number(grossWeight) / Number(hoWeight)) * 100
                const productionPer = Number(grossWeight) / ((totalsInfo[0].grossWeight) * 100)
                if(rec.voneCode == 'HOSO'){
                    honProdcution += rec.hoWeight
                }
                if(!blockProductMap.has(rec.skuCode)){
                    blockProductMap.set(rec.skuCode,new MISProductsInfo(rec.skuCode,slabs,pouchWeight,netWeight,grossWeight,yieldPer,hoWeight,productionPer))
                }else{
                    const headOnWeight = Number(blockProductMap.get(rec.skuCode).totalEquivalentHeadOnWeight) + hoWeight
                    const totGrossWeight = Number(blockProductMap.get(rec.skuCode).grossTotalWeight) + grossWeight
                    blockProductMap.get(rec.skuCode).noOfSlabs = Number(blockProductMap.get(rec.skuCode).noOfSlabs) + slabs
                    blockProductMap.get(rec.skuCode).weightPerSlab = Number(blockProductMap.get(rec.skuCode).weightPerSlab) + Number(pouchWeight)
                    blockProductMap.get(rec.skuCode).netTotalWeight = Number(blockProductMap.get(rec.skuCode).netTotalWeight) + netWeight
                    blockProductMap.get(rec.skuCode).grossTotalWeight = Number(blockProductMap.get(rec.skuCode).grossTotalWeight) + grossWeight
                    blockProductMap.get(rec.skuCode).totalEquivalentHeadOnWeight = Number(blockProductMap.get(rec.skuCode).totalEquivalentHeadOnWeight) + hoWeight
                    blockProductMap.get(rec.skuCode).yieldPer =  (Number(totGrossWeight) / Number(headOnWeight))* 100
                    blockProductMap.get(rec.skuCode).produciton = Number(totGrossWeight) / ((totalsInfo[0].hoWeight) * 100)

                }
            }
            const blockModel: MISProductsInfo[] = []
            blockProductMap.forEach(e=> {
                blockModel.push(e)
            })

            const info = new ProductAnalysisModel(productionQtyInfo[0].qty,productionQtyInfo[0].reweighmentQty,Number(productionQtyInfo[0].reweighmentQty) - Number(productionQtyInfo[0].qty),honProdcution,(Number(productionQtyInfo[0].reweighmentQty) - Number(honProdcution) ),0,0,totalsInfo[0].slabs,totalsInfo[0].netWeight,totalsInfo[0].grossWeight,totalsInfo[0].hoWeight,totalsInfo[0].productionPer,Number(totalsInfo[0].hoWeight) - Number(productionQtyInfo[0].qty),0,0,0,iqfModel,blockModel)

            return new ProductAnalysisResponseModel(true,1,'Data retrieved',info)

        }catch(err){
            throw err
        }
    }

    async getDayWiseProdcutionReport(req : DayWiseProductionReq):Promise<DaywiseProductionResponseModel>{
        try{
            const manager = getManager()
            const date = new Date()
            let getQuery = `SELECT r.lot_code,r.sale_order_id,r.sale_order_item_id,r.variant_id,inv.buyer_po_number,gi.plant_lot_number as batch_number,sku.variant_code,sku.short_code,grade.grade_name, pm.packing_method_name,ec.end_customer_code,ec.end_customer_name,so.enquiry_id,cs.quantity,cs.yield,cs.pack_count,cs.rm_count,cs.rm_rate,cs.rm_cost,cs.mfg_cost,cs.freight_and_forward_exp,cs.pack_material_cost,cs.incentives,cs.net_pl_on_buyer_price,cs.final_profit_loss
            FROM ${appSettings.warehouse_db} .reporting r 
            LEFT JOIN ${appSettings.sales_db} .so_invoice_details inv ON inv.sale_order_id = r.sale_order_id
            LEFT JOIN ${appSettings.sales_db} .sale_order so ON so.sale_order_id = r.sale_order_id
            LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.lot_number = r.lot_code
            LEFT JOIN ${appSettings.rm_procure_db} .grn g ON g.grn_id = gi.grn_id
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = r.variant_id
            LEFT JOIN ${appSettings.masters_db} .grades grade ON grade.grade_id = sku.grade_id 
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .end_customers ec ON ec.end_customer_id = inv.end_customer_id
            LEFT JOIN ${appSettings.enquiry_db} .cost_sheet cs ON cs.enquiry_id = so.enquiry_id AND cs.variant_id = r.variant_id
            WHERE r.reporting_log_id > 0 `
            if(req.fromDate != undefined){
                getQuery += ` AND DATE(reporting_date) BETWEEN '${moment(req.fromDate).format('YYYY-MM-DD')}' AND '${moment(req.toDate).format('YYYY-MM-DD')}'`
            }else{
                getQuery += ` AND DATE(reporting_date) = '${moment(date).format('YYYY-MM-DD')}'`
            }
            const queryData = await manager.query(getQuery)
            const info = []
            if(queryData.length > 0){
                for(const rec of queryData){
                    const totalCostOfSales = Number(rec.rm_cost) + Number(rec.mfg_cost) + Number(rec.pack_material_cost) + Number(rec.freight_and_forward_exp)
                    const inInr = Number(totalCostOfSales) * Number(rec.quantity)
                    const costOfSalesPerLbKgInUsd = Number(totalCostOfSales) / 82 * 0.454
                    info.push(new DaywiseProductionModel(rec.batch_number,rec.short_code,rec.grade_name,rec.packing_method_name,rec.buyer_po_number,rec.end_customer_name,rec.quantity,rec.yield,rec.pack_count,rec.rm_count,rec.rm_rate,rec.rm_cost,rec.mfg_cost,rec.pack_material_cost,rec.freight_and_forward_exp,totalCostOfSales,inInr,costOfSalesPerLbKgInUsd,0,0,rec.incentives,0))
                }
                return new DaywiseProductionResponseModel(true,1,'Data retrieved',info)
            }else{
                return new DaywiseProductionResponseModel(false,0,'No data found',[])
            }

        }catch(err){
            throw err
        }
    }

    async getTodayStockInInfo(req:UnitRequest):Promise<CommonResponse>{
        const manager = getManager()
        try{
            let date = Date.now()
            let infoQuery = `SELECT r.reporting_date as reportedDate, r.reported_cases as masterCartons,r.loose_pouches as loosePouches,r.lot_code as lotCode,r.stock_type as stockType,r.transaction_type as transactionType,sku.short_code as shortCode,inv.po_number as poNumber,r.unit_id as unitId,r.package_type as packageType,r.tare_weight as tareWeight,r.quantity
            FROM ${appSettings.warehouse_db} .reporting r
            LEFT JOIN ${appSettings.sales_db} .so_invoice_details inv ON inv.sale_order_id = r.sale_order_id
            LEFT JOIN ${appSettings.sales_db} .sale_order_items soi ON soi.sale_order_item_id = r.sale_order_item_id
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = soi.varient_id
            WHERE DATE(r.created_at) = '${moment(date).format('YYYY-MM-DD')}'`
            if(req.unitId != undefined){
                infoQuery += ` and r.unit_id = ${req.unitId}`   
            }
            if(req.stockInType != undefined){
                infoQuery += ` and r.stock_in_type = '${req.stockInType}'`
            }
            const info = await manager.query(infoQuery)
            if(info.length > 0){
                return new CommonResponse(true,1,'Data retrieved successfully',info)
            }else{
                return new CommonResponse(false,0,'No data found')
            }

        }catch(err){
            throw err
        }
    }

    async getReportedQtyAgainstJob(req:JobIdRequest):Promise<CommonResponse>{
        const manager = getManager()
        try{
            // const infoQuery = `            
            // SELECT ROUND(SUM(
            // (IF(uom_name = 'LBS' , (((reported_cases * no_of_pouches * pouches_per_row)+(loose_pouches * pouches_per_row)) * 0.454),
            // IF(uom_name = 'OZ' ,((((reported_cases * no_of_pouches * pouches_per_row)+(loose_pouches * pouches_per_row)) / 16 ) * 0.454),
            // IF(uom_name = 'GMS' ,(((reported_cases * no_of_pouches * pouches_per_row)+(loose_pouches * pouches_per_row)) / 1000),
            // (((reported_cases * no_of_pouches * pouches_per_row)+(loose_pouches * pouches_per_row)))))))),2) AS quantity
            //  FROM reporting r
            // LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            // LEFT JOIN ${appSettings.masters_db} .uoms uom ON uom.uom_id = pm.uom_id
            // WHERE job_id = ${req.jobId}`
            const infoQuery = `            
            SELECT (reported_cases * no_of_pouches * pouches_per_row)+(loose_pouches * pouches_per_row) AS quantity
             FROM reporting r
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            WHERE job_id = ${req.jobId}`
            const info = await manager.query(infoQuery)
            if(info.length > 0){
                return new CommonResponse(true,1,'Data retrieved',info)
            }else{
                return new CommonResponse(false,0,'No data found')
            }

        }catch(err){
            throw err
        }
    }

    // async getContainerWiseAbstract(req:ContainerWiseAbstractReq):Promise<ContainerWiseAbstractResponseModel>{
    //     try{
    //         const manager = getManager()
    //         const date = `${req.year}-${req.month.toString().padStart(2, '0')}-01`
    //         const infoQuery = `SELECT sinv.po_number as poNumber,ec.end_customer_name as buyer,sku.short_code as shortCode,g.grade_name as grade,pm.packing_method_name as packStyle,cou.country_name as country,e.enquiry_number as enquiryNumber,ep.enquiry_product_id,
    //         cs.exchange_rate as exchangeRate,cs.rm_count as rmCount,cs.rm_rate as rmRate,cs.rm_cost as rmCost,cs.mfg_cost as mfgCost,cs.fixed_cost as fixedCost,cs.pack_material_cost as packingCost,cs.freight_and_forward_exp as freightAndForwardingCost,cs.total_expenses as totalExpenses,
    //         cs.cost_of_sales_inr,cs.cost_of_sales_usd_kg,cs.cost_of_sales_usd_lb,cs.total_sale_cost as totalCostOfSales,cs.net_pl_on_buyer_price,cs.incentives as incentives,cs.pl_percentage as plPercentage,
    //         cs.final_profit_loss as totalPL,soi.net_weight,ep.confirmed_containers as confirmedContainers,soi.addon_product
    //         FROM ${appSettings.sales_db} .sale_order_items soi
    //         LEFT JOIN ${appSettings.sales_db} .sale_order so ON so.sale_order_id = soi.sale_order_id
    //         LEFT JOIN ${appSettings.sales_db} .so_invoice_details sinv ON sinv.sale_order_id = so.sale_order_id
    //         LEFT JOIN ${appSettings.masters_db} .end_customers ec ON ec.end_customer_id = sinv.end_customer_id
    //         LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = soi.varient_id
    //         LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
    //         LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = soi.pack_style_id
    //         LEFT JOIN ${appSettings.masters_db} .countries cou ON cou.country_id = sinv.country_id
    //         LEFT JOIN ${appSettings.enquiry_db} .enquiries e ON e.enquiry_id = so.enquiry_id
    //         LEFT JOIN ${appSettings.enquiry_db} .enquiry_products ep ON ep.enquiry_id = e.enquiry_id AND ep.variant_id = soi.varient_id 
    //         AND ep.pack_style_id = soi.pack_style_id AND ep.brand_id = soi.brand_id AND ep.style_weighment = soi.style_weighment
    //         LEFT JOIN ${appSettings.enquiry_db} .cost_sheet cs ON cs.enquiry_product_id = ep.enquiry_product_id
    //         WHERE so.enquiry_id IS NOT NULL AND YEAR(soi.created_at) = '${req.year}' AND MONTH(soi.created_at) = '${req.month}'
    //         GROUP BY soi.sale_order_item_id`
    //         const info = await manager.query(infoQuery)

    //         const containerAbstractInfo = []

    //         if(info.length > 0){
    //             const countryWiseMap = new Map<string,CountryWiseAbstract>()
    //             for(const rec of info){
    //                 if(!countryWiseMap.has(rec.country)){
    //                     countryWiseMap.set(rec.country,new CountryWiseAbstract(rec.country,rec.confirmedContainers,rec.totalPL))
    //                 }else{
    //                     const nooffcl = countryWiseMap.get(rec.country).noOfFcl
    //                     const pl = countryWiseMap.get(rec.country).plInInr
    //                     countryWiseMap.get(rec.country).noOfFcl = Number(nooffcl) + Number(rec.confirmedContainers)
    //                     countryWiseMap.get(rec.country).plInInr = Number(pl) + Number(rec.totalPL)
    //                 }
    //                 containerAbstractInfo.push(new ContainerWiseAbstract(rec.poNumber,rec.buyer,rec.shortCode,rec.grade,rec.country,rec.packStyle,rec.totalQty,rec.exchangeRate,rec.rmCount,rec.rmRate,rec.rmCost,rec.mfgCost,rec.fixedCost,rec.packingCost,rec.freightAndForwardingCost,rec.totalExpenses,rec.totalCostOfSales,rec.costOfSalesPerLbKgUsd,rec.exportRate,rec.plPercentage,rec.incentives,rec.totalInUsdPLPerLbKg,rec.totalPL))
    //             }

    //             const countryWiseAbstractInfo = []
    //             countryWiseMap.forEach(e => {countryWiseAbstractInfo.push(e) })
    //             const abstractInfo = new ContainerWiseAbstractModel(containerAbstractInfo,countryWiseAbstractInfo)
    //             return new ContainerWiseAbstractResponseModel(true,1,'Data retrieved',abstractInfo)
    //         }else{
    //             return new ContainerWiseAbstractResponseModel(false,0,'No data found',null)
    //         }

    //     }catch(err){
    //         throw err
    //     }
    // }

    async getContainerWiseAbstract(req:ContainerWiseAbstractReq):Promise<ContainerWiseAbstractResponseModel>{
        try{
            const manager = getManager()
    

                const infoQuery = `SELECT pca.po_number AS poNumber,pca.end_customer AS buyer,pca.grade AS grade,pca.pack_style AS packStyle,pca.country AS country,
                pca.exchange_rate AS exchangeRate,SUM(pca.rm_count) AS rmCount,SUM(pca.rm_rate) AS rmRate,SUM(pca.rm_cost) AS rmCost,SUM(pca.mfg_cost) AS mfgCost,
                SUM(pca.packing_cost) AS packingCost,SUM(pca.freight_frwd_cost) AS freightAndForwardingCost,SUM(pca.sale_cost_kg_usd) AS sale_cost_kg_usd ,SUM(pca.sale_cost_lb_usd) AS sale_cost_lb_usd,
                SUM(pca.sale_cost_kg_inr) AS sale_cost_kg_inr,SUM(pca.incentives) AS incentives,SUM(pca.profit_loss) AS totalPL,SUBSTRING(pca.variant, 1, LENGTH(pca.variant) - LOCATE('-', REVERSE(pca.variant))) AS shortCode,SUM(pca.fg_qty_kgs) AS totalQty,
                SUM(pca.mfg_cost + pca.packing_cost + pca.freight_frwd_cost) AS totalExpenses,
                SUM((pca.mfg_cost + pca.packing_cost + pca.freight_frwd_cost) + pca.rm_cost) AS totalCostOfSales,pca.sale_price AS exportRate,pca.total_pl AS totalPLinINR,SUM(pca.incentives + pca.profit_loss) AS TotalINUSDPLper,
                SUM(enqProd.confirmed_containers) AS noOfFCL,so.enquiry_id,enq.enquiry_number
                FROM ${appSettings.analytics_db}.production_cost_analysis pca
                LEFT JOIN ${appSettings.sales_db}.sale_order so ON so.sale_order_id = pca.sale_order_id
                LEFT JOIN ${appSettings.enquiry_db}.enquiries enq ON enq.enquiry_id = so.enquiry_id
                LEFT JOIN ${appSettings.enquiry_db}.enquiry_products enqProd ON enqProd.enquiry_id = enq.enquiry_id
                WHERE YEAR(pca.reported_date) = ${req.year} AND MONTH(pca.reported_date) = ${req.month}
                GROUP BY pca.pack_style,pca.grade,pca.country,pca.product,pca.inv_num,pca.end_customer`


            const info = await manager.query(infoQuery)

            

            const containerAbstractInfo = []

            if(info.length > 0){
                const countryWiseMap = new Map<string,CountryWiseAbstract>()
                for(const rec of info){
                    if(!countryWiseMap.has(rec.country)){
                        countryWiseMap.set(rec.country,new CountryWiseAbstract(rec.country,rec.noOfFCL,rec.totalPL))
                    }else{
                        const nooffcl = countryWiseMap.get(rec.country).noOfFcl
                        const pl = countryWiseMap.get(rec.country).plInInr
                        countryWiseMap.get(rec.country).noOfFcl = rec.noOfFCL
                        countryWiseMap.get(rec.country).plInInr = rec.totalPL
                    }
                    containerAbstractInfo.push(new ContainerWiseAbstract(rec.poNumber,rec.buyer,rec.shortCode,rec.grade,rec.country,rec.packStyle,rec.totalQty,rec.exchangeRate,rec.rmCount,rec.rmRate,rec.rmCost,rec.mfgCost,null,rec.packingCost,rec.freightAndForwardingCost,rec.totalExpenses,rec.totalCostOfSales,rec.sale_cost_lb_usd,rec.exportRate,rec.totalPL,rec.incentives,rec.TotalINUSDPLper,rec.totalPLinINR))
                }

                const countryWiseAbstractInfo = []
                countryWiseMap.forEach(e => {countryWiseAbstractInfo.push(e) })
                const abstractInfo = new ContainerWiseAbstractModel(containerAbstractInfo,countryWiseAbstractInfo)
                return new ContainerWiseAbstractResponseModel(true,1,'Data retrieved',abstractInfo)
            }else{
                return new ContainerWiseAbstractResponseModel(false,0,'No data found',null)
            }

        }catch(err){
            throw err
        }
    }




    @Cron('0 1 * * *')
    async updateProductionCostAnalysis():Promise<CommonResponse>{
        const manager = getManager()
        const transmanager = new GenericTransactionManager();
        try{

            const date = new Date();
            let month = Number(date.getMonth()) + 1;
            const mfgCost = `SELECT e.month,SUM(amount) AS price,e.year FROM ${appSettings.finance_db} .expenses e WHERE category IN('Procurement Freight','LABOUR CHARGES','PROCESSING CHARGES','Electrical cost',
            'SOLAR UNITS INCOME','PACKING MAT','SALT & CHEM','QC COST','CONSUMABLES','OTHER DIR EXP','SALARIES','Finance cost','Depreciation','INSURANCE','ADMIN','Forwarding Expenses')
            GROUP BY e.month , e.year`;
            const mfgCostData = await manager.query(mfgCost)
            const mfgCostDatmap = new Map<any,any>()
            for(const rec of mfgCostData){
                if(!mfgCostDatmap.has(JSON.stringify({month:rec.month,year:rec.year}))){
                    mfgCostDatmap.set(JSON.stringify({month:rec.month,year:rec.year}),rec)
                }
                // mfgCostDatmap.get(rec.month).push(rec)
            }
            // console.log(mfgCostDatmap,'mfgCostData')

            const forwExpQuery = `SELECT e.month,amount,e.year FROM ${appSettings.finance_db} .expenses e WHERE category = 'Forwarding Expenses' GROUP BY e.month, e.year`
            const forwExpData = await manager.query(forwExpQuery)
            const forwExpDataMap = new Map<any,any>()
            for(const rec of forwExpData){
                if(!forwExpDataMap.has(JSON.stringify({month:rec.month,year:rec.year}))){
                    forwExpDataMap.set(JSON.stringify({month:rec.month,year:rec.year}),rec)
                }
                // forwExpDataMap.get(rec.month).push(rec)
            }
            // console.log(forwExpDataMap,'forwExpData')


            const prevailingMarketRateQuery = `select min_price,product_id from ${appSettings.masters_db} .product_price_list where category = 'EXPORT'`
            // console.log('okk')
            const prevailingMarketRateData = await manager.query(prevailingMarketRateQuery)
            const prevailingMarketRateMap = new Map<number,any>()
            for(const rec of prevailingMarketRateData){
                prevailingMarketRateMap.set(rec.product_id,rec.min_price)
            }
            // console.log(prevailingMarketRateMap,'prevailingMarketRateMap')
            const prevOrderQuery = `SELECT soi.varient_id,(soi.cases * soi.pouches * soi.pouch_weight) AS qty,soi.unitPrice,(soi.cases * soi.pouches * soi.pouch_weight * soi.unitPrice) as amount  FROM ${appSettings.sales_db} .sale_order_items  soi
            LEFT JOIN ${appSettings.sales_db} .sale_order so ON so.sale_order_id = soi.sale_order_id
            WHERE so.status != 'CLOSED' AND soi.unitPrice > 0`
            const prevOrderData = await manager.query(prevOrderQuery)
            const prevOrderMap = new Map<number,any>()
            for(const rec of prevOrderData){
                if(!prevOrderMap.has(rec.varient_id)){
                    prevOrderMap.set(rec.varient_id,{'quantity':Number(rec.qty),'amount':Number(rec.amount)})
                }else{
                    const prevQty = prevOrderMap.get(rec.varient_id).quantity
                    const prevAmt = prevOrderMap.get(rec.varient_id).amount
                    prevOrderMap.get(rec.varient_id).quantity = Number(prevQty) + Number(rec.qty)
                    prevOrderMap.get(rec.varient_id).amount = Number(prevAmt) + Number(rec.amount)
                }
            }
            // console.log(prevOrderMap,'prevOrderMap')
            const prevShippedQuery = `SELECT soi.varient_id,(soi.cases * soi.pouches * soi.pouch_weight) AS qty,soi.unitPrice,(soi.cases * soi.pouches * soi.pouch_weight * soi.unitPrice) as amount  FROM ${appSettings.sales_db} .sale_order_items  soi
            LEFT JOIN ${appSettings.sales_db} .sale_order so ON so.sale_order_id = soi.sale_order_id
            WHERE so.status = 'CLOSED' AND soi.unitPrice > 0`
            const prevShippedData = await manager.query(prevShippedQuery)
            const prevShippedMap = new Map<number,any>()
            for(const rec of prevShippedData){
                if(!prevShippedMap.has(rec.varient_id)){
                    prevShippedMap.set(rec.varient_id,{'quantity':Number(rec.qty),'amount':Number(rec.amount)})
                }else{
                    const prevQty = prevShippedMap.get(rec.varient_id).quantity
                    const prevAmt = prevShippedMap.get(rec.varient_id).amount
                    prevShippedMap.get(rec.varient_id).quantity = Number(prevQty) + Number(rec.qty)
                    prevShippedMap.get(rec.varient_id).amount = Number(prevAmt) + Number(rec.amount)
                }
            }
            // console.log(prevShippedMap,'prevShippedMap')

            // const reportingPricesQry = `SELECT r.variant_id,r.lot_code,gi.count,gi.price as price,r.stock_id FROM ${appSettings.warehouse_db} .reporting r LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.plant_lot_number = r.lot_code GROUP BY r.lot_code,r.variant_id`
            // const reportingPrices = await manager.query(reportingPricesQry)
            // const reportingPricesMap = new Map<string,any>()
            // for(const rec of reportingPrices){
            //     // if(!reportingPricesMap.has(rec.stock_id)){
            //     //     reportingPricesMap.set(rec.stock_id,{price:rec.price,total:1})
            //     // }else{
            //     //     let price = reportingPricesMap.get(rec.stock_id).price
            //     //     let total = reportingPricesMap.get(rec.stock_id).total
            //     //     reportingPricesMap.get(rec.stock_id).price = price
            //     //     reportingPricesMap.get(rec.stock_id).total = Number(total) + 1
            //     // }
            //     // if(rec.lot_code == 'LOT-N/A'){
            //     //     rec.price = 0
            //     // }
            //     if(rec.lot_code != 'LOT-N/A'){
                   
            //         if(!reportingPricesMap.has(rec.variant_id)){
            //             reportingPricesMap.set(rec.variant_id,{price:rec.price,total:1})
            //             // if(rec.variant_id == 186){
            //             //     console.log(rec.price,'========price')
            //             //     console.log(reportingPricesMap,'************************===******************************')
            //             // }
            //         }else{
            //             let price = reportingPricesMap.get(rec.variant_id).price
            //             let total = reportingPricesMap.get(rec.variant_id).total
            //             // if(rec.variant_id == 186){
            //             //     console.log(price,'************************---******************************',total)
            //             // }
            //             reportingPricesMap.set(rec.variant_id,{price:Number(price) + Number(rec.price),total:Number(total) + 1}) 
            //         }
            //         // if(rec.variant_id == 186){
            //         //     console.log(reportingPricesMap,'******************************************************')
            //         // }
            //     }
            // }

            const reportingPricesQry = `SELECT r.variant_id,r.lot_code,inv.unit_price as price FROM ${appSettings.warehouse_db} .reporting r LEFT JOIN ${appSettings.rm_procure_db} .rm_invoice inv ON inv.batch_number = r.lot_code GROUP BY r.lot_code`
            const reportingPrices = await manager.query(reportingPricesQry)
            const reportingPricesMap = new Map<string,any>()
            for(const rec of reportingPrices){
                if(!(reportingPricesMap.has(rec.lot_code))){
                    reportingPricesMap.set(rec.lot_code,rec)
                }
            }

            // console.log(reportingPricesMap,'reportingPricesMap')

            // const reportingIdsQry = `SELECT GROUP_CONCAT(reporting_log_id) as reportingId FROM ${appSettings.warehouse_db} .reporting WHERE flag = 0`
            // const reportingIds = await manager.query(reportingIdsQry)

            const getStockInfoQry = `SELECT r.reporting_log_id,r.reporting_date,r.variant_id,r.pack_style_id,r.reported_cases,r.loose_pouches,r.lot_code,r.unit_id,r.product_category,r.sale_order_id,r.sale_order_item_id,
            sinv.po_number,soi.unitPrice,sku.short_code,v1.code AS v1,v2.code AS v2,v3.code AS v3,v4.code AS v4,v5.code AS v5,g.grade_name,pm.packing_method_name,
            ec.end_customer_name,sinv.end_customer_id,sku.hon_to_fg_yield AS fgYield,uc.unit_name,uc.company,uc.company_id,c.country_name,pm.no_of_pouches AS pouches,
            pm.pouches_per_row AS pouchWeight,soi.uom_id,ft.food_type,g.pack_count,soi.addon_product,sku.product_id,p.name as productName,sku.soaking_style,MONTH(r.reporting_date) as month,YEAR(r.reporting_date) as year,ci.invoice_number,pm.gross_weight as grossWeight,r.transaction_type as transactionType
            FROM ${appSettings.warehouse_db} .reporting r
            LEFT JOIN ${appSettings.sales_db} .so_invoice_details sinv ON sinv.sale_order_id = r.sale_order_id
            LEFT JOIN ${appSettings.sales_db} .sale_order_items  soi ON soi.sale_order_item_id = r.sale_order_item_id
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = r.variant_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_one_types v1 ON v1.value_addition_one_id = soi.value_addition_one_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_two_types v2 ON v2.value_addition_two_id = soi.value_addition_two_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_three_types v3 ON v3.value_addition_three_id = soi.value_addition_three_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_four_types v4 ON v4.value_addition_four_id = soi.value_addition_four_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_five_types v5 ON v5.value_addition_five_id = soi.value_addition_five_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .end_customers ec ON ec.end_customer_id = sinv.end_customer_id
            LEFT JOIN ${appSettings.masters_db} .unitcodes uc ON uc.unit_code_id = r.unit_id
            LEFT JOIN ${appSettings.masters_db} .countries c ON c.country_id = sinv.country_id
            LEFT JOIN ${appSettings.masters_db} .food_types ft ON ft.food_type_id = soi.food_type_id
            LEFT JOIN ${appSettings.masters_db} .products p ON p.product_id = sku.product_id
            LEFT JOIN ${appSettings.sales_db} .customer_invoice ci on ci.sale_order_id = r.sale_order_id and ci.is_active =1
            WHERE r.flag = 0 AND r.variant_id > 0`
            const getStockInfo = await manager.query(getStockInfoQry)

            const exchangeRateQry = `SELECT exchange_rate from ${appSettings.masters_db} .exchange_rates er LEFT JOIN ${appSettings.masters_db} .currencies c ON c.currency_id = er.currency_id WHERE c.currency_name = 'USD'`
            const exchangeRate = await manager.query(exchangeRateQry)

            const packMaterialPriceQry = `SELECT price,product_id,pack_style_id FROM ${appSettings.masters_db} .packing_material_prices`
            const packMaterialPrice = await manager.query(packMaterialPriceQry)
            const packMaterialPriceMap = new Map<{productId:number,packStyleId:number},any>()
            for(const rec of packMaterialPrice){
                if(!packMaterialPriceMap.has({productId:rec.product_id,packStyleId:rec.pack_style_id})){
                    packMaterialPriceMap.set({productId:rec.product_id,packStyleId:rec.pack_style_id},rec)
                }
            }

            await transmanager.startTransaction()
            const saveFlag = new Set<boolean>()

            const obj = new CronInfo()
            obj.module = 'Warehouse'
            obj.description = 'Production Cost Analysis Info Update'
            let reportingIds = []
            for(const rec of getStockInfo){
                // if( mfgCostDatmap.get(JSON.stringify({month:Number(rec.month),year:Number(rec.year)}))){
                    reportingIds.push(rec.reporting_log_id)
                    const qty = (Number(rec.reported_cases) * Number(rec.pouches) * Number(rec.pouchWeight)) + (Number(rec.loose_pouches) * Number(rec.pouchWeight))
                    let qtyInKgs
                    if(UnitsOfWeightInput.find(e => { return e.value == rec.uom_id}).name == 'lb'){
                        qtyInKgs = Number(qty) * 0.454
                        rec.grossWeight = (Number(rec.grossWeight) * 0.454)
                    }else if(UnitsOfWeightInput.find(e => { return e.value == rec.uom_id}).name == 'oz'){
                        qtyInKgs = (Number(qty) / 16) * 0.454
                        rec.grossWeight =( Number(rec.grossWeight)/16) * 0.454
                    }else if(UnitsOfWeightInput.find(e => { return e.value == rec.uom_id}).name == 'gm'){
                        qtyInKgs = Number(qty) / 1000
                        rec.grossWeight = Number(rec.grossWeight) / 1000
                    }else{
                        qtyInKgs = Number(qty)
                    }
                    const price = reportingPricesMap.get(rec.lot_code)  ? reportingPricesMap.get(rec.lot_code).price : 0
                    // const totalCount = reportingPricesMap.get(rec.variant_id)  ? reportingPricesMap.get(rec.variant_id).total : 1
                    // for(const stockId of rec.stockIds){
                    //     price += reportingPricesMap.get(stockId) ? Number(reportingPricesMap.get(stockId).price) : 0
                    //     totalCount += reportingPricesMap.get(stockId) ?  Number(reportingPricesMap.get(stockId).total) : 0
                    // }
                    const mfgCostInfo = mfgCostDatmap.get(JSON.stringify({month:Number(rec.month),year:Number(rec.year)}))
                    let rmRate = Number(price) 
                    const calRmQty = Number(((Number(qtyInKgs))/Number(rec.fgYield)*100).toFixed(2))
                    const rmValue = Math.round(Number(rmRate)*Number(calRmQty))
                    const mfgCost = Math.round(Number(calRmQty) * (mfgCostInfo != undefined ? Number(mfgCostInfo.price) : 0))
                    const netCOP = Number(rmValue) + Number(mfgCost)
                    let basis
                    let realisationRate = 0
                    let realisationValue = 0
                    if(prevOrderMap.has(rec.varient_id)){
                        realisationRate = prevOrderMap.get(rec.varient_id).amount / prevOrderMap.get(rec.varient_id).quantity
                        basis = 'ORDER'
                    } else if(prevailingMarketRateMap.has(rec.variant_id)){
                        realisationRate = prevailingMarketRateMap.get(rec.variant_id)
                        basis = 'MARKET'
                    } else if(prevShippedMap.has(rec.variant_id)){
                        realisationRate = prevShippedMap.get(rec.variant_id).amount / prevShippedMap.get(rec.variant_id).quantity
                        basis = 'PREVIOUS ORDER'
                    } else{
                        basis = 'COST'
                    }
    
                    if(basis == 'COST'){
                        realisationValue = netCOP
                    }else{
                        realisationValue = (Number(qtyInKgs)* Number(exchangeRate[0].exchange_rate) * Number(realisationRate))
                    }
                    // console.log(packMaterialPriceMap,'**')
                    const forwardExpAmount = forwExpDataMap.get(JSON.stringify({month:rec.month,year:rec.year})) != undefined ? Number(forwExpDataMap.get({month:rec.month,year:rec.year}).amount) : 0
                    const rmCost = Math.round(rmRate/(rec.fgYield/100))
                    const packingCost = packMaterialPriceMap.get({productId:rec.variant_id,packStyleId:rec.pack_style_id}) ? Number(packMaterialPriceMap.get({productId:rec.variant_id,packStyleId:rec.pack_style_id}).price) : 0
     
    
                    const totalCostOfSalePerKg = Number(rmCost) + Number(mfgCost) + Number(packingCost) + Number(forwardExpAmount)
                    const inInr = Number(totalCostOfSalePerKg) * Number(qtyInKgs)
                    const costOfSalesPerKgLbInUsd = (Number(totalCostOfSalePerKg) / Number(exchangeRate[0].exchange_rate)) * 0.454
                    const pl = Number(rec.unitPrice) - Number(costOfSalesPerKgLbInUsd)
                    const incentives = ((Number(rec.unitPrice) - Number(forwardExpAmount))*6.1) / 100
                    const totalPl = Number(pl) + Number(incentives)
    
                    const entityObj = new ProductionCostAnalysisEntity()
                    entityObj.batchNo = rec.lot_code
                    entityObj.variant = rec.short_code
                    entityObj.grade = rec.grade_name
                    entityObj.variantId = rec.variant_id
                    entityObj.packStyleId = rec.pack_style_id
                    entityObj.packStyle = rec.packing_method_name
                    entityObj.poNumber = rec.po_number
                    entityObj.endCustomer = rec.end_customer_name
                    entityObj.endCustomerId = rec.end_customer_id
                    entityObj.fgYield = rec.fgYield
                    entityObj.packCount = rec.pack_count
                    entityObj.fgQtyKgs = qtyInKgs
                    entityObj.rmCount = Math.round(1000/((454/Number(rec.fgYield)/Number(rec.pack_count))*100))
                    entityObj.rmRate = rmRate
                    entityObj.rmCost = rmCost
                    entityObj.mfgCost = mfgCost
                    entityObj.packingCost = packingCost
                    entityObj.freightFrwdCost = forwardExpAmount
                    entityObj.saleCostKgInr = inInr
                    entityObj.saleCostKgUsd = totalCostOfSalePerKg
                    entityObj.saleCostLbUsd = costOfSalesPerKgLbInUsd                       
                    entityObj.salePrice = rec.unitPrice
                    entityObj.profitLoss = pl
                    entityObj.incentives = incentives
                    entityObj.totalPl = totalPl
                    entityObj.plantId = rec.unit_id
                    entityObj.companyId = rec.company_id
                    entityObj.cartons = rec.reported_cases
                    entityObj.loosePouches = rec.loose_pouches
                    entityObj.reportedDate = rec.reporting_date
                    entityObj.actualMfgKg = 0
                    entityObj.actualMfgCost = 0
                    entityObj.exchangeRate = exchangeRate[0].exchange_rate
                    entityObj.calRmQty = calRmQty
                    entityObj.rmValue = rmValue
                    entityObj.netCop = netCOP
                    entityObj.realPricePerKg = realisationRate
                    entityObj.realValue = realisationValue
                    entityObj.basis = basis
                    entityObj.country = rec.country_name
                    entityObj.pouches = rec.pouches
                    entityObj.pouchWeight = rec.pouchWeight
                    entityObj.uomId = rec.uom_id
                    entityObj.grossPouchWeight = rec.grossWeight
                    entityObj.productCategory = rec.product_category
                    entityObj.product = rec.productName
                    entityObj.foodType = rec.food_type
                    entityObj.va1 = rec.v1
                    entityObj.va2 = rec.v2
                    entityObj.va3 = rec.v3
                    entityObj.va4 = rec.v4
                    entityObj.va5 = rec.v5
                    entityObj.reportingId = rec.reporting_log_id
                    entityObj.soakStyle = rec.soaking_style
                    entityObj.saleOrderId = rec.sale_order_id
                    entityObj.invoiceNumber = rec.invoice_number
                    entityObj.transactionType = rec.transactionType
                    const grossWe = Number(rec.grossWeight).toFixed(3) 
                    entityObj.fgToHonWeightKg =  ((Number(grossWe) * ((rec.pouches * rec.reported_cases) +rec.loose_pouches)) / (rec.fgYield)) * 100
                    // console.log(entityObj,'=====')parseFloat(num.toFixed(3))
                    const save = await transmanager.getRepository(ProductionCostAnalysisEntity).save(entityObj)
    
                    if(save){
                        saveFlag.add(true)
                    }else{
                        saveFlag.add(false)
                        obj.status = false
                        obj.reason = 'Something went wrong in saving production analysis info'
                        const updateCronInfo = await this.cronInfoRepo.save(obj)
                        await transmanager.releaseTransaction()
                        return new CommonResponse(false,0,'Something went wrong in saving production analysis info')
                    }
                // }
            }
            if(!(saveFlag.has(false))){
                if(reportingIds.length > 0){
                    const updateFlagInReportingQry =  `UPDATE ${appSettings.warehouse_db} .reporting SET flag = true WHERE reporting_log_id IN (${reportingIds})`
                    const updateFlagInReporting = await manager.query(updateFlagInReportingQry)
                    if(updateFlagInReporting){
                        obj.status = true
                        const updateCronInfo = await this.cronInfoRepo.save(obj)
                        await transmanager.completeTransaction()
                        return new CommonResponse(true,1,'Saved Sucessfully')
                    }else{
                        obj.status = false
                        obj.reason = 'Something went wrong in updating flag status'
                        const updateCronInfo = await this.cronInfoRepo.save(obj)
                        await transmanager.releaseTransaction()
                        return new CommonResponse(false,0,'Something went wrong in updating flag status')
                    }
                }
                obj.status = true
                const updateCronInfo = await this.cronInfoRepo.save(obj)
                await transmanager.completeTransaction()
                return new CommonResponse(true,1,'Saved Sucessfully')
            }
        }catch(err){
            const obj = new CronInfo()
            obj.module = 'Warehouse'
            obj.description = 'Production Cost Analysis Info Update'
            obj.status = false
            obj.reason = err.message
            const updateCronInfo = await this.cronInfoRepo.save(obj)
            // console.log(err,'====')
            await transmanager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong',err)
        }
    }

    @Cron('0 2 * * *')
    async updateRmPurchaseAnalysis():Promise<CommonResponse>{
        const transManager = new GenericTransactionManager()
        const manager = getManager()
        try{
            const gradeIdsQry = `SELECT GROUP_CONCAT(g.grade_inv_id) as gradeIds FROM ${appSettings.production_db} .grade_inventory g
            LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.plant_lot_number = g.lot_number AND gi.year = g.year
            WHERE flag = 0 and g.hon_count > 0 and g.rm_rate > 0 AND gi.inv_status = '${InvoiceStatusEnum.CLOSE}'`
            const gradeIds = await manager.query(gradeIdsQry)

            const qry = `SELECT g.year,g.grade_inv_id,g.plant_id,g.sub_plant_id,g.lot_number,g.grade,g.boxes,g.quantity,g.hon_count,g.hon_quantity,g.rm_rate,g.amount,g.grade_range,g.grn_hon_count,g.grn_hon_quantity,g.grn_rm_rate,gi.grn_item_id,s.name AS farmer,i.harvest_type,gi.reweighment_count,gi.reweighment_quantity,i.supplier_type,i.harvesting_date,v.vehicle_type,g.created_user,uc.company_id,grn.vehicle_number,gi.reweighment_boxes,grn.grn_date,emp1.employee_name AS harvestSupervisor,emp2.employee_name AS intakeSupervisor,s.city,gi.reweighment_date AS plantUnloadingDate,g.main_lot,i.is_vehicle_required,gi.ice_rate,g.grn_count,i.commission
            FROM ${appSettings.production_db} .grade_inventory g
            LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.plant_lot_number = g.lot_number AND gi.year=g.year
            LEFT JOIN ${appSettings.rm_procure_db} .grn grn ON grn.grn_id = gi.grn_id
            LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id
            LEFT JOIN ${appSettings.rm_procure_db} .indent_items ii ON ii.indent_id = gi.indent_id
            LEFT JOIN ${appSettings.masters_db} .suppliers s ON s.supplier_id = IF(i.supplier_type = '${SupplierTypeEnum.DEALER}' , ii.broker,ii.farmer)
            LEFT JOIN ${appSettings.masters_db} .unitcodes uc ON g.plant_id = uc.unit_code_id
            LEFT JOIN ${appSettings.transport_db} .vehicle_assignment v ON v.indent_id = gi.indent_id
            LEFT JOIN ${appSettings.masters_db} .employee_details emp1 ON emp1.employee_id = i.assign_lead_1
	        LEFT JOIN ${appSettings.masters_db}  .employee_details emp2 ON emp2.employee_id = grn.supervisor_id
            WHERE g.flag = 0 and g.hon_count > 0 and g.rm_rate > 0 AND gi.inv_status = '${InvoiceStatusEnum.CLOSE}'
            GROUP BY g.grade_inv_id`
            const data = await manager.query(qry)

            const getInvAmountQry = ` SELECT IF(lc.lot_club_status = 1 ,lc.clubbed_main_lot ,lc.lot_number) AS lotNumber,SUM(total_amount) as amount,lc.year,inv.invoice_number,inv.unit_price
            FROM ${appSettings.production_db} .lot_code_data lc
            LEFT JOIN ${appSettings.rm_procure_db} .grn_items gi ON gi.plant_lot_number = IF(lc.lot_club_status = 1 ,lc.clubbed_main_lot ,lc.lot_number) AND lc.year = gi.year
            LEFT JOIN ${appSettings.rm_procure_db} .rm_invoice inv ON gi.grn_item_id = inv.grn_item_id
            WHERE inv.invoice_number IS NOT NULL
            GROUP BY IF(lc.lot_club_status = 1 ,lc.clubbed_main_lot ,lc.lot_number),lc.year`
            const invAMountInfo = await manager.query(getInvAmountQry)
            const invAMountMap = new Map<any,any>()

            for(const rec of invAMountInfo){
                if(!(invAMountMap.has(JSON.stringify({lotNumber:rec.lotNumber,year:rec.year})))){
                    invAMountMap.set(JSON.stringify({lotNumber:rec.lotNumber,year:rec.year}),{amount:rec.amount,invNum:rec.invoice_number,unitPrice:rec.unit_price})
                }
            }

            await transManager.startTransaction()
            const saveFlag = new Set<boolean>()

            const obj = new CronInfo()
            obj.module = 'Production'
            obj.description = 'RM Purchase Analysis Info Update'

            for(const rec of data){
                // let mainLot = ''
                // let lastHyphenIndex = rec.lot_number.lastIndexOf('-');
                //   if (lastHyphenIndex == rec.lot_number.length - 2) {
                //     mainLot = rec.lot_number.substring(0, lastHyphenIndex)
                //   } else {
                //     mainLot = rec.lot_number
                //   }
                const invAmount = invAMountMap.get(JSON.stringify({lotNumber:rec.lot_number,year:rec.year})) != undefined ? invAMountMap.get(JSON.stringify({lotNumber:rec.lot_number,year:rec.year})).amount : 0
                const entityObj = new RMPurchaseAnalysisEntity()
                entityObj.plantId  = rec.plant_id
                entityObj.subPlantId = rec.sub_plant_id
                entityObj.lotNumber = rec.lot_number
                entityObj.grade = rec.grade
                entityObj.boxes = rec.boxes
                entityObj.quantity = rec.quantity
                entityObj.honCount = rec.hon_count 
                entityObj.honQuantity = rec.hon_quantity
                entityObj.rmRate = rec.rm_rate
                entityObj.amount = rec.amount
                entityObj.gradeRange = rec.grade_range
                entityObj.grnHonCount = rec.grn_hon_count
                entityObj.grnHonQuantity = rec.grn_hon_quantity
                entityObj.grnRmRate = rec.grn_rm_rate
                entityObj.farmer = rec.farmer
                entityObj.harvestType = rec.harvest_type
                entityObj.vehicleNum = rec.vehicle_number
                entityObj.noOfCreates = rec.reweighment_boxes
                entityObj.harvestDate = rec.harvesting_date
                entityObj.vehicleType = rec.vehicle_type
                entityObj.supplierType = rec.supplier_type
                entityObj.reweighmentCount = rec.reweighment_count
                entityObj.reweighmentQuantity = rec.reweighment_quantity
                entityObj.companyId = rec.company_id
                entityObj.createdUser = rec.created_user
                entityObj.invAmount = invAmount
                entityObj.invRate = invAMountMap.get(JSON.stringify({lotNumber:rec.lot_number,year:rec.year})) != undefined ? invAMountMap.get(JSON.stringify({lotNumber:rec.lot_number,year:rec.year})).unitPrice : 0
                // entityObj.invNum = rec.invoice_number
                entityObj.invNum = invAMountMap.get(JSON.stringify({lotNumber:rec.lot_number,year:rec.year})) != undefined ? invAMountMap.get(JSON.stringify({lotNumber:rec.lot_number,year:rec.year})).invNum : 0
                entityObj.mainLotNo = rec.main_lot
                entityObj.grnDate = rec.grn_date
                entityObj.city = rec.city
                entityObj.harvestSupervisor = rec.harvestSupervisor
                entityObj.intakeSupervisor = rec.intakeSupervisor
                entityObj.plantUnloadingDate = rec.plantUnloadingDate
                entityObj.isVehicleRequired = rec.is_vehicle_required
                entityObj.iceRate = rec.ice_rate
                entityObj.year = rec.year
                entityObj.gradeInvId = rec.grade_inv_id
                entityObj.grnCount = rec.grn_count
                entityObj.commission = rec.commission

                const save = await transManager.getRepository(RMPurchaseAnalysisEntity).save(entityObj)
                if(save){
                    saveFlag.add(true)
                }else{
                    saveFlag.add(false)
                    obj.status = false
                    obj.reason = 'Something went wrong in updating flag status'
                    const updateCronInfo = await this.cronInfoRepo.save(obj)
                    await transManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong in saving RM purchase analysis info')
                }

            }

            if(!(saveFlag.has(false))){
                const updateFlagQry = `UPDATE ${appSettings.production_db} .grade_inventory SET flag = true WHERE grade_inv_id IN (${gradeIds[0].gradeIds})`

                // console.log(gradeIds,'---')
                const updateFlag = await manager.query(updateFlagQry)
                if(updateFlag){
                    obj.status = true
                    const updateCronInfo = await this.cronInfoRepo.save(obj)
                    await transManager.completeTransaction()
                    return new CommonResponse(true,1,'Saved Sucessfully')
                }else{
                    obj.status = false
                    obj.reason = 'Something went wrong in updating flag status'
                    const updateCronInfo = await this.cronInfoRepo.save(obj)
                    await transManager.releaseTransaction()
                    return new CommonResponse(false,0,'Something went wrong in saving RM purchase analysis info')
                }
            }else{
                obj.status = false
                obj.reason = 'Something went wrong in saving RM purchase analysis info'
                const updateCronInfo = await this.cronInfoRepo.save(obj)
                await transManager.releaseTransaction()
                return new CommonResponse(false,0,'Something went wrong in saving RM purchase analysis info')
            }
        }catch(err){
            const obj = new CronInfo()
            obj.module = 'Production'
            obj.description = 'RM Purchase Analysis Info Update'
            obj.status = false
            obj.reason = err.message
            const updateCronInfo = await this.cronInfoRepo.save(obj)
            // console.log(err,'===')
            await transManager.releaseTransaction()
            return new CommonResponse(false,0,'Something went wrong')
        }

    }

    async getDayWiseAnalysisReport(req : DayWiseProductionReq):Promise<DaywiseAnalysisResponseModel>{
        const manager = getManager()
        try{
            const date = new Date()
            let exportProductsQry = `SELECT SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant))) as variant,grade,pack_style,FORMAT(SUM(fg_qty_kgs),2) AS fgQty,SUM(sale_cost_kg_inr) AS saleCostInr,SUM(sale_price) AS exportValue,product_category,va_5 AS va5
            FROM ${appSettings.analytics_db} .production_cost_analysis 
            WHERE product_category = '${ProductCategoryEnum.GI}' `
            if(req.fromDate != undefined){
                exportProductsQry += ` AND DATE(reported_date) BETWEEN '${moment(req.fromDate).format('YYYY-MM-DD')}' AND '${moment(req.toDate).format('YYYY-MM-DD')}'`
            }else{
                exportProductsQry += ` AND DATE(reported_date) = '${moment(date).format('YYYY-MM-DD')}'`
            }
            exportProductsQry += ` GROUP BY variant,grade,pack_style`
            const exportProductsInfo = await manager.query(exportProductsQry)

            let g2ProductQry = `SELECT SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant))) as variant,grade,pack_style,FORMAT(SUM(fg_qty_kgs),2) AS fgQty,SUM(sale_cost_kg_inr) AS saleCostInr,SUM(sale_price) AS exportValue,product_category,va_5 AS va5
            FROM ${appSettings.analytics_db} .production_cost_analysis 
            WHERE va_5 IN ('GII','BKN','DC') `
            if(req.fromDate != undefined){
                g2ProductQry += ` AND DATE(reported_date) BETWEEN '${moment(req.fromDate).format('YYYY-MM-DD')}' AND '${moment(req.toDate).format('YYYY-MM-DD')}'`
            }else{
                g2ProductQry += ` AND DATE(reported_date) = '${moment(date).format('YYYY-MM-DD')}'`
            }
            g2ProductQry += ` GROUP BY variant,grade,pack_style`
            const g2ProductsInfo = await manager.query(g2ProductQry)

            let jumbleProductQry = `SELECT SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant))) as variant,grade,pack_style,FORMAT(SUM(fg_qty_kgs),2) AS fgQty,SUM(sale_cost_kg_inr) AS saleCostInr,SUM(sale_price) AS exportValue,product_category,va_5 AS va5
            FROM ${appSettings.analytics_db} .production_cost_analysis 
            WHERE product_category = '${ProductCategoryEnum.jumble}' `
            if(req.fromDate != undefined){
                jumbleProductQry += ` AND DATE(reported_date) BETWEEN '${moment(req.fromDate).format('YYYY-MM-DD')}' AND '${moment(req.toDate).format('YYYY-MM-DD')}'`
            }else{
                jumbleProductQry += ` AND DATE(reported_date) = '${moment(date).format('YYYY-MM-DD')}'`
            }
            jumbleProductQry += ` GROUP BY variant,grade,pack_style`
            const jumbleProductsInfo = await manager.query(jumbleProductQry)

            const exportProducts = []
            const g2Products = []
            const jumbleProducts = []
            let totalCostInInr = 0
            let totalRealisationInInr = 0
            if(exportProductsInfo.length > 0 || g2ProductsInfo.length > 0 || jumbleProductsInfo.length > 0){
                for(const rec of exportProductsInfo){
                    exportProducts.push(new ExportsProductsInfo(rec.variant,rec.grade,rec.pack_style,rec.fgQty,rec.saleCostInr,rec.exportValue,Number(rec.saleCostInr) - Number(rec.exportValue)))
                    totalCostInInr += Number(rec.saleCostInr)
                    totalRealisationInInr += Number(rec.exportValue)
                }
    
                for(const rec of g2ProductsInfo){
                    g2Products.push(new G2ProductsInfo(rec.variant,rec.grade,rec.pack_style,rec.fgQty,rec.saleCostInr,0,0))
                    totalCostInInr += Number(rec.saleCostInr)
                }
    
                for(const rec of jumbleProductsInfo){
                    jumbleProducts.push(new JumbleProductsInfo(rec.product,rec.grade,rec.pack_style,rec.fgQty,rec.saleCostInr))
                    totalCostInInr += Number(rec.saleCostInr)
                    totalRealisationInInr += Number(rec.saleCostInr)
                }
                const info = new DayWiseProducitonAnalysisModel(exportProducts,g2Products,jumbleProducts,totalCostInInr,totalRealisationInInr,Number(totalRealisationInInr) - Number(totalCostInInr))
    
                return new DaywiseAnalysisResponseModel(true,1,'Data retrived sucessfully',info)
            }else{
                return new DaywiseAnalysisResponseModel(false,0,'No data found')
            }
        }catch(err){
            throw err
        }

    }

    async getDaywiseProductionExcelInfo(req : DayWiseProductionReq):Promise<DaywiseProductionResponseModel>{
        try{
            const manager = getManager()
            const date = new Date()
            let getQry = `SELECT p.batch_no,p.variant,p.grade,p.pack_style,p.po_number,p.end_customer,p.fg_qty_kgs AS fgQty,p.fg_yield,p.pack_count,p.rm_count,p.rm_rate,
            p.rm_cost,p.mfg_cost,p.packing_cost,p.freight_frwd_cost,p.sale_cost_kg_usd,p.sale_cost_kg_inr,p.sale_cost_lb_usd,p.sale_price,p.profit_loss,p.incentives,p.total_pl
            FROM ${appSettings.analytics_db} .production_cost_analysis p
            WHERE p.id > 0 `
            if(req.fromDate != undefined){
                getQry += ` AND DATE(reported_date) BETWEEN '${moment(req.fromDate).format('YYYY-MM-DD')}' AND '${moment(req.toDate).format('YYYY-MM-DD')}'`
            }else{
                getQry += ` AND DATE(reported_date) = '${moment(date).format('YYYY-MM-DD')}'`
            }
            const qryData = await manager.query(getQry)
            const info = []
            if(qryData.length > 0){
                for(const rec of qryData){
                    info.push(new DaywiseProductionModel(rec.batch_no,rec.variant,rec.grade,rec.pack_style,rec.po_number,rec.end_customer,rec.fgQty,rec.fg_yield,rec.pack_count,rec.rm_count,rec.rm_rate,rec.rm_cost,rec.mfg_cost,rec.packing_cost,rec.freight_frwd_cost,rec.sale_cost_kg_usd,rec.sale_cost_kg_inr,rec.sale_cost_lb_usd,rec.sale_price,rec.profit_loss,rec.incentives,rec.total_pl))
                }
                return new DaywiseProductionResponseModel(true,1,'Data retrieved successfully',info)
            }else{
                return new DaywiseProductionResponseModel(false,0,'No data found',[])
            }

        }catch(err){
            throw err
        }
    }

    @Cron('0 3 * * *')
    async updateDaywiseOpeningStockInfo():Promise<CommonResponse>{
        // const manager = getManager()
        // const transManager = new GenericTransactionManager()
        const connection = getConnection();
        const transManager: QueryRunner = connection.createQueryRunner();
        try{
            const saveFlag = new Set<boolean>()
            const today = new Date();
            const yesterday = new Date(today);
            // yesterday.setDate(today.getDate() - 1);
            await transManager.startTransaction()


            // const getDisctinctDatesQry = `SELECT DISTINCT(DATE(reporting_date)) as date FROM ${appSettings.warehouse_db} .reporting WHERE daywise_op_qty_flag = 0` 
            // const distinctDates = await transManager.query(getDisctinctDatesQry)

            const getDisctinctDatesQry = `SELECT DISTINCT(DATE(reporting_date)) as date FROM ${appSettings.warehouse_db} .reporting WHERE DATE(created_at) = '${moment(yesterday).format('YYYY-MM-DD')}' ORDER BY DATE(reporting_date)` 
            const distinctDates = await transManager.query(getDisctinctDatesQry)

            if(distinctDates.length > 0){
                const obj = new CronInfo()
                obj.module = 'Warehouse'
                obj.description = 'Daywise Opening STock Info Saving'
                const datesArray = []
                for(const dateRec of distinctDates){
                    const getPrevRecInDaywiseOpeningStockQry = `SELECT * from ${appSettings.analytics_db} .daywise_opening_stock where DATE(date) = '${moment(dateRec.date).format('YYYY-MM-DD')}'`
                    const getPrevRecInDaywiseOpeningStock = await transManager.query(getPrevRecInDaywiseOpeningStockQry)
                    if(getPrevRecInDaywiseOpeningStock.length > 0){
                        // const deletePrevRec = await transManager.manager.getRepository(DaywiseOpeningStockEntity).delete({date:moment(rec.date).format('YYYY-MM-DD')})
                        const deletePrevRecQry = `DELETE FROM ${appSettings.analytics_db} .daywise_opening_stock WHERE DATE(date) = '${moment(dateRec.date).format('YYYY-MM-DD')}'`
                        const deletePrevRec = await transManager.manager.query(deletePrevRecQry)
                        if(deletePrevRec.affectedRows){
                            saveFlag.add(true)
                        }else{
                            saveFlag.add(false)
                            obj.status = false
                            obj.reason = 'Something went wrong in deleting prev records in daywise opening stock info'
                            const updateCronInfo = await this.cronInfoRepo.save(obj)
                            await transManager.rollbackTransaction()
                            await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in deleting prev records')
                        }
                    }
                    // const array = ['28']
                    // const month = '05'
                    // const array = ['01','02','03','04','05','06','07','08','09',10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]
                    // for(let i = 1 ; i++ ; i<=10){
                    //     console.log(i,'=====================***================**====66===========i')
    
                    // }
                    // for(const i of array){
                // for(const dateRec of distinctDates){
                    // datesArray.push(moment(dateRec.date).format('YYYY-MM-DD'))
                    // const getStockInInfoQry = `SELECT r.variant_id,r.pack_style_id,SUM(reported_cases) AS cases,SUM(loose_pouches) AS loosePouches ,unit_id AS plantId,pm.no_of_pouches,pm.pouches_per_row,pm.uom_id,r.product_category
                    // FROM ${appSettings.warehouse_db} .reporting r
                    // LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
                    // WHERE DATE(reporting_date) <= '${moment(dateRec.date).format('YYYY-MM-DD')}' AND r.variant_id > 0
                    // GROUP BY r.variant_id,r.pack_style_id,r.unit_id,r.product_category`
                    // WHERE DATE(r.reporting_date) <= '2025-${month}-${i}'
    
                    const getStockInInfoQry = `SELECT r.variant_id,r.pack_style_id,SUM(reported_cases) AS cases,SUM(loose_pouches) AS loosePouches ,unit_id AS plantId,pm.no_of_pouches,pm.pouches_per_row,pm.uom_id,r.product_category
                    FROM ${appSettings.warehouse_db} .reporting r
                    LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
                    WHERE DATE(r.reporting_date) <= '${moment(dateRec.date).format('YYYY-MM-DD')}'
                    GROUP BY r.variant_id,r.pack_style_id,r.unit_id,r.product_category`
                    // WHERE DATE(r.reporting_date) <= '${moment(yesterday).format('YYYY-MM-DD')}'

    
                    const stockInInfo = await transManager.query(getStockInInfoQry)
                    // const stockInInfoMap = new Map<any,any>()
                    // for(const rec of stockInInfo){
                    //     stockInInfoMap.set({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId},rec)
                    // }
        
                    // const getStockOutInfoQry = `SELECT s.varient_id,s.pack_style_id,SUM(fi.job_cartons) AS jobCartons,SUM(fi.job_loose_pouches) AS loosePouches,s.unit_id AS plantId,s.product_category
                    // FROM ${appSettings.warehouse_db} .fork_lift_jobs fj
                    // LEFT JOIN ${appSettings.warehouse_db} .fork_lift_items fi ON fi.fork_lift_item_id = fj.job_id
                    // LEFT JOIN ${appSettings.warehouse_db} .stock s ON s.stock_id = fi.stock_id
                    // WHERE fj.date <= '${moment(dateRec.date).format('YYYY-MM-DD')}'
                    // GROUP BY s.varient_id,s.pack_style_id,s.unit_id,s.product_category`
    
                    
                    const getStockOutInfoQry = `SELECT s.varient_id,s.pack_style_id,SUM(fi.job_cartons) AS jobCartons,SUM(fi.job_loose_pouches) AS loosePouches,s.unit_id AS plantId,s.product_category
                    FROM ${appSettings.warehouse_db} .fork_lift_items fi
                    LEFT JOIN ${appSettings.warehouse_db} .fork_lift_jobs fj ON fi.fork_lift_job_id = fj.job_id
                    LEFT JOIN ${appSettings.warehouse_db} .stock s ON s.stock_id = fi.stock_id
                    WHERE DATE(fj.date) <= '${moment(dateRec.date).format('YYYY-MM-DD')}' and fj.job_purpose != '${TransactionType.stockTransfer}'
                    GROUP BY s.varient_id,s.pack_style_id,s.unit_id,s.product_category`
                    // WHERE DATE(fj.date) <= '${moment(yesterday).format('YYYY-MM-DD')}' and fj.job_purpose != '${TransactionType.stockTransfer}'
                    const stockOutInfo = await transManager.query(getStockOutInfoQry)
                    const stockOutInfoMap = new Map<any,any>()
                    for(const rec of stockOutInfo){
                        stockOutInfoMap.set(JSON.stringify({variantId:rec.varient_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category}),rec)
                    }
        
                    
                    if(stockInInfo.length > 0){
                        for(const rec of stockInInfo){
                            
                            // const stockOutcartons = stockOutInfoMap.get(JSON.stringify({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category})) ? Number(rec.cases) - Number(stockOutInfoMap.get(JSON.stringify({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category})).jobCartons) : rec.cases
                            // const stockOutloosePouches = stockOutInfoMap.get(JSON.stringify({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category})) ? Number(rec.loosePouches) - Number(stockOutInfoMap.get(JSON.stringify({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category})).loosePouches) : rec.loosePouches
                                const stockOutcartons = stockOutInfoMap.get(JSON.stringify({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category})) ?  Number(stockOutInfoMap.get(JSON.stringify({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category})).jobCartons) : 0
                            const stockOutloosePouches = stockOutInfoMap.get(JSON.stringify({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category})) ?  Number(stockOutInfoMap.get(JSON.stringify({variantId:rec.variant_id,pack_style_id:rec.pack_style_id,plantId:rec.plantId,productCateogry:rec.product_category})).loosePouches) : 0
                                let stockInPouches = (Number(rec.cases) * Number(rec.no_of_pouches)) + Number(rec.loosePouches)
                                let stockoutPouches = (Number(stockOutcartons) * Number(rec.no_of_pouches)) + Number(stockOutloosePouches)
                                let remainingPouches = Number(stockInPouches) - Number(stockoutPouches)
                                let cartons = Math.floor(remainingPouches/rec.no_of_pouches)
                                let loosePouches = remainingPouches % rec.no_of_pouches
                                if(cartons > 0 || loosePouches > 0){
    
                                let qtyInKgs = (Number(cartons) * Number(rec.pouches_per_row) * Number(rec.no_of_pouches)) + (Number(rec.loosePouches) * Number(rec.pouches_per_row))
                                if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'lb'){
                                    qtyInKgs = Number(qtyInKgs) * 0.454
                                }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'oz'){
                                    qtyInKgs = (Number(qtyInKgs) / 16) * 0.454
                                }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'gm'){
                                    qtyInKgs = Number(qtyInKgs) / 1000
                                }
    
    
                                const entityObj = new DaywiseOpeningStockEntity()
                                entityObj.variantId = rec.variant_id
                                entityObj.packStyleId = rec.pack_style_id
                                entityObj.date = moment(dateRec.date).format('YYYY-MM-DD')
                                entityObj.cartons = cartons
                                entityObj.loosePouches = loosePouches
                                entityObj.openingStockKgs = qtyInKgs
                                entityObj.plantId = rec.plantId
                                entityObj.productCategory = rec.product_category
            
                                const save = await transManager.manager.save(DaywiseOpeningStockEntity,entityObj)
                                if(save){
                                    saveFlag.add(true)
                                }else{
                                    saveFlag.add(false)
                                    obj.status = false
                                    obj.reason = 'Something went wrong in saving daywise opening stock info'
                                    const updateCronInfo = await this.cronInfoRepo.save(obj)
                                    await transManager.rollbackTransaction()
                                    await transManager.release()
                                    return new CommonResponse(false,0,'Something went wrong in saving daywise opening stock info')
                                }
                            }
                            
                        }
                    }else{
                        obj.status = false
                        obj.reason = 'No data found'
                        const updateCronInfo = await this.cronInfoRepo.save(obj)
                        await transManager.rollbackTransaction()
                        await transManager.release()
                        return new CommonResponse(false,0,'No data found')
                    }
                }
                // }
                    // }
    
                // console.log(datesArray,'===dates')
                // const resultArray = datesArray.map(date => date.toISOString().split('T')[0]);
                // console.log(resultArray,'result')
                const updateFlag = new Set<boolean>()
                if(!(saveFlag.has(false))){
                    obj.status = true
                    const updateCronInfo = await this.cronInfoRepo.save(obj)
                    await transManager.commitTransaction()
                    await transManager.release()
                    return new CommonResponse(true,1,'Saved successfully')
                    // for(const date of datesArray){
                    //     const updateFlagQry = `UPDATE ${appSettings.warehouse_db} .reporting SET daywise_op_qty_flag = true WHERE DATE(reporting_date) IN ('${date}')`
                    //     const updateFlagStatus = await transManager.query(updateFlagQry)
                    //     console.log(updateFlagStatus,'===updateFlag')
                    //     if(updateFlagStatus){
                    //       updateFlag.add(true)
                    //     }else{
                    //         obj.status = false
                    //         obj.reason = 'Something went wrong in updating flag in reporting table'
                    //         const updateCronInfo = await this.cronInfoRepo.save(obj)
                    //         await transManager.rollbackTransaction()
                    //         await transManager.release()
                    //         return new CommonResponse(false,0,'Something went wrong in updating flag')
                    //     }
                    // }
                }else{
                    obj.status = false
                    obj.reason = 'Something went wrong in saving daywise opening stock info'
                    const updateCronInfo = await this.cronInfoRepo.save(obj)
                    await transManager.rollbackTransaction()
                    await transManager.release()
                    return new CommonResponse(false,0,'Something went wrong in saving daywise opening stock info')
                }
            }else{
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,'No data to dump')
            }

            // if(!(updateFlag.has(false))){
            //     obj.status = true
            //     const updateCronInfo = await this.cronInfoRepo.save(obj)
            //     await transManager.commitTransaction()
            //     await transManager.release()
            //     return new CommonResponse(true,1,'Saved successfully')
            // }else{
            //     obj.status = false
            //     obj.reason = 'Something went wrong in updating flag in reporting table'
            //     const updateCronInfo = await this.cronInfoRepo.save(obj)
            //     await transManager.rollbackTransaction()
            //     await transManager.release()
            //     return new CommonResponse(false,0,'Something went wrong in updating flag')
            // }
        }catch(err){
            const obj = new CronInfo()
            obj.module = 'Warehouse'
            obj.description = 'Daywise Opening STock Info Saving'
            obj.status = false
            obj.reason = err.message
            const updateCronInfo = await this.cronInfoRepo.save(obj)
            // console.log(err,'====')
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false,0,'Something went wrong',err)
        }

    }
    
    @Cron('0 4 * * *')
    async updateDaywiseShrimpAnalysisInfo():Promise<CommonResponse>{
        const manager = getManager()
        // const transManager = new GenericTransactionManager()
        const connection = getConnection();
        const transManager: QueryRunner = connection.createQueryRunner();
        try{
            const date = new Date()
            const getStockInInfoQry = `SELECT GROUP_CONCAT(r.reporting_log_id) as reportingLogId,reporting_date,soi.varient_id,soi.pack_style_id,r.product_category,r.unit_id,sku.short_code,pm.packing_method_name,g.grade_name,v1.code as va1,v2.code as va2,v3.code as va3,v4.code as va4,v5.code as va5,sku.grade_id,pm.uom_id,pm.pouches_per_row,pm.no_of_pouches,sku.product_id,sku.food_type_id,sku.soaking_style,
            IF(transaction_type = 'reprocessing' , SUM(r.reported_cases) , 0 ) AS reprocessingCases,
            IF(transaction_type = 'rm' , SUM(r.reported_cases) , 0 ) AS rmCases,
            IF(transaction_type = 'repacking' , SUM(r.reported_cases) , 0 ) AS repackingCases,
            IF(transaction_type = 'rework' , SUM(r.reported_cases) , 0 ) AS reworkCases,
            IF(transaction_type = 'reprocessing' , SUM(r.loose_pouches) , 0 ) AS reprocessingLP,
            IF(transaction_type = 'rm' , SUM(r.loose_pouches) , 0 ) AS rmLP,
            IF(transaction_type = 'repacking' , SUM(r.loose_pouches) , 0 ) AS repackingLP,
            IF(transaction_type = 'rework' , SUM(r.loose_pouches) , 0 ) AS reworkLP,
            IF(transaction_type = 'labsamples', SUM(r.reported_cases) , 0) AS labsampleCases,
            IF(transaction_type = 'labsamples', SUM(r.loose_pouches) , 0) AS labsampleLP,
            IF(transaction_type = 'complements', SUM(r.reported_cases) , 0) AS complementCases,
            IF(transaction_type = 'complements', SUM(r.loose_pouches) , 0) AS complementLP
            FROM ${appSettings.warehouse_db} .reporting r
            LEFT JOIN ${appSettings.sales_db} .sale_order_items soi ON soi.sale_order_item_id = r.sale_order_item_id
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = soi.varient_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = soi.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_one_types v1 ON v1.value_addition_one_id = sku.value_addition_one_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_two_types v2 ON v2.value_addition_two_id = sku.value_addition_two_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_three_types v3 ON v3.value_addition_three_id = sku.value_addition_three_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_four_types v4 ON v4.value_addition_four_id = sku.value_addition_four_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_five_types v5 ON v5.value_addition_five_id = sku.value_addition_five_id
            WHERE r.daywise_shrimp_flag = 0
            GROUP BY variant_id,pack_style_id,unit_id,product_category,transaction_type,reporting_date`
            // GROUP BY variant_id,pack_style_id,unit_id,product_category,transaction_type`
            const stockInInfo = await manager.query(getStockInInfoQry)
            // const stockInInfoMap = new Map<any,any>()
            // for(const rec of stockInInfo){
            //     if(!stockInInfoMap.has({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id})){
            //         stockInInfoMap.set({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id},rec)
            //     }else{
            //         const prevRec = stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id})
            //         stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).rmCases = Number(prevRec.rmCases) + Number(rec.rmCases)
            //         stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).rmLP =  Number(prevRec.rmLP) + Number(rec.rmLP)
            //         stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).reprocessingCases = Number(prevRec.reprocessingCases) + Number(rec.reprocessingCases)
            //         stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).reprocessingLP = Number(prevRec.reprocessingLP) + Number(rec.reprocessingLP)
            //         stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).repackingCases = Number(prevRec.repackingCases) + Number(rec.repackingCases)
            //         stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).repackingLP = Number(prevRec.repackingLP) + Number(rec.repackingLP)
            //         stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).reworkCases = Number(prevRec.reworkCases) + Number(rec.reworkCases)
            //         stockInInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).reworkLP = Number(prevRec.reworkLP) + Number(rec.reworkLP)
            //     }
            // }

            const getStockOutInfoQry = `SELECT GROUP_CONCAT(j.job_id) as jobId,s.varient_id,s.product_category,s.pack_style_id,s.unit_id,j.date,s.uom_id,s.pouches as no_of_pouches,s.pouch_weight as pouches_per_row,sku.short_code,pm.packing_method_name,g.grade_name,g.grade_id,v1.code as va1,v2.code as va2,v3.code as va3,v4.code as va4,v5.code as va5,sku.product_id,sku.food_type_id,sku.soaking_style,
            IF(j.job_purpose = 'dispatch' , SUM(total_job_cartons),0) AS dispatchCases,
            IF(j.job_purpose = 'reprocessing' , SUM(total_job_cartons),0) AS reprocessCases,
            IF(j.job_purpose = 'repacking' , SUM(total_job_cartons),0) AS repackCases,
            IF(j.job_purpose = 'rework' , SUM(total_job_cartons),0) AS reworkCases,
            IF(j.job_purpose = 'dispatch' , SUM(total_job_loose_pouches),0) AS dispatchLP,
            IF(j.job_purpose = 'reprocessing', SUM(total_job_loose_pouches),0) AS reprocessLP,
            IF(j.job_purpose = 'repacking' , SUM(total_job_loose_pouches),0) AS repackLP,
            IF(j.job_purpose = 'rework' , SUM(total_job_loose_pouches),0) AS reworkLP,
            IF(j.job_purpose = 'labsamples' , SUM(total_job_cartons),0) AS labsampleCases,
            IF(j.job_purpose = 'labsamples' , SUM(total_job_loose_pouches),0) AS labsampleLP,
            IF(j.job_purpose = 'complements' , SUM(total_job_cartons),0) AS complementCases,
            IF(j.job_purpose = 'complements' , SUM(total_job_loose_pouches),0) AS complementLP
            FROM ${appSettings.warehouse_db} .fork_lift_jobs j
            LEFT JOIN ${appSettings.warehouse_db} .fork_lift_items fi ON fi.fork_lift_job_id = j.job_id
            LEFT JOIN ${appSettings.warehouse_db} .stock s ON s.stock_id = fi.stock_id
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = s.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_one_types v1 ON v1.value_addition_one_id = sku.value_addition_one_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_two_types v2 ON v2.value_addition_two_id = sku.value_addition_two_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_three_types v3 ON v3.value_addition_three_id = sku.value_addition_three_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_four_types v4 ON v4.value_addition_four_id = sku.value_addition_four_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_five_types v5 ON v5.value_addition_five_id = sku.value_addition_five_id
            WHERE j.daywise_shrimp_flag = 0
            GROUP BY s.product_category,s.varient_id,s.pack_style_id,s.unit_id,j.date`
            const stockOutInfo = await manager.query(getStockOutInfoQry)
            // const stockOutInfoMap = new Map<any,any>()
            // for(const rec of stockOutInfo){
            //     // if(!stockOutInfoMap.has({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id})){
            //         stockOutInfoMap.set({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id,date:rec.date},rec)
            //     // }else{
            //     //     const prevRec = stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id})
            //     //     stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).dispatchCases = Number(prevRec.dispatchCases) + Number(rec.dispatchCases)
            //     //     stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).dispatchLP =  Number(prevRec.dispatchLP) + Number(rec.dispatchLP)
            //     //     stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).reprocessCases = Number(prevRec.reprocessCases) + Number(rec.reprocessCases)
            //     //     stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).reprocessingLP = Number(prevRec.reprocessLP) + Number(rec.reprocessLP)
            //     //     stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).repackCases = Number(prevRec.repackCases) + Number(rec.repackCases)
            //     //     stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).repackLP = Number(prevRec.repackLP) + Number(rec.repackLP)
            //     //     stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).reworkCases = Number(prevRec.reworkCases) + Number(rec.reworkCases)
            //     //     stockOutInfoMap.get({variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id}).reworkLP = Number(prevRec.reworkLP) + Number(rec.reworkLP)
            //     // }
            // }

            const domesticSalesInfoQry = `SELECT GROUP_CONCAT(d.id) as domesticSaleId,d.varient_id,d.packStyle_id,SUM(d.cases) AS cases,SUM(d.loose_pouches) AS loose_pouches,SUM(d.quantity) AS qty,d.unit_id,s.product_category,d.created_at,s.uom_id,s.pouches as no_of_pouches,s.pouch_weight as pouches_per_row,sku.short_code,pm.packing_method_name,g.grade_name,g.grade_id,v1.code as va1,v2.code as va2,v3.code as va3,v4.code as va4,v5.code as va5,sku.product_id,sku.food_type_id,sku.soaking_style
            FROM ${appSettings.sales_db} .domestic_sales d
            LEFT JOIN ${appSettings.warehouse_db} .stock s ON s.stock_id = d.stock_id
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = d.varient_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = d.packStyle_id
            LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_one_types v1 ON v1.value_addition_one_id = sku.value_addition_one_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_two_types v2 ON v2.value_addition_two_id = sku.value_addition_two_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_three_types v3 ON v3.value_addition_three_id = sku.value_addition_three_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_four_types v4 ON v4.value_addition_four_id = sku.value_addition_four_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_five_types v5 ON v5.value_addition_five_id = sku.value_addition_five_id
            WHERE d.daywise_shrimp_flag = 0
            GROUP BY d.varient_id,d.packStyle_id,d.unit_id,s.product_category,d.created_at`
            const domesticSalesInfo = await manager.query(domesticSalesInfoQry)
            const domesticSalesInfoMap = new Map<any,any>()
            // for(const rec of domesticSalesInfo){
            //     if(!domesticSalesInfoMap.has({variantId:rec.varient_id,packStyleId:rec.packStyle_id,productCategory:rec.product_category,plantId:rec.unit_id,date:rec.created_at})){
            //         domesticSalesInfoMap.set({variantId:rec.varient_id,packStyleId:rec.packStyle_id,productCategory:rec.product_category,plantId:rec.unit_id,date:rec.created_at},rec)
            //     }else{

            //     }
            // }


            await transManager.startTransaction()
            // console.log(stockInInfo,'stockin')
            // console.log(stockOutInfo,'stockout')
            // console.log(domesticSalesInfo,'domestic')
            const saveFlag = new Set<boolean>()
            const cronObj = new CronInfo()
            cronObj.module = 'Warehouse'
            cronObj.description = 'Daywise shrimp analysis info saving'
            if(stockInInfo.length > 0 || stockOutInfo.length > 0 || domesticSalesInfo.length > 0){
                if(stockInInfo.length > 0){
                    for(const rec of stockInInfo){
                        // console.log(rec,'=================')
                        const reproductionCases = Number(rec.reprocessingCases) + Number(rec.repackingCases) + Number(rec.reworkCases)
                        const reproductionLP = Number(rec.reprocessingLP) + Number(rec.repackingLP) + Number(rec.reworkLP)
                        let freshProdQty = (Number(rec.rmCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(rec.rmLP) * Number(rec.pouches_per_row))
                        let reproductionQty = (Number(reproductionCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(reproductionLP) * Number(rec.pouches_per_row))
    
                        if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'lb'){
                            freshProdQty = Number(freshProdQty) * 0.454
                            reproductionQty = Number(reproductionQty) * 0.454
                           
                        }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'oz'){
                            freshProdQty = (Number(freshProdQty) / 16) * 0.454
                            reproductionQty = (Number(reproductionQty) / 16) * 0.454
                           
                        }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'gm'){
                            freshProdQty = Number(freshProdQty) / 1000
                            reproductionQty = Number(reproductionQty) / 1000
                           
                        }
    
                        const findRec = await transManager.manager.find(DaywiseShrimpAnalysisEntity,{where:{variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id,date:rec.reporting_date}})
                        const entityObj = new DaywiseShrimpAnalysisEntity()
                        if(findRec.length > 0){
                            entityObj.id = findRec[0].id
                        }else{
                            entityObj.variantId = rec.varient_id
                            entityObj.packStyleId = rec.pack_style_id
                            entityObj.productCategory = rec.product_category
                            entityObj.plantId = rec.unit_id
                            entityObj.date = rec.reporting_date
                            entityObj.variant = rec.short_code
                            entityObj.packStyle = rec.packing_method_name
                            entityObj.grade = rec.grade_name
                            entityObj.gradeId = rec.grade_id
                            entityObj.va1 = rec.va1
                            entityObj.va2 = rec.va2
                            entityObj.va3 = rec.va3
                            entityObj.va4 = rec.va4
                            entityObj.va5 = rec.va5
                            entityObj.foodTypeId = rec.food_type_id
                            entityObj.productId = rec.product_id
                            entityObj.soakStyle = rec.soaking_style
                        }
                        entityObj.freshProdCases = rec.rmCases
                        entityObj.freshProdLoosePouches = rec.rmLP
                        entityObj.freshProdQtyKg = freshProdQty
                        entityObj.reproductionCases = reproductionCases
                        entityObj.reproductionLoosePouches = reproductionLP
                        entityObj.reproductionQtyKg = reproductionQty
                        entityObj.totalProdQtyKg = Number(freshProdQty) + Number(reproductionQty)
                        
                        // console.log(entityObj,'entity')
                        const save = await transManager.manager.save(DaywiseShrimpAnalysisEntity,entityObj)
                        // console.log(save,'==================save')
                        if(save){
                            saveFlag.add(true)
                            const updateFlagInReportingQry = `UPDATE ${appSettings.warehouse_db} .reporting SET daywise_shrimp_flag = 1 WHERE reporting_log_id IN (${rec.reportingLogId})`
                            const updateFlagInReporting = await transManager.query(updateFlagInReportingQry)
                            if(updateFlagInReporting){
                                saveFlag.add(true)
                            }else{
                                saveFlag.add(false)
                                cronObj.status = false
                                cronObj.reason = 'Something went wrong in updating daywise shrimp flag in Reporting'
                                const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                                await transManager.rollbackTransaction()
                                await transManager.release()
                                return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp flag in Reporting')
                            }
                        }else{
                            saveFlag.add(false)
                            cronObj.status = false
                            cronObj.reason = 'Something went wrong in updating daywise shrimp info'
                            const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                            await transManager.rollbackTransaction()
                            await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp info')
                        }
                    }
                }
                if(stockOutInfo.length > 0){
                    for(const rec of stockOutInfo){
                        // console.log(rec,'=================')
                        let stockOutReprocessCases = 0
                        let strockOutReprocessLP =  0
                        let dispatchCases = 0
                        let dispatchLP = 0
                        let stockOutLabsamplesCases = 0
                        let stockOutLabsamplesLP = 0
                        stockOutReprocessCases = Number(rec.reprocessCases) + Number(rec.repackCases) + Number(rec.reworkCases)
                        strockOutReprocessLP =  Number(rec.reprocessLP) + Number(rec.repackLP) + Number(rec.reworkLP)
                        stockOutLabsamplesCases = Number(rec.labsampleCases) + Number(rec.complementCases)
                        stockOutLabsamplesLP = Number(rec.labsampleLP) + Number(rec.complementLP)
                        dispatchCases = rec.dispatchCases
                        dispatchLP = rec.dispatchCases
                        let dispacthQty = (Number(dispatchCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(dispatchLP) * Number(rec.pouches_per_row))
                        let reprocessIssuedQty = (Number(stockOutReprocessCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(strockOutReprocessLP) * Number(rec.pouches_per_row))
                        let labsampleQty = (Number(stockOutLabsamplesCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(stockOutLabsamplesLP) * Number(rec.pouches_per_row))
                        if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'lb'){
                            dispacthQty = Number(dispacthQty) * 0.454
                            reprocessIssuedQty = Number(reprocessIssuedQty) * 0.454
                        }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'oz'){
                            dispacthQty = (Number(dispacthQty) / 16) * 0.454
                            reprocessIssuedQty = (Number(reprocessIssuedQty) / 16) * 0.454
                        }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'gm'){
                            dispacthQty = Number(dispacthQty) / 1000
                            reprocessIssuedQty = Number(reprocessIssuedQty) / 1000
                        }
                        const findRec = await transManager.manager.find(DaywiseShrimpAnalysisEntity,{where:{variantId:rec.varient_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id,date:rec.date}})
                        const entityObj = new DaywiseShrimpAnalysisEntity()
                        if(findRec.length > 0){
                            entityObj.id = findRec[0].id
                        }else{
                            entityObj.variantId = rec.varient_id
                            entityObj.packStyleId = rec.pack_style_id
                            entityObj.productCategory = rec.product_category
                            entityObj.plantId = rec.unit_id
                            entityObj.date = rec.date
                            entityObj.variant = rec.short_code
                            entityObj.packStyle = rec.packing_method_name
                            entityObj.grade = rec.grade_name
                            entityObj.gradeId = rec.grade_id
                            entityObj.va1 = rec.va1
                            entityObj.va2 = rec.va2
                            entityObj.va3 = rec.va3
                            entityObj.va4 = rec.va4
                            entityObj.va5 = rec.va5
                            entityObj.foodTypeId = rec.food_type_id
                            entityObj.productId = rec.product_id
                            entityObj.soakStyle = rec.soaking_style
                        }
                        entityObj.shipmentCases =  rec.dispatchCases
                        entityObj.shipmentLoosePouches = rec.dispatchLP
                        entityObj.shipmentQtyKg = dispacthQty
                        entityObj.reprocessCases = stockOutReprocessCases
                        entityObj.reprocessLoosePouches = strockOutReprocessLP
                        entityObj.reprocessQtyKg = reprocessIssuedQty
                        entityObj.labSampleCases = stockOutLabsamplesCases
                        entityObj.labSampleLoosePouches = stockOutLabsamplesLP
                        entityObj.labSampleQtyKg = labsampleQty
                        // console.log(entityObj,'====enti')
                        const save = await transManager.manager.save(DaywiseShrimpAnalysisEntity,entityObj)
                        if(save){
                            saveFlag.add(true)
                            const updateFlagInForkLiftJobsQry = `UPDATE ${appSettings.warehouse_db} .fork_lift_jobs SET daywise_shrimp_flag = 1 WHERE job_id IN (${rec.jobId})`
                            const updateFlagInForkLiftJobs = await transManager.query(updateFlagInForkLiftJobsQry)
                            if(!updateFlagInForkLiftJobs){
                                saveFlag.add(false)
                                cronObj.status = false
                                cronObj.reason = 'Something went wrong in updating daywise shrimp flag in Fork Lift Jobs'
                                const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                                await transManager.rollbackTransaction()
                                await transManager.release()
                                return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp flag  Fork Lift Jobs')
                            }
                        }else{
                            saveFlag.add(false)
                            cronObj.status = false
                            cronObj.reason = 'Something went wrong in updating daywise shrimp info'
                            const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                            await transManager.rollbackTransaction()
                            await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp info')
                        }
                    }
                }
                if(domesticSalesInfo.length > 0){
                    for(const rec of domesticSalesInfo){
                        // console.log(rec,'=================')
                        let domesticSaleQty =  Number(rec.qty)
                        if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'lb'){
                            domesticSaleQty = Number(domesticSaleQty) * 0.454
                        }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'oz'){
                            domesticSaleQty = (Number(domesticSaleQty) / 16) * 0.454
                        }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'gm'){
                            domesticSaleQty = Number(domesticSaleQty) / 1000
                        }
                        const findRec = await transManager.manager.find(DaywiseShrimpAnalysisEntity,{where:{variantId:rec.varient_id,packStyleId:rec.packStyle_id,productCategory:rec.product_category,plantId:rec.unit_id,date:rec.created_at}})
                        const entityObj = new DaywiseShrimpAnalysisEntity()
                        if(findRec.length > 0){
                            entityObj.id = findRec[0].id
                        }else{
                            entityObj.variantId = rec.varient_id
                            entityObj.packStyleId = rec.packStyle_id
                            entityObj.productCategory = rec.product_category
                            entityObj.plantId = rec.unit_id
                            entityObj.date = rec.created_at
                            entityObj.variant = rec.short_code
                            entityObj.packStyle = rec.packing_method_name
                            entityObj.grade = rec.grade_name
                            entityObj.gradeId = rec.grade_id
                            entityObj.va1 = rec.va1
                            entityObj.va2 = rec.va2
                            entityObj.va3 = rec.va3
                            entityObj.va4 = rec.va4
                            entityObj.va5 = rec.va5
                            entityObj.foodTypeId = rec.food_type_id
                            entityObj.productId = rec.product_id
                            entityObj.soakStyle = rec.soaking_style
                        }
                        entityObj.domesticSaleCases = findRec.length > 0 ? Number(findRec[0].domesticSaleCases) + Number(rec.cases) : rec.cases
                        entityObj.domesticSaleLoosePouches = findRec.length > 0 ? Number(findRec[0].domesticSaleLoosePouches) + Number(rec.loose_pouches) : rec.loose_pouches
                        entityObj.domesticSaleQtyKg = findRec.length > 0 ?  Number(findRec[0].domesticSaleQtyKg) + Number(domesticSaleQty)  : domesticSaleQty
                        // console.log(entityObj,'===')
                        const save = await transManager.manager.save(DaywiseShrimpAnalysisEntity,entityObj)
                        if(save){
                            const updateFlagInDomesticSalesQry = `UPDATE ${appSettings.sales_db} .domestic_sales SET daywise_shrimp_flag = 1 WHERE id IN (${rec.domesticSaleId})`
                            const updateFlagInDomesticSales = await transManager.query(updateFlagInDomesticSalesQry)
                            if(!updateFlagInDomesticSales){
                                saveFlag.add(false)
                                cronObj.status = false
                                cronObj.reason = 'Something went wrong in updating daywise shrimp flag Domestic Sales'
                                const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                                await transManager.rollbackTransaction()
                                await transManager.release()
                                return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp flag Domestic Sales')
                            }
                        }else{
                            saveFlag.add(false)
                            cronObj.status = false
                            cronObj.reason = 'Something went wrong in updating daywise shrimp info'
                            const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                            await transManager.rollbackTransaction()
                            await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp info')
                        }
    
                    }
                }

                if(!(saveFlag.has(false))){
                    cronObj.status = true
                    const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                    await transManager.commitTransaction()
                    await transManager.release()
                    return new CommonResponse(true,1,'Updated successfully')
                }else{
                    cronObj.status = false
                    cronObj.reason = 'Something went wrong in updating daywise shrimp info'
                    const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                    await transManager.rollbackTransaction()
                    await transManager.release()
                    return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp info')
                }
            }else{
                cronObj.status = false
                cronObj.reason = 'No data found'
                const updateCronInfo = await this.cronInfoRepo.save(cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,'No data found')
            }
            // if(stockInInfo.length > 0){
            //     const saveFlag = new Set<boolean>()
            //     for(const rec of stockInInfo){
            //         const stockOutInfo = stockOutInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id,date:rec.reported_date})
            //         const domesticSaleInfo = domesticSalesInfoMap.get({variantId:rec.variant_id,packStyleId:rec.pack_style_id,productCategory:rec.product_category,plantId:rec.unit_id,date:rec.reported_date})

            //         const reproductionCases = Number(rec.reprocessingCases) + Number(rec.repackingCases) + Number(rec.reworkCases)
            //         const reproductionLP = Number(rec.reprocessingLP) + Number(rec.repackingLP) + Number(rec.reworkLP)
            //         let stockOutReprocessCases = 0
            //         let strockOutReprocessLP =  0
            //         let dispatchCases = 0
            //         let dispatchLP = 0
                    console.log(stockOutInfo,'-------------------------------------------------stockout')
            //         if(stockOutInfo != undefined){
            //             stockOutReprocessCases = Number(stockOutInfo.reprocessCases) + Number(stockOutInfo.repackCases) + Number(stockOutInfo.reworkCases)
            //             strockOutReprocessLP =  Number(stockOutInfo.reprocessLP) + Number(stockOutInfo.repackLP) + Number(stockOutInfo.reworkLP)
                        console.log('okk')
            //             dispatchCases = stockOutInfo.dispatchCases
            //             dispatchLP = stockOutInfo.dispatchCases
            //         }
            //         let freshProdQty = (Number(rec.rmCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(rec.rmLP) * Number(rec.pouches_per_row))
            //         let reproductionQty = (Number(reproductionCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(reproductionLP) * Number(rec.pouches_per_row))
            //         let dispacthQty = (Number(dispatchCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(dispatchLP) * Number(rec.pouches_per_row))
            //         let reprocessIssuedQty = (Number(stockOutReprocessCases) * Number(rec.no_of_pouches) * Number(rec.pouches_per_row)) + (Number(strockOutReprocessLP) * Number(rec.pouches_per_row))
            //         let domesticSaleQty = domesticSaleInfo!= undefined ? Number(domesticSaleInfo.quantity) : 0
                    // console.log(rec,'(((((')

            //         if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'lb'){
            //             freshProdQty = Number(freshProdQty) * 0.454
            //             reproductionQty = Number(reproductionQty) * 0.454
            //             dispacthQty = Number(dispacthQty) * 0.454
            //             reprocessIssuedQty = Number(reprocessIssuedQty) * 0.454
            //             domesticSaleQty = Number(domesticSaleQty) * 0.454
            //         }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'oz'){
            //             freshProdQty = (Number(freshProdQty) / 16) * 0.454
            //             reproductionQty = (Number(reproductionQty) / 16) * 0.454
            //             dispacthQty = (Number(dispacthQty) / 16) * 0.454
            //             reprocessIssuedQty = (Number(reprocessIssuedQty) / 16) * 0.454
            //             domesticSaleQty = (Number(domesticSaleQty) / 16) * 0.454
            //         }else if(UnitsOfWeightInput.find(e => {return e.value == rec.uom_id}).name == 'gm'){
            //             freshProdQty = Number(freshProdQty) / 1000
            //             reproductionQty = Number(reproductionQty) / 1000
            //             dispacthQty = Number(dispacthQty) / 1000
            //             reprocessIssuedQty = Number(reprocessIssuedQty) / 1000
            //             domesticSaleQty = Number(domesticSaleQty) / 1000
            //         }
                    // console.log('*************')
            //         const entityObj = new DaywiseShrimpAnalysisEntity()
            //         entityObj.variant = rec.short_code
            //         entityObj.variantId = rec.variant_id
            //         entityObj.packStyleId = rec.pack_style_id
            //         entityObj.packStyle = rec.packing_method_name
            //         entityObj.grade = rec.grade_name
            //         entityObj.gradeId = rec.grade_id
            //         entityObj.va1 = rec.va1
            //         entityObj.va2 = rec.va2
            //         entityObj.va3 = rec.va3
            //         entityObj.va4 = rec.va4
            //         entityObj.va5 = rec.va5
            //         entityObj.productCategory = rec.product_category
            //         entityObj.plantId = rec.unit_id
            //         entityObj.date = rec.reporting_date
            //         entityObj.freshProdCases = rec.rmCases
            //         entityObj.freshProdLoosePouches = rec.rmLP
            //         entityObj.freshProdQtyKg = freshProdQty
            //         entityObj.reproductionCases = reproductionCases
            //         entityObj.reproductionLoosePouches = reproductionLP
            //         entityObj.reproductionQtyKg = reproductionQty
            //         entityObj.totalProdQtyKg = Number(freshProdQty) + Number(reproductionQty)
            //         entityObj.shipmentCases = stockOutInfo != undefined ? stockOutInfo.dispatchCases : 0
            //         entityObj.shipmentLoosePouches = stockOutInfo != undefined ? stockOutInfo.dispatchLP : 0
            //         entityObj.shipmentQtyKg = dispacthQty
            //         entityObj.reprocessCases = stockOutReprocessCases
            //         entityObj.reprocessLoosePouches = strockOutReprocessLP
            //         entityObj.reprocessQtyKg = reprocessIssuedQty
            //         entityObj.labSampleCases = 0
            //         entityObj.labSampleLoosePouches = 0
            //         entityObj.labSampleQtyKg = 0
            //         entityObj.domesticSaleCases = domesticSaleInfo != undefined ? domesticSaleInfo.cases : 0
            //         entityObj.domesticSaleLoosePouches = domesticSaleInfo != undefined ?  domesticSaleInfo.loose_pouches : 0
            //         entityObj.domesticSaleQtyKg = domesticSaleQty
            //         entityObj.foodTypeId = rec.food_type_id
            //         entityObj.productId = rec.product_id
            //         entityObj.soakStyle = rec.soaking_style

            //         const save = await transManager.getRepository(DaywiseShrimpAnalysisEntity).save(entityObj)

            //         if(save){

            //             saveFlag.add(true)
            //             const updateFlagInReportingQry = `UPDATE ${appSettings.warehouse_db} .reporting SET daywise_shrimp_flag = 1 WHERE reporting_log_id IN ${rec.reporting_log_id}`
            //             const updateFlagInReporting = await manager.query(updateFlagInReportingQry)
                        // console.log(updateFlagInReporting,'updateFlagInReporting')
            //             if(updateFlagInReporting){
            //                 saveFlag.add(true)
            //                 if(stockOutInfo != undefined){
            //                     const updateFlagInForkLiftJobsQry = `UPDATE ${appSettings.warehouse_db} .fork_lift_jobs SET daywise_shrimp_flag = 1 WHERE job_id IN ${stockOutInfo.jobId}`
            //                     const updateFlagInForkLiftJobs = await manager.query(updateFlagInForkLiftJobsQry)
            //                     if(!updateFlagInForkLiftJobs){
            //                         saveFlag.add(false)
            //                         cronObj.status = false
            //                         cronObj.reason = 'Something went wrong in updating daywise shrimp flag in Fork Lift Jobs'
            //                         const updateCronInfo = await this.cronInfoRepo.save(cronObj)
            //                         await transManager.releaseTransaction()
            //                         return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp flag  Fork Lift Jobs')
            //                     }
            //                 }
            //                 if(domesticSaleInfo != undefined){
            //                     const updateFlagInDomesticSalesQry = `UPDATE ${appSettings.sales_db} .domestic_sales SET daywise_shrimp_flag = 1 WHERE id IN ${domesticSaleInfo.domesticSaleId}`
            //                     const updateFlagInDomesticSales = await manager.query(updateFlagInDomesticSalesQry)
            //                     if(!updateFlagInDomesticSales){
            //                         saveFlag.add(false)
            //                         cronObj.status = false
            //                         cronObj.reason = 'Something went wrong in updating daywise shrimp flag Domestic Sales'
            //                         const updateCronInfo = await this.cronInfoRepo.save(cronObj)
            //                         await transManager.releaseTransaction()
            //                         return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp flag Domestic Sales')
            //                     }
            //                 }
            //             }else{
            //                 saveFlag.add(false)
            //                 cronObj.status = false
            //                 cronObj.reason = 'Something went wrong in updating daywise shrimp flag in Reporting'
            //                 const updateCronInfo = await this.cronInfoRepo.save(cronObj)
            //                 await transManager.releaseTransaction()
            //                 return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp flag in Reporting')
            //             }
            //         }else{
            //             saveFlag.add(false)
            //             cronObj.status = false
            //             cronObj.reason = 'Something went wrong in updating daywise shrimp info'
            //             const updateCronInfo = await this.cronInfoRepo.save(cronObj)
            //             await transManager.releaseTransaction()
            //             return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp info')
            //         }
            //     }
            //     if(!(saveFlag.has(false))){
            //         cronObj.status = true
            //         const updateCronInfo = await this.cronInfoRepo.save(cronObj)
            //         await transManager.completeTransaction()
            //         return new CommonResponse(true,1,'Updated successfully')
            //     }else{
            //         cronObj.status = false
            //         cronObj.reason = 'Something went wrong in updating daywise shrimp info'
            //         const updateCronInfo = await this.cronInfoRepo.save(cronObj)
            //         await transManager.releaseTransaction()
            //         return new CommonResponse(false,0,'Something went wrong in updating daywise shrimp info')
            //     }
            // }else{
            //     cronObj.status = false
            //     cronObj.reason = 'No data found'
            //     const updateCronInfo = await this.cronInfoRepo.save(cronObj)
            //     await transManager.releaseTransaction()
            //     return new CommonResponse(false,0,'No data found')
            // }
        }catch(err){
            const cronObj = new CronInfo()
            cronObj.module = 'Warehouse'
            cronObj.description = 'Daywise shrimp analysis info saving'
            cronObj.status = false
            cronObj.reason = err.message
            const updateCronInfo = await this.cronInfoRepo.save(cronObj)
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false,0,'Something went wrong')
        }
    }


    async getMonthlyShrimpMISReport(req:MonthWiseShrimpReq): Promise<CommonResponse> {
        const manager = getManager()
        try {
            let query = `SELECT dsa.pack_style_id,dsa.product_category as productCategory,dsa.plant_id,dsa.date,
            SUM(dsa.fresh_prod_qty_kg) AS freshProductionKgs,SUM(dsa.reproduction_qty_kg) AS reproductionKgs,
            SUM(dsa.total_prod_qty_kg) AS totalProductionKgs,SUM(dsa.shipment_qty_kg) AS shipmentQuantity,
            SUM(dsa.reprocess_qty_kg) AS reprocessQtyKg,SUM(dsa.lab_sample_qty_kg) AS labSampleQtyKg,
            SUM(dsa.domestic_sale_qty_kg) AS domesticSaleQty,
            LEFT(dsa.variant, LENGTH(dsa.variant) - LOCATE('-', REVERSE(dsa.variant))) AS truncatedShortCode,
            CONCAT(LEFT(dsa.variant, LENGTH(dsa.variant) - LOCATE('-', REVERSE(dsa.variant))), ' ', dsa.pack_style) 
            AS productDescription,uc.unit_name,sku.value_addition_one_id as va1, sku.value_addition_two_id as va2,sku.value_addition_three_id as va3,sku.value_addition_four_id as va4,sku.value_addition_five_id as va5,dsa.food_type_id,dsa.product_id,dsa.soak_style,
            dsa.product_category
            FROM ${appSettings.analytics_db}.daywise_shrimp_analysis dsa
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku on sku.sku_code_id = dsa.variant_id
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = dsa.plant_id
            WHERE YEAR(dsa.date) = '${req.year}' AND MONTH(dsa.date) = '${req.month} '
            `;

            if (req.plantId) {
                query += ` AND uc.unit_code_id = ${req.plantId}`;
            }
            query += `
             GROUP BY 
                dsa.va1, dsa.va2,dsa.va3,dsa.va4,dsa.va5,dsa.food_type_id,dsa.product_id,dsa.soak_style,
                dsa.pack_style_id, 
                dsa.product_category;
        `;
        const productionData = await manager.query(query);            

        // let openingStockQuery = `SELECT dos.pack_style_id, SUM(dos.opening_stock_kgs) AS openingStockKgs, 
        // DATE(dos.date) AS openingStockDate,sku.value_addition_one_id as va1, sku.value_addition_two_id as va2,sku.value_addition_three_id as va3,sku.value_addition_four_id as va4,sku.value_addition_five_id as va5,sku.food_type_id,sku.product_id,sku.soaking_style,dos.product_category
        // FROM ${appSettings.analytics_db}.daywise_opening_stock dos
        // LEFT JOIN ${appSettings.masters_db} .sku_codes sku on sku.sku_code_id = dos.variant_id
        // WHERE YEAR(dos.date) = '${req.year}' AND MONTH(dos.date) <= '${req.month-1}'
        // GROUP BY  dos.pack_style_id, sku.value_addition_one_id, sku.value_addition_two_id,sku.value_addition_three_id,sku.value_addition_four_id,sku.value_addition_five_id,sku.food_type_id,sku.product_id,sku.soaking_style,dos.product_category
        // order by date(date) desc limit 1;`;
        const openingStockQuery = `SELECT dos.pack_style_id, SUM(dos.opening_stock_kgs) AS openingStockKgs,DATE(dos.date) AS openingStockDate,sku.value_addition_one_id AS va1, sku.value_addition_two_id AS va2,sku.value_addition_three_id AS va3,sku.value_addition_four_id AS va4,sku.value_addition_five_id AS va5,sku.food_type_id,sku.product_id,sku.soaking_style,dos.product_category
        FROM erpx_dev_analytics.daywise_opening_stock dos                                                           
        LEFT JOIN  erpx_dev_masters.sku_codes sku 
        ON sku.sku_code_id = dos.variant_id
        JOIN 
            (
                -- Subquery to get the max date for each combination
                SELECT  pack_style_id,  value_addition_one_id,  value_addition_two_id, value_addition_three_id, value_addition_four_id, value_addition_five_id, food_type_id, product_id, soaking_style, product_category, MAX(date) AS max_date
            FROM  erpx_dev_analytics.daywise_opening_stock dos
            LEFT JOIN erpx_dev_masters.sku_codes sku 
            ON sku.sku_code_id = dos.variant_id
            WHERE  YEAR(dos.date) = '${req.year}' AND MONTH(dos.date) <= '${req.month - 1}'
            GROUP BY  pack_style_id,  value_addition_one_id,  value_addition_two_id, value_addition_three_id, value_addition_four_id, value_addition_five_id, food_type_id, product_id, soaking_style, product_category
        ) max_dates
    ON 
        dos.pack_style_id = max_dates.pack_style_id
        AND sku.value_addition_one_id = max_dates.value_addition_one_id
        AND sku.value_addition_two_id = max_dates.value_addition_two_id
        AND sku.value_addition_three_id = max_dates.value_addition_three_id
        AND sku.value_addition_four_id = max_dates.value_addition_four_id
        AND sku.value_addition_five_id = max_dates.value_addition_five_id   
        AND sku.food_type_id = max_dates.food_type_id
        AND sku.product_id = max_dates.product_id
        AND sku.soaking_style = max_dates.soaking_style
        AND dos.product_category = max_dates.product_category
        AND dos.date = max_dates.max_date
    GROUP BY  dos.pack_style_id, sku.value_addition_one_id, sku.value_addition_two_id,sku.value_addition_three_id,sku.value_addition_four_id,sku.value_addition_five_id,sku.food_type_id,sku.product_id,sku.soaking_style,dos.product_category, DATE(dos.date);
    `
        const openingStockData = await manager.query(openingStockQuery);

        const openingSTockMap = new Map<any,number>()
        if(openingStockData.length > 0){
            for(const rec of openingStockData){
                console.log(rec,'****')
                if(!(openingSTockMap.has(JSON.stringify({va1:rec.va1,va2:rec.va2,va3:rec.va3,va4:rec.va4,va5:rec.va5,foodType:rec.food_type_id,product:rec.product_id,soakStyle:rec.soaking_style,productCategory:rec.product_category,packStyle:rec.pack_style_id})))){
                    openingSTockMap.set(JSON.stringify({va1:rec.va1,va2:rec.va2,va3:rec.va3,va4:rec.va4,va5:rec.va5,foodType:rec.food_type_id,product:rec.product_id,soakStyle:rec.soaking_style,productCategory:rec.product_category,packStyle:rec.pack_style_id}),rec.openingStockKgs)
                }
            }
        }

        console.log(openingSTockMap,'================')
    
            for (const record of productionData) {
                 console.log(JSON.stringify({va1:record.va1,va2:record.va2,va3:record.va3,va4:record.va4,va5:record.va5,foodType:record.food_type_id,product:record.product_id,soakStyle:record.soak_style,productCategory:record.product_category,packStyle:record.pack_style_id}))
                    const qty = openingSTockMap.get(JSON.stringify({va1:record.va1,va2:record.va2,va3:record.va3,va4:record.va4,va5:record.va5,foodType:record.food_type_id,product:record.product_id,soakStyle:record.soak_style,productCategory:record.product_category,packStyle:record.pack_style_id})) ? openingSTockMap.get(JSON.stringify({va1:record.va1,va2:record.va2,va3:record.va3,va4:record.va4,va5:record.va5,foodType:record.food_type_id,product:record.product_id,soakStyle:record.soak_style,productCategory:record.product_category,packStyle:record.pack_style_id})) : 0
                    record.openingStockKgs = qty;
                    record.openingStockDate = null;
              
            }
    
            if (productionData.length > 0) {
                return new CommonResponse(true, 111, "Data retrieved successfully", productionData);
            } else {
                return new CommonResponse(false, 0, "No data found", []);
            }
        } catch (err) {
            throw err;
        }
    }
    
    async getShippedContainerMISDetails(req:MonthWiseShrimpReq): Promise<CommonResponse> {
        try {
          let query = `SELECT 
                        DATE_FORMAT(c.updated_at, '%Y-%m') AS MONTH, uc.unit_name as UnitName, COUNT(c.status) AS shippedStatusCount
                        FROM ${appSettings.logistics_db}.container c
                        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = c.unit_id
                        WHERE  c.status = 'SHIPPED' AND YEAR(c.updated_at) = '${req.year}' AND MONTH(c.updated_at) = '${req.month}'
                       `
                        if (req.unitId) {
                            query += ` AND uc.unit_code_id = ${req.unitId}`;
                        }
                        query += `
                        GROUP BY uc.unit_name, DATE_FORMAT(c.updated_at, '%Y-%m')
                        ORDER BY MONTH, uc.unit_name;
                    `;
     
          const data = await this.stockInRepository.query(query)
    
          if (data.length > 0) {
            return new CommonResponse(true, 111, "Details retrieved successfully", data)
          } else {
            return new CommonResponse(false, 0, "No data found", [])
          }
        } catch (err) {
          throw (err)
        }
    
      }

      async getGrnQuantityForMISReport(req:MonthWiseShrimpReq): Promise<CommonResponse> {
        try {
          let query = `SELECT DATE(grn.grn_date) AS grnDate,SUM(grni.quantity) AS quantity,grn.plant_id,uc.unit_name
                        FROM ${appSettings.rm_procure_db}.grn grn
                        LEFT JOIN ${appSettings.rm_procure_db}.grn_items grni ON grni.grn_id=grn.grn_id
                        LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = grn.plant_id
                        WHERE YEAR(grn.grn_date) = '${req.year}' AND MONTH(grn.grn_date) = '${req.month}'
                        `

                        if (req.plantId) {
                            query += ` AND uc.unit_code_id = ${req.plantId}`;
                        }
                        query += `
                        GROUP BY MONTH(grn.grn_date)
                    `;
     
          const data = await this.stockInRepository.query(query)
    
          if (data.length > 0) {
            return new CommonResponse(true, 111, "Details retrieved successfully", data)
          } else {
            return new CommonResponse(false, 0, "No data found", [])
          }
        } catch (err) {
          throw (err)
        }
    
      }


      async getMISproductDetailedReport(req?:ProductAnalysisReq): Promise<CommonResponse> {
        const manager = getManager();
        let toDate = new Date(req.toDate);
        toDate.setDate(toDate.getDate() + 1);
        req.toDate = moment(toDate).format('YYYY-MM-DD')

        // (SUBSTRING_INDEX(pca.pack_style, '*', -1) * 0.453592) AS weightPerSlab,
        // IQF Product Info Query
        const iqfProductInfoQuery = `
            SELECT
                CONCAT(SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant))),'',pouch_weight,'',u.uom_name) AS productType, 
                SUM(pca.cartons * pca.pouches) + SUM(pca.loose_pouches) AS numberOfSlabs,
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'oz')}).value} , ((pouch_weight /16) * 0.454),
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'lb')}).value} ,(pouch_weight * 0.454),
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'gm')}).value} ,(pouch_weight / 1000),
                (pouch_weight)))) AS weightPerSlab,
                SUM(IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'oz')}).value} , (((((pca.cartons * pca.pouches) + pca.loose_pouches)*pouch_weight)/16) * 0.454),
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'lb')}).value} ,((((pca.cartons * pca.pouches)+pca.loose_pouches)*pouch_weight) * 0.454),
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'gm')}).value} ,((((pca.cartons * pca.pouches) + pca.loose_pouches)*pouch_weight) / 1000),
                (((pca.cartons * pca.pouches) + pca.loose_pouches)*pouch_weight))))) AS netTotalWeight,
                (SUM(pca.cartons * pca.pouches) + SUM(pca.loose_pouches)) * pca.gross_pouch_weight AS grossTotalWeight,
                SUM(pca.fg_to_hon_weight_kg) AS totalEquivalentHeadOnWeight,
                 (((SUM(pca.cartons * pca.pouches) + SUM(pca.loose_pouches)) * pca.gross_pouch_weight) /  SUM(pca.fg_to_hon_weight_kg)) * 100 AS yieldPercent,
                (SUM(pca.gross_pouch_weight) / (SELECT SUM(gross_pouch_weight) FROM erpx_dev_analytics.production_cost_analysis)) * 100 AS productionPercent,sku.value_addition_one_id as va1
            FROM
                ${appSettings.analytics_db} .production_cost_analysis pca
            LEFT JOIN ${appSettings.masters_db} .uoms u on u.uom_id = pca.uom_id
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku on sku.sku_code_id = pca.variant_id
            WHERE
                pca.va_4 = 'IQF' AND  pca.reported_date BETWEEN '${req.fromDate}' AND '${req.toDate}' 
            GROUP BY food_type,va_1,va_2,va_3, va_4, va_5,soak_style,product,pack_style`;
    
        // BLOCK Product Info Query
        const blockProductInfoQuery = `
            SELECT
                CONCAT(SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant))),'',pouch_weight,'',u.uom_name) AS productType,
                SUM(pca.cartons * pca.pouches) + SUM(pca.loose_pouches) AS numberOfSlabs, IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'oz')}).value} , ((pouch_weight /16) * 0.454),
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'lb')}).value} ,(pouch_weight * 0.454),
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'gm')}).value} ,(pouch_weight / 1000),
                (pouch_weight)))) AS weightPerSlab,
                  SUM(IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'oz')}).value} , (((((pca.cartons * pca.pouches) + pca.loose_pouches)*pouch_weight)/16) * 0.454),
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'lb')}).value} ,((((pca.cartons * pca.pouches)+pca.loose_pouches)*pouch_weight) * 0.454),
                IF(u.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'gm')}).value} ,((((pca.cartons * pca.pouches) + pca.loose_pouches)*pouch_weight) / 1000),
                (((pca.cartons * pca.pouches) + pca.loose_pouches)*pouch_weight))))) AS netTotalWeight,
                (SUM(pca.cartons * pca.pouches) + SUM(pca.loose_pouches)) * pca.gross_pouch_weight AS grossTotalWeight,
                SUM(pca.fg_to_hon_weight_kg) AS totalEquivalentHeadOnWeight,
      (((SUM(pca.cartons * pca.pouches) + SUM(pca.loose_pouches)) * pca.gross_pouch_weight) /  SUM(pca.fg_to_hon_weight_kg)) * 100 AS yieldPercent,
                (SUM(pca.gross_pouch_weight) / (SELECT SUM(gross_pouch_weight) FROM erpx_dev_analytics.production_cost_analysis)) * 100 AS productionPercent,sku.value_addition_one_id as va1
            FROM
                erpx_dev_analytics.production_cost_analysis pca
                 LEFT JOIN ${appSettings.masters_db} .uoms u on u.uom_id = pca.uom_id
             LEFT JOIN ${appSettings.masters_db} .sku_codes sku on sku.sku_code_id = pca.variant_id
            WHERE
                pca.va_4 = 'BLOCK' AND  pca.reported_date BETWEEN '${req.fromDate}' AND '${req.toDate}'
            GROUP BY food_type,va_1,va_2,va_3, va_4, va_5,soak_style,product,pack_style `;
    
        // Totals Query
        const totalsQuery = `
            SELECT
                SUM(combined.numberOfSlabs) AS totalNumberOfSlabs,
                SUM(combined.weightPerSlab) AS totalWeightPerSlab,
                SUM(combined.netTotalWeight) AS totalNetWeight,
                SUM(combined.grossTotalWeight) AS totalGrossWeight,
                SUM(combined.totalEquivalentHeadOnWeight) AS totalHeadOnWeight,
                SUM(combined.productionPercent) AS totalProduction,
                SUM(combined.yieldPercent) AS totalYieldPercent,
                SUM(combined.productionPercent) AS totalProductionPercent
            FROM (
                ${iqfProductInfoQuery}
                UNION ALL
                ${blockProductInfoQuery}
            ) AS combined
        `;
    
        // Production Quantity Query
        const productionQtyQuery = `
           SELECT 
                    gi.grn_id AS grnId,gi.grn_item_id AS grnItemId,
                    SUM(COALESCE(gi.quantity, 0)) AS quantity,
                    SUM(COALESCE(if(gi.reweighment_quantity,gi.reweighment_quantity,gi.quantity), 0)) AS reweighmentQuantity,
                     DATE(g.grn_date) AS grnDate
            FROM 
                erpx_dev_rm_procurement.grn_items gi
            LEFT JOIN 
                erpx_dev_rm_procurement.grn g 
            ON 
                g.grn_id = gi.grn_id
            WHERE 
                DATE(g.grn_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'
        `;
    
        // Execute the queries
        const iqfData = await manager.query(iqfProductInfoQuery);
        const blockData = await manager.query(blockProductInfoQuery);
        const totalsData = await manager.query(totalsQuery);
        const productionQtyData = await manager.query(productionQtyQuery);
    
        // Map data to models
        const iqfProductsInfo = iqfData.map(item => new MISProductInfo(
            item.productType,
            parseFloat(item.numberOfSlabs),
            parseFloat(item.weightPerSlab),
            parseFloat(item.netTotalWeight),
            parseFloat(item.grossTotalWeight),
            parseFloat(item.yieldPercent),
            parseFloat(item.totalEquivalentHeadOnWeight),
            parseFloat(item.production),
            parseFloat(item.va1)
        ));
    
        const blockProductsInfo = blockData.map(item => new MISProductInfo(
            item.productType,
            parseFloat(item.numberOfSlabs),
            parseFloat(item.weightPerSlab),
            parseFloat(item.netTotalWeight),
            parseFloat(item.grossTotalWeight),
            parseFloat(item.yieldPercent),
            parseFloat(item.totalEquivalentHeadOnWeight),
            parseFloat(item.production),
            parseFloat(item.va1)
        ));
    
        const totals = new ProductAnalysisTotals(
            parseFloat(totalsData[0].totalNumberOfSlabs),
            parseFloat(totalsData[0].totalWeightPerSlab),
            parseFloat(totalsData[0].totalNetWeight),
            parseFloat(totalsData[0].totalGrossWeight),
            parseFloat(totalsData[0].totalHeadOnWeight),
            parseFloat(totalsData[0].totalProduction),
            parseFloat(totalsData[0].totalYieldPercent),
            parseFloat(totalsData[0].totalProductionPercent)
        );
    
        const productionQuantity = productionQtyData.map(item => new ProductionQuantity(
            item.grnItemId,
            item.grnId,
            parseFloat(item.quantity),
            parseFloat(item.reweighmentQuantity),
            new Date(item.grnDate)
        ));
    
        const result = new MISProductDetailedReportModel(
            iqfProductsInfo,
            blockProductsInfo,
            totals,
            productionQuantity
        );
        if (result) {
            return new CommonResponse(true, 1, "Data Retrieved Successfully", result);
        } else {
            return new CommonResponse(false, 0, "No Data Found", []);
        }
    }

    async getStockStatementInfo(req:StockSTatementReq):Promise<StockStatementResponseModel>{
        // console.log(req,"v")
        try{
            const manager = getManager()
            const otherProducts = ['VPDTOFFBLKBKN/NS/BKN','VPUDTOFFBLKDC/NS/DC','VCPDTOFFIQFBKN/S2S2/12-15/120Min/BKN','VCPDTOFFIQFGII/S2S2/12-15/120MIN/61-70','VPDTONIQFBRD/NS/BRD','VHLSOIQFBRD/NS/BRD','VHLSOBLKDC/NS/DC']

            // const updated = otherProducts.map(str => `"${str}"`)
            const updated = otherProducts.map(str => `"${str}"`).join(", ");
            const plantIds = Array?.isArray(req.plantId) ? req.plantId : [req.plantId];


            // console.log(updated,"updated")


                 let jumbleinfoQuery = `SELECT SUM(cartons)AS totalCartons,SUM(loose_pouches) AS totalPouches,
                    CONCAT(SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant)))," ",pack_style)AS product,pouch_weight AS pouchWeight,grade,uc.unit_code_id
                    FROM  ${appSettings.analytics_db}.production_cost_analysis pc
                    LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=plant_id
                    LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_name = pc.grade
                    WHERE DATE(reported_date) = "${req.date}" AND product_category = '${ProductCategoryEnum.jumble}' AND transaction_type = '${TransactionType.rm}' `
                    
                    
                    if (req.plantId) {
                        jumbleinfoQuery = jumbleinfoQuery + ` AND uc.unit_code_id IN (${plantIds.join(",")})`;
                      }
                      jumbleinfoQuery = jumbleinfoQuery + ` GROUP BY  food_type,va_1,va_2,va_3, va_4, va_5,soak_style,product,pack_style,grade
                      ORDER BY( CASE WHEN grade_name REGEXP '^[0-9]' THEN 0 ELSE 1 END),
                     CAST(grade_min_count AS UNSIGNED) ASC,
                     CAST(grade_max_count AS UNSIGNED) ASC`
              const jumbleinfo = await manager.query(jumbleinfoQuery)


              let fginfoQuery = `SELECT SUM(cartons)AS totalCartons,SUM(loose_pouches) AS totalPouches,
              CONCAT(SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant)))," ",pack_style)AS product,pouch_weight AS pouchWeight,grade,uc.unit_code_id
              FROM  ${appSettings.analytics_db}.production_cost_analysis pc
              LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=plant_id
              LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_name = pc.grade
              WHERE DATE(reported_date) = "${req.date}" AND product_category = '${ProductCategoryEnum.GI}' AND transaction_type = '${TransactionType.rm}' `
              if (req.plantId) {
                fginfoQuery = fginfoQuery + ` AND uc.unit_code_id IN (${plantIds.join(",")})`;
              }
                fginfoQuery = fginfoQuery + ` GROUP BY  food_type,va_1,va_2,va_3, va_4, va_5,soak_style,product,pack_style,grade
                ORDER BY( CASE WHEN grade_name REGEXP '^[0-9]' THEN 0 ELSE 1 END),
                     CAST(grade_min_count AS UNSIGNED) ASC,
                     CAST(grade_max_count AS UNSIGNED) ASC`
            const fginfo = await manager.query(fginfoQuery)


            let totalQtyInKgsQuery = `SELECT SUM(fg_qty_kgs) AS totalQtyInKgs
            FROM  ${appSettings.analytics_db}.production_cost_analysis
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=plant_id
            WHERE DATE(reported_date) = "${req.date}" AND transaction_type = '${TransactionType.rm}' `
            if (req.plantId) {
                totalQtyInKgsQuery = totalQtyInKgsQuery + ` AND uc.unit_code_id IN (${plantIds.join(",")})`;
              }
           
          const totalQtyInKg = await manager.query(totalQtyInKgsQuery)


          let g2infoQuery = `SELECT SUM(cartons)AS totalCartons,SUM(loose_pouches) AS totalPouches,
              CONCAT(SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant)))," ",pack_style)AS product,pouch_weight AS pouchWeight,grade
              FROM  ${appSettings.analytics_db}.production_cost_analysis pc
               LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=plant_id
               LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_name = pc.grade
              WHERE DATE(reported_date) = "${req.date}" AND va_5 IN ("BKN", "DC", "GII", "BRD") AND transaction_type = '${TransactionType.rm}' `
               if (req.plantId) {
                g2infoQuery = g2infoQuery + ` AND uc.unit_code_id IN (${plantIds.join(",")})`;
              }
            g2infoQuery = g2infoQuery + ` GROUP BY  food_type,va_1,va_2,va_3, va_4, va_5,soak_style,product,pack_style,grade
            ORDER BY( CASE WHEN grade_name REGEXP '^[0-9]' THEN 0 ELSE 1 END),
                                CAST(grade_min_count AS UNSIGNED) ASC,
                                CAST(grade_max_count AS UNSIGNED) ASC`
            const g2info = await manager.query(g2infoQuery)

            let otherProductsinfoQuery = `SELECT SUM(cartons)AS totalCartons,SUM(loose_pouches) AS totalPouches,
            CONCAT(SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant)))," ",pack_style)AS product,pouch_weight AS pouchWeight,grade
            FROM  ${appSettings.analytics_db}.production_cost_analysis pc
             LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=plant_id
             LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_name = pc.grade
            WHERE DATE(reported_date) = "${req.date}" AND variant IN (${updated})`
            if (req.plantId) {
                otherProductsinfoQuery = otherProductsinfoQuery + ` AND uc.unit_code_id IN (${plantIds.join(",")})`;
              }
              otherProductsinfoQuery = otherProductsinfoQuery + ` GROUP BY  food_type,va_1,va_2,va_3, va_4, va_5,soak_style,product,pack_style,grade
              ORDER BY( CASE WHEN grade_name REGEXP '^[0-9]' THEN 0 ELSE 1 END),
                     CAST(grade_min_count AS UNSIGNED) ASC,
                     CAST(grade_max_count AS UNSIGNED) ASC`

          const otherProductsinfo = await manager.query(otherProductsinfoQuery)

          const inputDate = new Date(req.date)
          const year = inputDate.getFullYear();
          const month = String(inputDate.getMonth() + 1).padStart(2, '0');
          const day = String(inputDate.getDate()).padStart(2, '0');
          const fromDate = `${year}-${month}-1`
          const toDate = `${year}-${month}-${Number(day)}`

        //   console.log(fromDate,"formdate")
        //   console.log(toDate,"toDate")

          let gettotalProductionQuery = `SELECT SUM(fg_qty_kgs) AS totalProductionQtys
            FROM  ${appSettings.analytics_db}.production_cost_analysis
            LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id=plant_id
            WHERE DATE(reported_date) between '${fromDate}' AND '${toDate}' AND transaction_type = '${TransactionType.rm}' `
            if (req.plantId) {
                gettotalProductionQuery = gettotalProductionQuery + ` AND uc.unit_code_id IN (${plantIds.join(",")})`;
              }
          
          const totalProductionQty = await manager.query(gettotalProductionQuery)


            if(jumbleinfo.length > 0  || fginfo.length > 0 || totalQtyInKg.length > 0 || g2info.length > 0  || otherProductsinfo > 0 ){

                const jumbleDataModel: StockStatementProductInfo[] = []
                
                const fgDataModel: StockStatementProductInfo[] = []

                const g2DataModel: StockStatementProductInfo[] = []

                const otherDataModel: StockStatementProductInfo[] = []
  
                const jumbledataMap = new Map<string,StockStatementProductInfo>()
                for (const rec of jumbleinfo){
                    if(!jumbledataMap.has(rec.product)){
                        jumbledataMap.set(rec.product,new StockStatementProductInfo(rec.product,[]));
                    }
                    jumbledataMap.get(rec.product).gradesInfo.push(new StockStatementGradesInfo(rec.grade,rec.totalCartons,rec.totalPouches));
                }
                jumbledataMap.forEach(e => jumbleDataModel.push(e))

                const fgdataMap = new Map<string,StockStatementProductInfo>()
                for (const rec of fginfo){
                    if(!fgdataMap.has(rec.product)){
                        fgdataMap.set(rec.product,new StockStatementProductInfo(rec.product,[]));
                    }
                    fgdataMap.get(rec.product).gradesInfo.push(new StockStatementGradesInfo(rec.grade,rec.totalCartons,rec.totalPouches));
                }
                fgdataMap.forEach(e => fgDataModel.push(e))

                const g2dataMap = new Map<string,StockStatementProductInfo>()
                for (const rec of g2info){
                    if(!g2dataMap.has(rec.product)){
                        g2dataMap.set(rec.product,new StockStatementProductInfo(rec.product,[]));
                    }
                    g2dataMap.get(rec.product).gradesInfo.push(new StockStatementGradesInfo(rec.grade,rec.totalCartons,rec.totalPouches));
                 }
                 g2dataMap.forEach(e => g2DataModel.push(e))

                 const otherProductsDataMap = new Map<string,StockStatementProductInfo>()
                for (const rec of otherProductsinfo){
                    if(!otherProductsDataMap.has(rec.product)){
                        otherProductsDataMap.set(rec.product,new StockStatementProductInfo(rec.product,[]));
                    }
                    otherProductsDataMap.get(rec.product).gradesInfo.push(new StockStatementGradesInfo(rec.grade,rec.totalCartons,rec.totalPouches));
                }
                otherProductsDataMap.forEach(e => otherDataModel.push(e))

                  const finalData = new StockStatementModel(fgDataModel,jumbleDataModel,g2DataModel,otherDataModel,Number(totalProductionQty[0]?.totalProductionQtys),Number(totalQtyInKg[0].totalQtyInKgs))
            
 
                return  new StockStatementResponseModel(true,1,'Data retrieved',finalData)
            }else{
                return new StockStatementResponseModel(false,0,'No data found')
            }


        }catch(err){
            throw err
        }
    }
    
      
    async getStockValuationReport(req:ProductReq):Promise<StockValuationResponseModel>{
        try{
            const manager = getManager()
            const dateString = req?.fromDate;
            const parts = dateString?.split("-");
            const month = parseInt(parts[1], 10);
            let toDate = new Date(req?.toDate);
            toDate.setDate(toDate.getDate() + 1);
        let abstractInfo = []
        let productInfo = []
        let query = `SELECT  SUBSTRING(variant, 1, LENGTH(variant) - LOCATE('-', REVERSE(variant))) as variant, grade, pack_style, SUM(fg_qty_kgs) AS fgQtyKgs, fg_yield , SUM(cartons) AS cartons, SUM(loose_pouches) AS pouches,rm_count, AVG(rm_rate) AS rmRate, (sum(mfg_cost) + (AVG(rm_rate) * SUM(cal_rm_qty))) AS netCop,SUM(real_price_kg) AS realPriceKg,
        SUM(real_value) AS realValue,basis,product,pack_count,sum(cal_rm_qty) as calRmQty,(AVG(rm_rate) * SUM(cal_rm_qty)) as rmValue,sum(actual_mfg_cost) as actualMfgCost,product_category,sum(mfg_cost) as mfgCost
        FROM ${appSettings.analytics_db}.production_cost_analysis
        WHERE DATE(reported_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'
        GROUP BY food_type,va_1,va_2,va_3, va_4, va_5,soak_style,product,grade`
        const data = await manager.query(query)

        const mfgCost = `SELECT SUM(amount) AS price FROM ${appSettings.finance_db} .expenses WHERE category IN('Procurement Freight','LABOUR CHARGES','PROCESSING CHARGES','Electrical cost',
        'SOLAR UNITS INCOME','PACKING MAT','SALT & CHEM','QC COST','CONSUMABLES','OTHER DIR EXP','SALARIES','Finance cost','Depreciation','INSURANCE','ADMIN','Forwarding Expenses') AND month = ${month}`;
        const mfgCostData = await manager.query(mfgCost)

        const rmQtyQuery = `select sum(quantity) as rmQty from ${appSettings.rm_procure_db} .grn_items where created_at between '${req.fromDate}' and '${req.toDate}'`
        const rmQtyData = await manager.query(rmQtyQuery)

        const forwExpQuery = `SELECT amount FROM ${appSettings.finance_db} .expenses WHERE category = 'Forwarding Expenses' AND month = ${month}`
        const forwExpData = await manager.query(forwExpQuery)

        const mfgCostPerKg = Number(mfgCostData[0].price) / Number(rmQtyData[0].rmQty)
        const forwardExpAmount = forwExpData.length > 0 ? Number(forwExpData[0].amount) : 0
        const mfgCostPerKgForJumble = (Number(mfgCostData[0].price) - forwardExpAmount) / Number(rmQtyData[0].rmQty)

        const abstract = `SELECT SUM(fg_qty_kgs) AS qty,SUM(net_cop)AS cop,SUM(real_value) AS realisation,product_category
        FROM ${appSettings.analytics_db}.production_cost_analysis
        GROUP BY product_category`
        const abstractData = await manager.query(abstract)
        
        const exchangeRateQry = `SELECT exchange_rate from ${appSettings.masters_db} .exchange_rates er LEFT JOIN ${appSettings.masters_db} .currencies c ON c.currency_id = er.currency_id WHERE c.currency_name = 'USD'`
        const exchangeRate = await manager.query(exchangeRateQry)
        // let exchangeRate = 0
        const dataMap = new Map<number,StockValuationProductInfo>()
        const abstractMap = new Map<string,AbstractInfo>()
            // console.log(abstractData,'abstractData')
        if(abstractData.length>0){
            for(const rec of abstractData){
                let particular
                // console.log(rec.product_category)
                        if(rec.product_category == ProductCategoryEnum.GI){
                            particular = 'FG'
                        }else if(rec.product_category == ProductCategoryEnum.jumble){
                            particular = 'JUMBLE'
                        }else{
                            particular = 'GII/BRK/DC'
                        }
                    let copPerKg = Number(rec.cop)/Number(rec.qty)
                    let realPerKg = Number(rec.realisation)/Number(rec.qty)
                abstractInfo.push(new AbstractInfo(particular,rec.qty,rec.cop,copPerKg,rec.realisation,realPerKg))
            }
        }
        if(data.length>0){
        for(const val of data){
            let calRmQty:any= Number(Number(val.fg_qty_kgs)/Number(val.fg_yield)*100).toFixed(2)
            let rmValue = Number(Number(calRmQty)*Number(val.rmRate))
            let mfgCost = Number(calRmQty)*Number(mfgCostPerKgForJumble)
            productInfo.push(new StockValuationProductInfo(val.grade,val.variant,val.cartons,val.pouches,val.fgQtyKgs,val.fg_yield,val.pack_count,val.rm_count,val.rmRate,val.calRmQty,Math.round(val.rmValue),Math.round(val.mfgCost),val.netCop,val.realPriceKg,val.realValue,val.basis))
        }
        }
        const info = new StockValuationReportModel(mfgCostPerKgForJumble,mfgCostPerKg,exchangeRate[0].exchange_rate,productInfo,abstractInfo)
         return new StockValuationResponseModel(true,1,'Data Retrived SuccessFully',info)
        }catch(err){
            throw err
        }
    }


async getGradesOpeningStockForProductionReport(req: ProductSummaryReportReq): Promise<CommonResponse> {
    // console.log(req,"reqqqqqqqqqq service")
    try {
        const manager = getManager();

        let query = `
            SELECT dos.id, dos.variant_id, dos.pack_style_id, dos.cartons, dos.loose_pouches, dos.date,
                   sku.grade_id, 
                   CONCAT(SUBSTRING_INDEX(sku.short_code, '-', 2), ' ', pm.packing_method_name) AS modified_short_code, 
                   pm.packing_method_name, 
                   g.grade_name
            FROM erpx_dev_analytics.daywise_opening_stock dos
            LEFT JOIN erpx_dev_masters.sku_codes sku ON sku.sku_code_id = dos.variant_id
            LEFT JOIN erpx_dev_masters.packing_methods pm ON pm.packing_method_id = dos.pack_style_id
            LEFT JOIN erpx_dev_masters.grades g ON g.grade_id = sku.grade_id
            WHERE YEAR(dos.date) = '${req.year}' AND MONTH(dos.date) = '${req.month}'
        `;

        if (req.varientId) {
            query += ` AND dos.variant_id = ${req.varientId}`;
        }
        if (req.packStyleId) {
            query += ` AND dos.pack_style_id = ${req.packStyleId}`;
        }

        query += `
            GROUP BY dos.variant_id, dos.pack_style_id, 
                     sku.value_addition_one_id, sku.value_addition_two_id, 
                     sku.value_addition_three_id, sku.value_addition_four_id, 
                     sku.value_addition_five_id, sku.food_type_id
        `;

        const rawData = await manager.query(query);

        const processedData = rawData.map((item: any) => {
            const { packing_method_name, cartons, loose_pouches } = item;

            let num_packs = 0;
            let unit_weight = 0;
            let unit = '';

            if (packing_method_name.includes('X')) {
                const [packs, weightUnit] = packing_method_name.split('X');
                num_packs = parseInt(packs, 10) || 0;
                const weightParts = weightUnit.trim().split(' ');
                unit_weight = parseFloat(weightParts[0]) || 0;  
                unit = weightParts[1] ? weightParts[1].toLowerCase() : '';
            }

            switch (unit) {
                case 'kg':
                    unit_weight = unit_weight;
                    break;
                case 'lb':
                    unit_weight = unit_weight * 0.453592;  // lbs to kg
                    break;
                case 'oz':
                    unit_weight = unit_weight * 0.0283495;  // oz to kg
                    break;
                case 'gm':
                case 'g':
                    unit_weight = unit_weight * 0.001;  // grams to kg
                    break;
                default:
                    unit_weight = 0;  // Unknown unit, treat as 0
                    break;
            }

            const total_weight = (num_packs * cartons * unit_weight) + (loose_pouches * unit_weight);
            const total_weight_in_kg=(total_weight).toFixed(2)

            return {
                grade_id: item.grade_id,
                grade_name: item.grade_name,
                total_weight_in_kg
            };
        });

        if (processedData.length > 0) {
            return new CommonResponse(true, 111, 'Details retrieved successfully', processedData);
        } else {
            return new CommonResponse(false, 0, 'No data found', []);
        }
    } catch (err) {
        throw err;
    }
}


async getProductionGradeInfoForProductionReport(req: ProductSummaryReportReq): Promise<CommonResponse> {
    // console.log(req, "req service");
    try {
        const manager = getManager();

        let query = `
            SELECT r.reporting_log_id, r.reporting_date AS reportingDate, r.variant_id, r.pack_style_id, 
                   sum(r.reported_cases) AS cartons, sum(r.loose_pouches) AS loosePouches, r.transaction_type,
                   sku.grade_id, 
                   CONCAT(SUBSTRING_INDEX(sku.short_code, '-', 2), ' ', pm.packing_method_name) AS modified_short_code, 
                   pm.packing_method_name, 
                   g.grade_name
            FROM erpx_dev_warehouse.reporting r
            LEFT JOIN erpx_dev_masters.sku_codes sku ON sku.sku_code_id = r.variant_id
            LEFT JOIN erpx_dev_masters.packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN erpx_dev_masters.grades g ON g.grade_id = sku.grade_id
            WHERE YEAR(r.reporting_date) = '${req.year}' AND MONTH(r.reporting_date) = '${req.month}'
        `;

        if (req.varientId) {
            query += ` AND r.variant_id = ${req.varientId}`;
        }
        if (req.packStyleId) {
            query += ` AND r.pack_style_id = ${req.packStyleId}`;
        }

        query += `
            GROUP BY  r.variant_id, r.pack_style_id, r.reporting_date,
                     sku.value_addition_one_id, sku.value_addition_two_id, 
                     sku.value_addition_three_id, sku.value_addition_four_id, 
                     sku.value_addition_five_id, sku.food_type_id
            ORDER BY r.reporting_date     
        `;

        const rawData = await manager.query(query);

        const processedData = rawData.map((item: any) => {
            const { packing_method_name, cartons, loosePouches, reportingDate,transaction_type } = item;

            let num_packs = 0;
            let unit_weight = 0;
            let unit = '';

            if (packing_method_name) {
                const parts = packing_method_name.split('X');
                if (parts.length === 2) {
                    num_packs = parseInt(parts[0].trim(), 10) || 0;
                    const weightParts = parts[1].trim().split(' ');
                    unit_weight = parseFloat(weightParts[0]) || 0;
                    unit = weightParts[1] ? weightParts[1].toLowerCase() : '';
                }
            }

            switch (unit) {
                case 'kg':
                    unit_weight = unit_weight;
                    break;
                case 'lb':
                    unit_weight = unit_weight * 0.453592;  
                    break;
                case 'oz':
                    unit_weight = unit_weight * 0.0283495;
                    break;
                case 'gm':
                case 'g':
                    unit_weight = unit_weight * 0.001;  
                    break;
                default:
                    unit_weight = 0;  
                    break;
            }

            const total_weight= (num_packs * cartons * unit_weight) + (loosePouches * unit_weight);
            const total_weight_in_kg=(total_weight).toFixed(2)
            return {
                grade_id: item.grade_id,
                grade_name: item.grade_name,
                reportingDate: item.reportingDate,
                transaction_type:item.transaction_type,
                total_weight_in_kg: total_weight_in_kg || 0 
            };
        });

        if (processedData.length > 0) {
            return new CommonResponse(true, 111, 'Details retrieved successfully', processedData);
        } else {
            return new CommonResponse(false, 0, 'No data found', []);
        }
    } catch (err) {
        return new CommonResponse(false, 0, 'Error', err);
    }
}


async getShippedReprocessedGradeInfoForProductionReport(req: ProductSummaryReportReq): Promise<CommonResponse> {
    // console.log(req, "req service");
    try {
        const manager = getManager();

        let query = `
           SELECT flj.job_id, DATE(flj.date) AS date, flj.job_purpose,
            fli.sale_order_item_id, SUM(fli.job_cartons) AS cartons, SUM(fli.job_loose_pouches) AS loosePouches,
            soi.varient_id, soi.pack_style_id,
            sku.grade_id, 
            CONCAT(SUBSTRING_INDEX(sku.short_code, '-', 2), ' ', pm.packing_method_name) AS modified_short_code, 
            pm.packing_method_name, 
            g.grade_name
            FROM erpx_dev_warehouse.fork_lift_jobs flj
            LEFT JOIN erpx_dev_warehouse.fork_lift_items fli ON fli.fork_lift_job_id = flj.job_id
            LEFT JOIN erpx_dev_sales.sale_order_items soi ON soi.sale_order_item_id = fli.sale_order_item_id
            LEFT JOIN erpx_dev_masters.sku_codes sku ON sku.sku_code_id = soi.varient_id
            LEFT JOIN erpx_dev_masters.packing_methods pm ON pm.packing_method_id = soi.pack_style_id
            LEFT JOIN erpx_dev_masters.grades g ON g.grade_id = sku.grade_id
            WHERE YEAR(flj.date) = '${req.year}' AND MONTH(flj.date) = '${req.month}'
        `;

        if (req.varientId) {
            query += ` AND soi.varient_id = ${req.varientId}`;
        }
        if (req.packStyleId) {
            query += ` AND soi.pack_style_id = ${req.packStyleId}`;
        }

        query += `
            GROUP BY soi.varient_id, soi.pack_style_id, DATE(flj.date),
                     sku.value_addition_one_id, sku.value_addition_two_id, 
                     sku.value_addition_three_id, sku.value_addition_four_id, 
                     sku.value_addition_five_id, sku.food_type_id
            ORDER BY flj.date
        `;

        const rawData = await manager.query(query);

        const processedData = rawData.map((item: any) => {
            const { packing_method_name, cartons, loosePouches, date, job_purpose } = item;

            let num_packs = 0;
            let unit_weight = 0;
            let unit = '';

            if (packing_method_name) {
                const parts = packing_method_name.split('X');
                if (parts.length === 2) {
                    num_packs = parseInt(parts[0].trim(), 10) || 0;
                    const weightParts = parts[1].trim().split(' ');
                    unit_weight = parseFloat(weightParts[0]) || 0;
                    unit = weightParts[1] ? weightParts[1].toLowerCase() : '';
                }
            }

            switch (unit) {
                case 'kg':
                    unit_weight = unit_weight;
                    break;
                case 'lb':
                    unit_weight = unit_weight * 0.453592;  
                    break;
                case 'oz':
                    unit_weight = unit_weight * 0.0283495;
                    break;
                case 'gm':
                case 'g':
                    unit_weight = unit_weight * 0.001; 
                    break;
                default:
                    unit_weight = 0; 
                    break;
            }

            const total_weight = (num_packs * cartons * unit_weight) + (loosePouches * unit_weight);
            const total_weight_in_kg = (total_weight).toFixed(2);

            return {
                grade_id: item.grade_id,
                grade_name: item.grade_name,
                date: item.date, // Ensure the date is captured here
                job_purpose: item.job_purpose,
                total_weight_in_kg: total_weight_in_kg || 0
            };
        });

        const groupedData = processedData.reduce((acc: any, current: any) => {
            const key = `${current.date}_${current.varient_id}_${current.pack_style_id}_${current.grade_id}`;

            if (!acc[key]) {
                acc[key] = { ...current }; // Keep all fields including date
            } else {
                acc[key].total_weight_in_kg = (
                    parseFloat(acc[key].total_weight_in_kg) + parseFloat(current.total_weight_in_kg)
                ).toFixed(2);
            }

            return acc;
        }, {});

        // Convert grouped data back to an array
        const finalData = Object.values(groupedData);

        if (finalData.length > 0) {
            return new CommonResponse(true, 111, 'Details retrieved successfully', finalData);
        } else {
            return new CommonResponse(false, 0, 'No data found', []);
        }
    } catch (err) {
        throw err;
    }
}



async getShortCodeDropdown():Promise<CommonResponse>{
    try{
        const manager = getManager()
        const dataQuery = `SELECT sku.sku_code_id as varientId,(SUBSTRING_INDEX(sku.short_code, '-', 2)) AS shortCode
                                        FROM erpx_dev_masters.sku_codes sku
                                        WHERE sku.short_code!="NULL"
                                        GROUP BY shortCode`
        const data = await manager.query(dataQuery)
        if(data.length > 0){
            return new CommonResponse(true,1,'Data retrievd', data)
        }else{
            return new CommonResponse(false,0,'No data found')
        }
    }catch(err){
        throw err
    }
}

async getPackStyleForProductAnalysisReport():Promise<CommonResponse>{
    try{
        const manager = getManager()
        const dataQuery = `SELECT pm.packing_method_id AS packStyleId,pm.packing_method_name AS packingMethodName
                            FROM erpx_dev_masters.packing_methods pm 
                            WHERE pm.packing_method_id!="NULL"
                            GROUP BY pm.packing_method_name`
        const data = await manager.query(dataQuery)
        if(data.length > 0){
            return new CommonResponse(true,1,'Data retrievd', data)
        }else{
            return new CommonResponse(false,0,'No data found')
        }
    }catch(err){
        throw err
    }
}
 
    @Cron('0 0 * * *')
    async updateMontlyMisInfo():Promise<CommonResponse>{
        const queryManager = getManager()
        const connection = getConnection();
    const transManager: QueryRunner = connection.createQueryRunner();

        // const transManager = new GenericTransactionManager()
        // const transManager = queryManager.queryRunner
        try{
            const saveFalg = new Set<boolean>()
            await transManager.startTransaction()
            const cronObj = new CronInfo()
            cronObj.module = 'All'
            cronObj.description = 'Montly Mis'

            const updateExportSalesInfo = await this.createExportSalesInfo(transManager)
            // console.log(updateExportSalesInfo,'updateExportSalesInfo')
            if(!updateExportSalesInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateExportSalesInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateExportSalesInfo.internalMessage)
            }

            const updateLocalSalesInfo = await this.createlocalSalesInfo(transManager)
            // console.log(updateLocalSalesInfo,'updateLocalSalesInfo')
            if(!updateLocalSalesInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateLocalSalesInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateLocalSalesInfo.internalMessage)
            }

            const updateFreshProductionInfo = await this.createFreshProductionInfo(transManager)
            // console.log(updateFreshProductionInfo,'updateFreshProductionInfo')
            if(!updateFreshProductionInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateFreshProductionInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateFreshProductionInfo.internalMessage)
            }

            const updateReprocessProductionInfo = await this.createReprocessProductionInfo(transManager)
            // console.log(updateReprocessProductionInfo,'updateReprocessProductionInfo')
            if(!updateReprocessProductionInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateReprocessProductionInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateReprocessProductionInfo.internalMessage)
            }

            const updateRewighmentQtyInfo = await this.createRewighmentQtyInfo(transManager)
            // console.log(updateRewighmentQtyInfo,'updateRewighmentQtyInfo')
            if(!updateRewighmentQtyInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateRewighmentQtyInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateRewighmentQtyInfo.internalMessage)
            }

            const updateProcuredQtyInfo = await this.createprocuredQtyInfo(transManager)
            // console.log(updateProcuredQtyInfo,'updateProcuredQtyInfo')
            if(!updateProcuredQtyInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateProcuredQtyInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateProcuredQtyInfo.internalMessage)
            }

            const updateHonQtyInfo = await this.createhonQtyInfo(transManager)
            // console.log(updateHonQtyInfo,'updateHonQtyInfo')
            if(!updateHonQtyInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateHonQtyInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateHonQtyInfo.internalMessage)
            }

            const updatefgPurchaseQtyInfo = await this.createfgPurchaseQtyInfo(transManager)
            // console.log(updatefgPurchaseQtyInfo,'updatefgPurchaseQtyInfo')
            if(!updatefgPurchaseQtyInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updatefgPurchaseQtyInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updatefgPurchaseQtyInfo.internalMessage)
            }

            const updatetransferQtyInfo = await this.createtransferQtyInfo(transManager)
            // console.log(updatetransferQtyInfo,'updatetransferQtyInfo')
            if(!updatetransferQtyInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updatetransferQtyInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updatetransferQtyInfo.internalMessage)
            }

            const updateshippedContainersInfo = await this.createshippedContainersInfo(transManager)
            // console.log(updateshippedContainersInfo,'updateshippedContainersInfo')
            if(!updateshippedContainersInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateshippedContainersInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateshippedContainersInfo.internalMessage)
            }

            const updateRmCostInfo = await this.creatermCostInfo(transManager)
            // console.log(updateRmCostInfo,'updateRmCostInfo')
            if(!updateRmCostInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateRmCostInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateRmCostInfo.internalMessage)
            }

            const updateExpensesInfo = await this.createExpensesInfo(transManager)
            // console.log(updateExpensesInfo,'updatexepensesinfo')
            if(!updateExpensesInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateExpensesInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateExpensesInfo.internalMessage)
            }

            const updateproductPurchaseInfo = await this.createproductPurchaseInfo(transManager)
            // console.log(updateproductPurchaseInfo,'updateproductPurchaseInfo')
            if(!updateproductPurchaseInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updateproductPurchaseInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updateproductPurchaseInfo.internalMessage)
            }

            const updatepackMaterialCostInfoQry = await this.createpackMaterialCostInfoQry(transManager)
            // console.log(updatepackMaterialCostInfoQry,'updatepackMaterialCostInfoQry')
            if(!updatepackMaterialCostInfoQry.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updatepackMaterialCostInfoQry.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updatepackMaterialCostInfoQry.internalMessage)
            }

            const updatesaltChemCostInfo = await this.createsaltChemCostInfo(transManager)
            // console.log(updatesaltChemCostInfo,'updatesaltChemCostInfo')
            if(!updatesaltChemCostInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updatesaltChemCostInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updatesaltChemCostInfo.internalMessage)
            }

            const updatemaintainanceCostInfo = await this.createmaintainanceCostInfo(transManager)
            // console.log(updatemaintainanceCostInfo,'updatemaintainanceCostInfo')
            if(!updatemaintainanceCostInfo.status){
                saveFalg.add(false)
                cronObj.status = false
                cronObj.reason = updatemaintainanceCostInfo.internalMessage
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,updatemaintainanceCostInfo.internalMessage)
            }

           

            if(!(saveFalg.has(false))){
                cronObj.status = true
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.commitTransaction()
                await transManager.release()
                return new CommonResponse(true,1,'Saved Succesfully')

            }else{
                cronObj.status = false
                cronObj.reason = 'Something went wrong'
                const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
                await transManager.rollbackTransaction()
                await transManager.release()
                return new CommonResponse(false,0,'Something went wrong')
            }

        }catch(err){
            const cronObj = new CronInfo()
            cronObj.module = 'All'
            cronObj.description = 'Montly Mis'
            cronObj.status = false
            cronObj.reason = err.message
            const updateCronInfo = await transManager.manager.save(CronInfo,cronObj)
            // console.log(err,'=============')
            await transManager.rollbackTransaction()
            await transManager.release()
            return new CommonResponse(false,0,'Something went wrong',err)
        }
    }

    async dayWiseProductionReport(req : DayWiseProductionReq):Promise<DaywiseProductionResponseModel>{
        try{
            const queryManager = getManager()
            // console.log(req,'====req')
            const query = `SELECT batch_no AS batchNo, SUBSTRING_INDEX(variant, '-', 2) AS product, grade, pack_style AS packStyle, po_number AS saleOrderNum,end_customer AS buyer, fg_qty_kgs AS fgQtyInKgs, fg_yield AS fgYield, pack_count AS packCount,
            rm_count AS rmCount, rm_rate AS rnRatePerKg, rm_cost AS rmCostPerKg, mfg_cost AS mfgCosttPerKg, packing_cost AS packingCostPerKg, freight_frwd_cost AS freightAndForwardExp, sale_cost_kg_usd AS totalCostOfSalesPerKg,
            sale_cost_kg_inr AS inInr, sale_cost_lb_usd AS costOfSaleLbkgInUsd, sale_price AS SalesRateLbkgInUsd, profit_loss AS pLPerKgLbInUsd, incentives, total_pl AS totalPLPerKfLbInUsd
            FROM `+ appSettings.analytics_db +`.production_cost_analysis
            WHERE DATE(reported_date) BETWEEN '${moment(req.fromDate).format('YYYY-MM-DD')}' AND '${moment(req.toDate).format('YYYY-MM-DD')}'
            GROUP BY batch_no, variant, grade, pack_style, po_number, end_customer`

            const data = await queryManager.query(query)

            if(data.length > 0){
                return new DaywiseProductionResponseModel(true,1, 'Data retrieved successfully', data)
            }else{
                return new DaywiseProductionResponseModel(false,0, 'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async createExportSalesInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const getExportSalesInfoQry = `SELECT date,tot_issued_quantity,unit_id,job_id FROM ${appSettings.warehouse_db} .fork_lift_jobs 
            WHERE job_purpose = '${ForkJobPurpose.Dispatch}' AND montly_mis_flag = 0`
            const getExportSalesInfo = await queryManager.query(getExportSalesInfoQry)
            if(getExportSalesInfo.length > 0){
                for(const rec of getExportSalesInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.DISPATCHED_QTY
                    entityObj.date = rec.date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.job_id
                    entityObj.refTable = 'fork_lift_jobs'
                    entityObj.type = 'Income'
                    entityObj.value = rec.tot_issued_quantity
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving export sale info')
                    }else{
                        const updateQry =  `update ${appSettings.warehouse_db} .fork_lift_jobs set montly_mis_flag = 1 where job_id = ${rec.job_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createlocalSalesInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const getLocalSalesInfoQry = `SELECT id AS domesticSaleId,quantity,amount,sale_order_date,unit_id FROM ${appSettings.sales_db} .domestic_sales WHERE  montly_mis_flag = 0`
            const getLocalSlaesInfo = await queryManager.query(getLocalSalesInfoQry)
            if(getLocalSlaesInfo.length > 0){
                for(const rec of getLocalSlaesInfo){
                    for(let i=0;i<=2;i++){
                        const entityObj = new MontlyMisEntity()
                        entityObj.columnName = i==1 ? MontlyMisColumnsJson.LOCAL_SALE_QTY : MontlyMisColumnsJson.DOMESTIC_SALE_AMOUNT
                        entityObj.date = rec.sale_order_date
                        entityObj.plantId = rec.unit_id
                        entityObj.refId = rec.domesticSaleId
                        entityObj.refTable = 'domestic_sales'
                        entityObj.value = i==1 ? rec.quantity : rec.amount
                        entityObj.type = 'Income'   
                        const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                        if(!save){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in saving domestic sale info')
                        }else{
                            const updateQry = `update ${appSettings.sales_db} .domestic_sales set montly_mis_flag = 1 where id = ${rec.domesticSaleId}`
                            const updateFlag = await transManager.query(updateQry)
                            if(!updateFlag){
                                // await transManager.rollbackTransaction()
                                // await transManager.release()
                                return new CommonResponse(false,0,'Something went wrong in updating flag')
                            }else{
                                return new CommonResponse(true,1,'Updated successfully')
                            }
                        }
                    } 
                }
            }else{
            return new CommonResponse(true,0,'No data found')

            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createFreshProductionInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const freshProdInfoQry = `SELECT reporting_log_id,reporting_date,unit_id,
            IF(u.uom_name = 'OZ' , ((((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 16) * 0.454), 
            IF(u.uom_name = 'LBS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) * 0.454), 
            IF(uom_name = 'GMS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 1000),
            ((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row))))) AS qty
            FROM ${appSettings.warehouse_db} .reporting r 
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .uoms u ON u.uom_id = pm.uom_id 
            WHERE transaction_type = '${TransactionType.rm}' AND r.montly_mis_flag = 0`
            const freshProdInfo = await queryManager.query(freshProdInfoQry)
            if(freshProdInfo.length > 0){
                for(const rec of freshProdInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.FRESH_PRODUCTION_QTY
                    entityObj.date = rec.reporting_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.reporting_log_id
                    entityObj.refTable = 'reporting'
                    entityObj.value = rec.qty
                    entityObj.type = 'Income'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving Fresh production info')
                    }else{
                        const updateQry = `update ${appSettings.warehouse_db} .reporting set montly_mis_flag = 1 where reporting_log_id = ${rec.reporting_log_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createReprocessProductionInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const freshProdInfoQry = `SELECT reporting_log_id,reporting_date,unit_id,
            IF(u.uom_name = 'OZ' , ((((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 16) * 0.454), 
            IF(u.uom_name = 'LBS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) * 0.454), 
            IF(uom_name = 'GMS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 1000),
            ((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row))))) AS qty
            FROM ${appSettings.warehouse_db} .reporting r 
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .uoms u ON u.uom_id = pm.uom_id 
            WHERE transaction_type IN ('${TransactionType.reprocessing}','${TransactionType.rework}') AND r.montly_mis_flag = 0`
            const freshProdInfo = await queryManager.query(freshProdInfoQry)
            if(freshProdInfo.length > 0){
                for(const rec of freshProdInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.FRESH_PRODUCTION_QTY
                    entityObj.date = rec.reporting_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.reporting_log_id
                    entityObj.refTable = 'reporting'
                    entityObj.value = rec.qty
                    entityObj.type = 'Income'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving Reproduction info')
                    }else{
                        const updateQry = `update ${appSettings.warehouse_db} .reporting set montly_mis_flag = 1 where reporting_log_id = ${rec.reporting_log_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createRewighmentQtyInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const rewighmentQtyInfoQry = `SELECT reweighment_quantity,r.created_at,gi.grn_item_id ,r.plant_id
            FROM ${appSettings.rm_procure_db} .grn_items gi
            LEFT JOIN ${appSettings.rm_procure_db} .rm_re_weighing r ON r.grn_item_id = gi.grn_item_id
            WHERE reweighment_quantity IS NOT NULL AND gi.reweigh_mis_flag = 0
            GROUP BY gi.grn_item_id`
            const reweighmentQtyInfo = await queryManager.query(rewighmentQtyInfoQry)
            if(reweighmentQtyInfo.length > 0){
                for(const rec of reweighmentQtyInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.RECEIVED_RM_PURCHASE_QTY
                    entityObj.date = rec.created_at
                    entityObj.plantId = rec.plant_id
                    entityObj.refId = rec.grn_item_id
                    entityObj.refTable = 'grn_items'
                    entityObj.value = rec.reweighment_quantity
                    entityObj.type = 'Income'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving reweighment info')
                    }else{
                        const updateQry = `update ${appSettings.rm_procure_db} .grn_items set reweigh_mis_flag = 1 where grn_item_id = ${rec.grn_item_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createprocuredQtyInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const procuredQtyInfoQry = `SELECT IF(i.harvest_type = 'Re Weighment' , reweighment_quantity,gi.quantity) AS qty,gi.grn_item_id,i.plant_id ,IF(i.harvest_type = 'Re Weighment' , rw.created_at,gi.created_at) AS date
            FROM ${appSettings.rm_procure_db} .grn_items gi
            LEFT JOIN ${appSettings.rm_procure_db} .indent i ON i.indent_id = gi.indent_id
            LEFT JOIN ${appSettings.rm_procure_db} .rm_re_weighing rw ON rw.grn_item_id = gi.grn_item_id
            WHERE IF(i.harvest_type = 'Re Weighment' , reweighment_quantity,gi.quantity) IS NOT NULL AND gi.procure_mis_flag = 0`
            const procuredQtyInfo = await queryManager.query(procuredQtyInfoQry)
            if(procuredQtyInfo.length > 0){
                for(const rec of procuredQtyInfo){
                    // console.log(rec,'====')
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.PROCURED_RM_PURCHASE_QTY
                    entityObj.date = rec.date
                    entityObj.plantId = rec.plant_id
                    entityObj.refId = rec.grn_item_id
                    entityObj.refTable = 'grn_items'
                    entityObj.value = rec.qty
                    entityObj.type = 'Income'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving procured qty info')
                    }else{
                        const updateQry = `update ${appSettings.rm_procure_db} .grn_items set procure_mis_flag = 1 where grn_item_id = ${rec.grn_item_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }


    async createhonQtyInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
             const honQtyInfoQry = `SELECT IF(u.uom_name = 'OZ' , ((((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 16) * 0.454), 
            IF(u.uom_name = 'LBS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) * 0.454), 
            IF(uom_name = 'GMS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 1000),
            ((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row))))) AS qty,r.unit_id,
            reporting_date,reporting_log_id
            FROM ${appSettings.warehouse_db} .reporting r
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = r.variant_id
            LEFT JOIN ${appSettings.masters_db} .value_addition_one_types v ON v.value_addition_one_id = sku.value_addition_one_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .uoms u ON u.uom_id = pm.uom_id
            WHERE v.code = 'HOSO' AND r.hon_qty_mis_flag = 0`
            const honQtyInfo = await queryManager.query(honQtyInfoQry)
            if(honQtyInfo.length > 0){
                for(const rec of honQtyInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.HON_FG_QTY
                    entityObj.date = rec.reporting_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.reporting_log_id
                    entityObj.refTable = 'reporting'
                    entityObj.value = rec.qty
                    entityObj.type = 'Income'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving HON qty info')
                    } else{
                        const updateQry = `update ${appSettings.warehouse_db} .reporting set hon_qty_mis_flag = 1 where reporting_log_id = ${rec.reporting_log_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createfgPurchaseQtyInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const fgPurchaseQtyInfoQry = `SELECT IF(u.uom_name = 'OZ' , ((((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 16) * 0.454), 
            IF(u.uom_name = 'LBS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) * 0.454), 
            IF(uom_name = 'GMS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 1000),
            ((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row))))) AS qty,unit_id,
            reporting_date,reporting_log_id
            FROM ${appSettings.warehouse_db} .reporting r
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .uoms u ON u.uom_id = pm.uom_id
            WHERE transaction_type = '${TransactionType.productPurchase}' AND r.montly_mis_flag = 0`
            const fgPurchaseQtyInfo = await queryManager.query(fgPurchaseQtyInfoQry)
            if(fgPurchaseQtyInfo.length > 0){
                for(const rec of fgPurchaseQtyInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.FG_PURCHASE_QTY
                    entityObj.date = rec.reporting_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.reporting_log_id
                    entityObj.refTable = 'reporting'
                    entityObj.value = rec.qty
                    entityObj.type = 'Income'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving FG purchase qty info')
                    }else{
                        const updateQry = `update ${appSettings.warehouse_db} .reporting set montly_mis_flag = 1 where reporting_log_id = ${rec.reporting_log_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createtransferQtyInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const transferQtyInfoQry = `SELECT IF(u.uom_name = 'OZ' , ((((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 16) * 0.454), 
            IF(u.uom_name = 'LBS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) * 0.454), 
            IF(uom_name = 'GMS' ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 1000),
            ((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row))))) AS qty,unit_id,
            reporting_date,reporting_log_id
            FROM ${appSettings.warehouse_db} .reporting r
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
            LEFT JOIN ${appSettings.masters_db} .uoms u ON u.uom_id = pm.uom_id
            WHERE transaction_type = '${TransactionType.stockTransfer}' AND r.montly_mis_flag = 0`
            const transferQtyInfo = await queryManager.query(transferQtyInfoQry)
            if(transferQtyInfo.length > 0){
                for(const rec of transferQtyInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.TRANSFER_QTY
                    entityObj.date = rec.reporting_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.reporting_log_id
                    entityObj.refTable = 'reporting'
                    entityObj.value = rec.qty
                    entityObj.type = 'Income'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving domestic sale info')
                    }else{
                        const updateQry = `update ${appSettings.warehouse_db} .reporting set montly_mis_flag = 1 where reporting_log_id = ${rec.reporting_log_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createshippedContainersInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
           const shippedContainerInfoQry = `SELECT shipped_onboard_date,unit_id,container_id
            FROM ${appSettings.logistics_db} .container c 
            WHERE STATUS = '${ContainerStatusEnum.SHIPPED}' AND shipped_onboard_date != NULL AND ship_containers_mis_flag = 0`
            const shippedContainerInfo = await queryManager.query(shippedContainerInfoQry)
            if(shippedContainerInfo.length > 0){
                for(const rec of shippedContainerInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.SHIPPED_CONTAINERS
                    entityObj.date = rec.shipped_onboard_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.container_id
                    entityObj.refTable = 'container'
                    entityObj.value = 1
                    entityObj.type = 'Income'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving shipped containers info')
                    }else{
                        const updateQry = `update ${appSettings.logistics_db} .container set ship_containers_mis_flag = 1 where container_id = ${rec.container_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async creatermCostInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
           const rmCostInfoQry = `SELECT total_amount,invoice_date,rm_invoice_id,plant_id FROM ${appSettings.rm_procure_db} .rm_invoice WHERE mis_flag = 0`
            const rmCostInfo = await queryManager.query(rmCostInfoQry)
            if(rmCostInfo.length > 0){
                for(const rec of rmCostInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.RM_COST
                    entityObj.date = rec.invoice_date
                    entityObj.plantId = rec.plant_id
                    entityObj.refId = rec.rm_invoice_id
                    entityObj.refTable = 'rm_invoice'
                    entityObj.value = rec.total_amount
                    entityObj.type = 'Expenditure'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving RM costinfo')
                    }else{
                        const updateQry = `update ${appSettings.rm_procure_db} .rm_invoice set mis_flag = 1 where rm_invoice_id = ${rec.rm_invoice_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createExpensesInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
           const expensesInfoQry = `SELECT e.ocean_frieght,e.domestic_frieght,expenses_logistics_id,anti_dumping_duty,duty_drawback,rodtep_amount,sales_comission,e.created_at,c.country_name,soi.processing_unit 
             FROM ${appSettings.logistics_db} .expenses e
            LEFT JOIN ${appSettings.sales_db} .so_invoice_details soi ON soi.sale_order_id = e.sale_order_id
            LEFT JOIN ${appSettings.masters_db} .countries c ON c.country_id = soi.country_id
            WHERE e.mis_flag = 0`
            const expensesInfo = await queryManager.query(expensesInfoQry)
            if(expensesInfo.length > 0){
                for(const rec of expensesInfo){
                    for(let i=1 ; i<=6;i++){
                        const entityObj = new MontlyMisEntity()
                        entityObj.columnName = i==1 ? (rec.country_name == 'USA' ? MontlyMisColumnsJson.OCEAN_FREIGHT_USA : rec.country_name == 'CANADA' ? MontlyMisColumnsJson.OCEAN_FREIGHT_CANADA : rec.country_name == 'JAPAN' || rec.country_name == 'CHINA' || rec.country_name == 'UAE' ? MontlyMisColumnsJson.OCEAN_FREIGHT_JAPAN_CHINA_UAE : MontlyMisColumnsJson.OCEAN_FREIGHT_REMAINING) : i== 2 ? MontlyMisColumnsJson.LOCAL_FREIGHT : i== 3 ? MontlyMisColumnsJson.ANTI_DUMPING_DUTY : i==4 ? MontlyMisColumnsJson.SALES_COMMISSION : i==5 ? MontlyMisColumnsJson.DUTY_DRAWBACK : i==6 ? MontlyMisColumnsJson.RODTEP_AMOUNT : ''
                        entityObj.date = rec.created_at
                        entityObj.plantId = rec.processing_unit
                        entityObj.refId = rec.expenses_logistics_id
                        entityObj.refTable = 'expenses'
                        entityObj.value = i==1 ? rec.ocean_frieght : i== 2 ? rec.domestic_frieght : i== 3 ? rec.anti_dumping_duty : i==4 ? rec.sales_comission : i==5 ? rec.duty_drawback : i==6 ? rec.rodtep_amount : ''
                        entityObj.type = 'Expenditure'   
                        const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                        if(!save){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in saving expenses info')
                        }else{
                        const updateQry = `update ${appSettings.logistics_db} .expenses set mis_flag = 1 where expenses_logistics_id = ${rec.expenses_logistics_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createproductPurchaseInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
           const productPurchaseInfoQry = `SELECT total_amount,purchase_product_id,p.purchase_date,p.unit_id
            FROM ${appSettings.finance_db} .purchase_products pp 
            LEFT JOIN ${appSettings.finance_db} .purchases p ON p.purchase_id = pp.purchase_id WHERE mis_flag = 0`
            const productPurchseInfo = await queryManager.query(productPurchaseInfoQry)
            if(productPurchseInfo.length > 0){
                for(const rec of productPurchseInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.PRODUCT_PURCHASE_COST
                    entityObj.date = rec.purchase_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.purchase_product_id
                    entityObj.refTable = 'purchase_products'
                    entityObj.value = rec.total_amount
                    entityObj.type = 'Expenditure'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving product purchase cost info')
                    }
                else{
                        const updateQry = `update ${appSettings.finance_db} .purchase_products set mis_flag = 1 where purchase_product_id = ${rec.purchase_product_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createpackMaterialCostInfoQry(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
           const packMaterialCostInfoQry = `SELECT store_consumption_id,sc.item_id,AVG(poi.item_cost) * sc.issued_quantity AS price,consumed_date,unit_id
            FROM ${appSettings.procure_db} .store_consumption sc 
            LEFT JOIN ${appSettings.procure_db} .purchase_order_items poi ON  poi.item_name = sc.item_id
            LEFT JOIN ${appSettings.masters_db} .item_categories ic ON ic.item_category_id = poi.item_category
            WHERE ic.item_category = 'Packing Material' AND mis_flag = 0
            GROUP BY store_consumption_id`
            const packMaterialCostInfo = await queryManager.query(packMaterialCostInfoQry)
            if(packMaterialCostInfo.length > 0){
                for(const rec of packMaterialCostInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.PRODUCT_PURCHASE_COST
                    entityObj.date = rec.consumed_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.store_consumption_id
                    entityObj.refTable = 'store_consumption'
                    entityObj.value = rec.price
                    entityObj.type = 'Expenditure'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving pack material cost info')
                    }
                else{
                        const updateQry = `update ${appSettings.procure_db} .store_consumption set mis_flag = 1 where store_consumption_id = ${rec.store_consumption_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createsaltChemCostInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
          const saleChemCostInfoQry = `SELECT store_consumption_id,sc.item_id,AVG(poi.item_cost) * sc.issued_quantity AS price,consumed_date,unit_id
            FROM ${appSettings.procure_db} .store_consumption sc 
            LEFT JOIN ${appSettings.procure_db} .purchase_order_items poi ON  poi.item_name = sc.item_id
            LEFT JOIN ${appSettings.masters_db} .item_categories ic ON ic.item_category_id = poi.item_category 
            LEFT JOIN ${appSettings.masters_db} .item_sub_categories isc ON isc.item_sub_category_id = poi.item_sub_category_id
            WHERE isc.item_sub_category = 'Salt and Chemicles' AND mis_flag = 0
            GROUP BY store_consumption_id`
            const saleChemCostInfo = await queryManager.query(saleChemCostInfoQry)
            if(saleChemCostInfo.length > 0){
                for(const rec of saleChemCostInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.SALT_CHEM_PACK_COST
                    entityObj.date = rec.consumed_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.store_consumption_id
                    entityObj.refTable = 'store_consumption'
                    entityObj.value = rec.price
                    entityObj.type = 'Expenditure'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving salt & chemical cost info')
                    }
                else{
                        const updateQry = `update ${appSettings.procure_db} .store_consumption set mis_flag = 1 where store_consumption_id = ${rec.store_consumption_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createconsumableCostInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
          const consumableCostInfoQry = `SELECT store_consumption_id,sc.item_id,AVG(poi.item_cost) * sc.issued_quantity AS price,consumed_date,unit_id
            FROM ${appSettings.procure_db} .store_consumption sc 
            LEFT JOIN ${appSettings.procure_db} .purchase_order_items poi ON  poi.item_name = sc.item_id
            LEFT JOIN ${appSettings.masters_db} .item_categories ic ON ic.item_category_id = poi.item_category 
            LEFT JOIN ${appSettings.masters_db} .item_sub_categories isc ON isc.item_sub_category_id = poi.item_sub_category_id
            WHERE isc.item_sub_category IN ('Sanitation Consumbales','Production Consumables','Non production Consumbales','Canteen Consumables' ) AND mis_flag = 0
            GROUP BY store_consumption_id`
            const consumableCostInfo = await queryManager.query(consumableCostInfoQry)
            if(consumableCostInfo.length > 0){
                for(const rec of consumableCostInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.CONSUMABLE_COST
                    entityObj.date = rec.consumed_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.store_consumption_id
                    entityObj.refTable = 'store_consumption'
                    entityObj.value = rec.price
                    entityObj.type = 'Expenditure'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving consumable cost info')
                    }
                else{
                        const updateQry = `update ${appSettings.procure_db} .store_consumption set mis_flag = 1 where store_consumption_id = ${rec.store_consumption_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async createmaintainanceCostInfo(transManager:QueryRunner):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
          const maintainanceCostInfoQry = `SELECT store_consumption_id,sc.item_id,AVG(poi.item_cost) * sc.issued_quantity AS price,consumed_date,unit_id
            FROM ${appSettings.procure_db} .store_consumption sc 
            LEFT JOIN ${appSettings.procure_db} .purchase_order_items poi ON  poi.item_name = sc.item_id
            LEFT JOIN ${appSettings.masters_db} .item_categories ic ON ic.item_category_id = poi.item_category 
            LEFT JOIN ${appSettings.masters_db} .item_sub_categories isc ON isc.item_sub_category_id = poi.item_sub_category_id
            WHERE isc.item_sub_category IN  ('Electrical Material','Mechanical Material','Plumbing Material','ETP and WTP Material') AND mis_flag = 0
            GROUP BY store_consumption_id`
            const maintainanceCostInfo = await queryManager.query(maintainanceCostInfoQry)
            if(maintainanceCostInfo.length > 0){
                for(const rec of maintainanceCostInfo){
                    const entityObj = new MontlyMisEntity()
                    entityObj.columnName = MontlyMisColumnsJson.MAINTAINANCE_COST
                    entityObj.date = rec.consumed_date
                    entityObj.plantId = rec.unit_id
                    entityObj.refId = rec.store_consumption_id
                    entityObj.refTable = 'store_consumption'
                    entityObj.value = rec.price
                    entityObj.type = 'Expenditure'   
                    const save = await transManager.manager.save(MontlyMisEntity,entityObj)  
                    if(!save){
                        // await transManager.rollbackTransaction()
                        // await transManager.release()
                        return new CommonResponse(false,0,'Something went wrong in saving maintainance cost info')
                    }
                else{
                        const updateQry = `update ${appSettings.procure_db} .store_consumption set mis_flag = 1 where store_consumption_id = ${rec.store_consumption_id}`
                        const updateFlag = await transManager.query(updateQry)
                        if(!updateFlag){
                            // await transManager.rollbackTransaction()
                            // await transManager.release()
                            return new CommonResponse(false,0,'Something went wrong in updating flag')
                        }else{
                            return new CommonResponse(true,1,'Updated successfully')
                        }
                    }
                }
            }else{
                return new CommonResponse(true,1,'No data found')
            }
        }catch(err){
            // await transManager.rollbackTransaction()
            // await transManager.release()
            return new CommonResponse(false,0,'Something went wrong in updating flag')
        }
    }

    async getMontlyMisInfo(req:MontlyMisInfoReq):Promise<CommonResponse>{
        const queryManager = getManager()
        try{
            const monthNames = ['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SPETEMBER','OCTOBER','NOVEMBER','DECEMBER']
            const monthsArray = [4,5,6,7,8,9,10,11,12,1,2,3]
            const monthIndex = monthsArray.findIndex(e => e === req.month)
            // console.log(monthIndex,'getmonths')
            const monthReq =monthsArray.slice(0, monthIndex+1);

            let getFromExcelQry = `SELECT category as column_name,amount as value,month FROM ${appSettings.finance_db} .expenses_log WHERE month IN (${monthReq}) AND year = ${req.year} and plant_id = ${req.plantId}`
            const excelInfo = await queryManager.query(getFromExcelQry)
            const excelInfoMap = new Map<string,any[]>()
            for(const rec of excelInfo){
                if(!excelInfoMap.has(rec.month)){
                    excelInfoMap.set(rec.month,[])
                }
                excelInfoMap.get(rec.month).push(rec)
            }
            // console.log(excelInfoMap,'=================')

            
            let infoqry = `SELECT column_name,SUM(VALUE) as value,plant_id,MONTH(DATE) AS month,YEAR(date) as year FROM ${appSettings.analytics_db} .montly_mis`
            // if(req.month){
            //     infoqry += ` WHERE MONTH(date) IN (${monthReq}) AND YEAR(date) = ${req.year}`
            // }
            if (req.month && req.year) {
                const month = req.month; 
                const year = req.year;
            
                let startDate: string;
                let endDate: string;
            
                // Determine start date based on the month
                if (month >= 4) {
                    // If month is April or later, start from April of the current year
                    startDate = `${year}-04-01`;
                } else {
                    // If month is before April, start from April of the previous year
                    startDate = `${year - 1}-04-01`;
                }
            
                // Determine end date based on the given month and year (last day of the given month)
                endDate = `${year}-${String(month).padStart(2, '0')}-01`;
            
                // Construct the WHERE clause with the financial year logic
                infoqry += ` WHERE DATE >= '${startDate}' AND DATE < DATE_ADD('${endDate}', INTERVAL 1 MONTH) `;
            }
           infoqry += ` GROUP BY column_name,MONTH(DATE)`
            if(req.plantId){
                infoqry += `,plant_id`
            }
            infoqry += ` ORDER BY YEAR(date),MONTH(date)`
            const info = await queryManager.query(infoqry)
            // console.log(info,'===info')
            const misInfo = []
            if(info.length > 0){
                const infoMap = new Map<string,Map<string,any[]>>()
    
                for(const rec of info){
                    if(!(infoMap.has(rec.month))){
                        infoMap.set(rec.month,new Map<string,any[]>())
                    }
                    const columnMap = infoMap.get(rec.month)
    
                    if(!(columnMap.has(rec.column_name))){
                        columnMap.set(rec.column_name,[])
                    }
    
                    columnMap.get(rec.column_name).push(rec)
                    if(excelInfoMap.has(rec.month)){
                        const excelData = excelInfoMap.get(rec.month)
                        for(const e of excelData){
                            if(!columnMap.has(e.column_name)){
                                columnMap.set(e.column_name,[])
                            }
                            columnMap.get(e.column_name).push(e)
                        }
                    }

                }
                // console.log(infoMap,'========')

                infoMap.forEach(monthInfo => {
                    const columnInfoArray= []
                    monthInfo.forEach(columnInfo => {
                        columnInfoArray.push(new ColumnsInfoModel(columnInfo[0].column_name,Number(columnInfo[0].value),columnInfo[0].plant_id,columnInfo[0].month,columnInfo[0].year))
                    })
                    // console.log(monthInfo,'monthInfo')
                    misInfo.push(new MontlyMisModel(monthNames[columnInfoArray[0].month - 1],columnInfoArray[0].year,columnInfoArray))
                })
    
                return new CommonResponse(true,1,'Data retrieved',misInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
            

        }catch(err){
            throw err
        }
    }

    async getLotWiseReportInfo(req:DateFilter):Promise<LotWiseInfoResponseModel>{
        const manager = getManager()
        try{
          let lotWisePoInfoQry = `SELECT r.reporting_date AS date,r.lot_code AS lotNumber,sku.short_code AS variety,pm.packing_method_name AS packing,g.grade_name AS grade,r.reported_cases AS cartons,r.loose_pouches AS loosePouches,inv.po_number AS poNumber,b.brand_name AS brand,v4.code AS section,
          uc.plant_code AS productionLocation,r.product_category AS productCategory,
          IF(pm.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'oz')}).value} , ((((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 16) * 0.454), 
          IF(pm.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'lb')}).value} ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) * 0.454), 
          IF(pm.uom_id = ${UnitsOfWeightInput.find(e => {return(e.name == 'gm')}).value} ,(((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row)) / 1000),
          ((r.reported_cases * pm.no_of_pouches * pm.pouches_per_row) + (r.loose_pouches * pm.pouches_per_row))))) AS qty
          FROM ${appSettings.warehouse_db} .reporting r
          LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = r.variant_id
          LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = r.pack_style_id
          LEFT JOIN ${appSettings.masters_db} .grades g ON g.grade_id = sku.grade_id
          LEFT JOIN ${appSettings.sales_db} .so_invoice_details inv ON inv.sale_order_id = r.sale_order_id
          LEFT JOIN ${appSettings.sales_db} .sale_order_items soi ON soi.sale_order_item_id = r.sale_order_item_id
          LEFT JOIN ${appSettings.masters_db} .brands b ON b.brand_id = soi.brand_id
          LEFT JOIN ${appSettings.masters_db} .unitcodes uc ON uc.unit_code_id = inv.processing_unit
          LEFT JOIN ${appSettings.masters_db} .uoms u ON u.uom_id = pm.uom_id
          LEFT JOIN ${appSettings.masters_db} .value_addition_four_types v4 on v4.value_addition_four_id = sku.value_addition_four_id
          WHERE r.reporting_log_id > 0 `
          if(req.fromDate != undefined){
            lotWisePoInfoQry += ` AND r.reporting_date BETWEEN '${req.fromDate}' AND '${req.toDate}'`
          }
          lotWisePoInfoQry += ` ORDER BY r.reporting_date`
          const lotWisePoInfo = await manager.query(lotWisePoInfoQry)

          let getLotsInfoQry = `SELECT GROUP_CONCAT(DISTINCT(lot_code)) as lotNumbers FROM ${appSettings.warehouse_db} .reporting r  WHERE r.reporting_log_id > 0`
          if(req.fromDate != undefined){
            getLotsInfoQry += ` AND r.reporting_date BETWEEN '${req.fromDate}' AND '${req.toDate}'`
          }
          const getLotsInfo = await manager.query(getLotsInfoQry)
          const lotNumbersArray = getLotsInfo[0].lotNumbers.split(',');
          let formattedLotNumbers = lotNumbersArray.map(lot => `'${lot}'`).join(',');
    
        //   const lotWiseQtyInfoQry = `SELECT g.grn_date AS purhcaseDate,gi.plant_lot_number AS lotNumber,IF(gi.reweighment_quantity > 0, gi.reweighment_quantity,gi.quantity) AS honQty,
        //   gi.reweighment_count AS COUNT,poi.operation,poi.issued_quantity,poi.input_grade,poi.physical_quantity,SUM(poi.physical_quantity) AS 
        //   hlQty,SUM(pov.physical_quantity) AS peelingQty,SUM(pos.physical_quantity) AS soakingInQty,pos.product,SUM(pos.issued_quantity) AS soakOutQty 
        //   FROM alpha_dev_rm_procurement .grn_items gi
        //   LEFT JOIN alpha_dev_rm_procurement .grn g ON g.grn_id = gi.grn_id
        //   LEFT JOIN alpha_dev_production .production_inventory poi ON poi.lot_number = gi.plant_lot_number AND poi.operation = '${OperationTypeEnum.BE_HEADING}'
        //   LEFT JOIN alpha_dev_production .production_inventory pov ON pov.lot_number = gi.plant_lot_number AND pov.operation = '${OperationTypeEnum.VALUE_ADDITION}'
        //   LEFT JOIN alpha_dev_production .production_inventory pos ON pos.lot_number = gi.plant_lot_number AND pos.operation = '${OperationTypeEnum.SOAKING}'
        //   WHERE gi.plant_lot_number = '${req.lotNumber}'
        //   GROUP BY pos.product`
        //   const lotWiseQtyInfo = await manager.query(lotWiseQtyInfoQry)
    
        const grnInfoQry = `SELECT IF(gi.reweighment_quantity > 0, sum(gi.reweighment_quantity ),sum(gi.quantity ))  AS honQty, SUM(gid.quantity) as defectQty FROM ${appSettings.rm_procure_db} .grn_items gi LEFT JOIN ${appSettings.rm_procure_db} .grn g ON g.grn_id = gi.grn_id LEFT JOIN ${appSettings.rm_procure_db} .grn_item_defects gid ON gid.grn_item_id = gi.grn_item_id
        WHERE gi.plant_lot_number IN (${formattedLotNumbers})`
        const grnInfo = await manager.query(grnInfoQry)
        // const grnInfoMap = new Map<string,any>()
        // for(const rec of grnInfo){
        //     if(!(grnInfoMap.has(rec.lotNumber))){
        //         grnInfoMap.set(rec.lotNumber,rec)
        //     }
        // }
    
        const hlQtyInfoQry = ` SELECT SUM(physical_quantity) AS hlQty FROM  ${appSettings.production_db} .production_inventory poi  WHERE  poi.lot_number IN (${formattedLotNumbers}) AND operation = '${OperationTypeEnum.BE_HEADING}'`
        const hlQtyInfo = await manager.query(hlQtyInfoQry)
        // const hlQtyInfoMap = new Map<string,any>()
        // for(const rec of hlQtyInfo){
        //     if(!(hlQtyInfoMap.has(rec.lotNumber))){
        //         hlQtyInfoMap.set(rec.lotNumber,rec)
        //     }
        // }
    
        const soakQtyInfoQry = `SELECT (SUM(physical_quantity)+SUM(wip_quantity)) AS soakingInQty,pos.product,SUM(pos.issued_quantity) AS soakOutQty,pos.lot_number as lotNumber FROM ${appSettings.production_db} .production_inventory pos  WHERE pos.lot_number IN (${formattedLotNumbers}) AND  operation = '${OperationTypeEnum.SOAKING}' GROUP BY pos.product`
        
        const soakQtyInfo = await manager.query(soakQtyInfoQry)
        // const soakQtyInfoMap = new Map<string,any>()
        // for(const rec of soakQtyInfo){
        //     if(!(soakQtyInfoMap.has(rec.lotNumber))){
        //         soakQtyInfoMap.set(rec.lotNumber,rec)
        //     }
        // }

    
        const peelingQtyInfoQry = `SELECT SUM(physical_quantity) AS peelingQty FROM ${appSettings.production_db} .production_inventory pov WHERE pov.lot_number IN (${formattedLotNumbers}) AND operation = '${OperationTypeEnum.VALUE_ADDITION}'`
    
        const peelingQtyInfo = await manager.query(peelingQtyInfoQry)
        // const peelingQtyInfoMap = new Map<string,any>()
        // for(const rec of peelingQtyInfo){
        //     if(!(peelingQtyInfoMap.has(rec.lotNumber))){
        //         peelingQtyInfoMap.set(rec.lotNumber,rec)
        //     }
        // }

        const lotWiseQtyInfo = []
        if(soakQtyInfo.length > 0){
            for(const rec of soakQtyInfo){
                lotWiseQtyInfo.push(new lotWiseQtyInfoModel(grnInfo[0].purhcaseDate,grnInfo[0].lotNumber,Number(grnInfo[0].honQty) + Number(grnInfo[0].defectQty),null,Number(hlQtyInfo[0].hlQty),Number(peelingQtyInfo[0].peelingQty),Number(rec.soakingInQty),Number(rec.soakOutQty),rec.product))
            }
        }else{
            lotWiseQtyInfo.push(new lotWiseQtyInfoModel(grnInfo[0].purhcaseDate,grnInfo[0].lotNumber,Number(grnInfo[0].honQty),grnInfo[0].count,Number(hlQtyInfo[0].hlQty),Number(peelingQtyInfo[0].peelingQty),null,null,null))
        }
          const info = new LotWiseInfoModel(lotWisePoInfo,lotWiseQtyInfo)
    
          return new LotWiseInfoResponseModel(true,1,'Data retrieved',info)
    
        }catch(err){
          throw err
        }
      }
    
      async getAllLotNumbersDropdown():Promise<CommonResponse>{
        const manager = getManager()
        try{
            const lotNumberQry = `SELECT lot_code as lotNumber FROM ${appSettings.warehouse_db} .reporting GROUP BY lot_code`
            const lotNumber = await manager.query(lotNumberQry) 
            if(lotNumber.length > 0){
                return new CommonResponse(true,1,'Data retrieved',lotNumber)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getSPSAStockValuationReport(req:SPSAStockValuationReq):Promise<CommonResponse>{
        try{
            const manager = getManager()
            let stockInfoQry = `SELECT lot_no as lotNumber,stock_type as stockType,inv.po_number as customerPo,sku.short_code as productSKU,pm.packing_method_name as packStyle,s.package_type as packageType,s.tare_weight as tareWeight,(s.quantity * s.total_cartons) as quantity,sp.price,(s.quantity * s.total_cartons) * sp.price as amount,s.total_cartons as packages
            FROM ${appSettings.warehouse_db} .stock s 
            LEFT JOIN ${appSettings.sales_db} .so_invoice_details inv ON inv.sale_order_id = s.sale_order_id
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id
            LEFT JOIN ${appSettings.masters_db} .packing_methods pm ON pm.packing_method_id = s.pack_style_id
            LEFT JOIN ${appSettings.rm_procure_db} .sku_price sp ON sp.sku_id = s.varient_id
            WHERE s.status = '${FgStockStatus.StockIn}'`
            if(req.skuCodeId != undefined){
                stockInfoQry += ` s.varient_id = ${req.skuCodeId}`
            }
            if(req.saleOrderId != undefined){
                stockInfoQry += ` and s.sale_order_id = ${req.saleOrderId}`
            }
            if(req.stockType != undefined){
                stockInfoQry += ` and s.stock_type = '${req.stockType}'`
            }
            if(req.lotNumber != undefined){
                stockInfoQry += ` and s.lot_no = '${req.lotNumber}'`
            }
            const stockInfo = await manager.query(stockInfoQry) 
            if(stockInfo.length > 0){
                return new CommonResponse(true,1,'Data retrieved',stockInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }

        }catch(err){
            throw err
        }
    }

    async getProductSkuDropdown():Promise<CommonResponse>{
        try{
            const manager = getManager()
            const productSKUQry = `SELECT short_code as productSKU,sku_code_id as skuCodeId FROM ${appSettings.warehouse_db} .stock s 
            LEFT JOIN ${appSettings.masters_db} .sku_codes sku ON sku.sku_code_id = s.varient_id 
            WHERE s.status = '${FgStockStatus.StockIn}' GROUP BY sku_code_id`
            const productSKUInfo = await manager.query(productSKUQry) 
            if(productSKUInfo.length > 0){
                return new CommonResponse(true,1,'Data retrieved',productSKUInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getCustomerPoDropdown():Promise<CommonResponse>{
        try{
            const manager = getManager()
            const productSKUQry = `SELECT po_number as customerPo,s.sale_order_id  as saleOrderId FROM ${appSettings.warehouse_db} .stock s 
            LEFT JOIN ${appSettings.sales_db} .so_invoice_details inv ON inv.sale_order_id = s.sale_order_id
            WHERE s.status = '${FgStockStatus.StockIn}' GROUP BY inv.sale_order_id`
            const productSKUInfo = await manager.query(productSKUQry) 
            if(productSKUInfo.length > 0){
                return new CommonResponse(true,1,'Data retrieved',productSKUInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async getLotNumberDropdown():Promise<CommonResponse>{
        try{
            const manager = getManager()
            const productSKUQry = `SELECT lot_no as lotNumber FROM ${appSettings.warehouse_db} .stock s 
            WHERE s.status = '${FgStockStatus.StockIn}' GROUP BY lot_no`
            const productSKUInfo = await manager.query(productSKUQry) 
            if(productSKUInfo.length > 0){
                return new CommonResponse(true,1,'Data retrieved',productSKUInfo)
            }else{
                return new CommonResponse(false,0,'No data found')
            }
        }catch(err){
            throw err
        }
    }

    async createBaleAmtInfo(req:BaleReq):Promise<CommonResponse>{        
        try{
            let totalAmt = 0
            for(const item of req.baleItemsInfo){
                totalAmt += Number(item.baleQty) * Number(item.inwardPrice)
            }
            const entityObj = new BaleAmtInfo()
            entityObj.baleId = req.baleId
            entityObj.baleQty = req.actualBaleQty
            entityObj.amount = totalAmt
            entityObj.price = Number(totalAmt)/Number(req.actualBaleQty)
            entityObj.createdUser = req.createdUser

            const save = await this.baleAmtInfoRepo.save(entityObj)
            if(save){
                return new CommonResponse(true,1,'Data saved successfully',save)
            }else{
                return new CommonResponse(false,0,'Something went wrong')
            }
        }catch(err){
            throw err
        }
    }

    

}
